webpackJsonp(["main"],{

/***/ "./enso_cms/static/enso-cms/css/main.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/ApAssetBlock.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("./enso_cms/static/enso-cms/js/components/ApAssetBlock.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ApAssetBlock = function (_React$Component) {
  _inherits(ApAssetBlock, _React$Component);

  function ApAssetBlock(props) {
    _classCallCheck(this, ApAssetBlock);

    var _this = _possibleConstructorReturn(this, (ApAssetBlock.__proto__ || Object.getPrototypeOf(ApAssetBlock)).call(this, props));

    _this.loadData = _this.loadData.bind(_this);

    _this.state = {
      assetId: props.block.data.get("assetId"),
      dataLoaded: false,
      data: {}
    };

    _this.loadData();
    return _this;
  }

  _createClass(ApAssetBlock, [{
    key: "loadData",
    value: function () {
      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var resp, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch("/api/core/assets/" + this.state.assetId, {
                  credentials: "same-origin"
                });

              case 2:
                resp = _context.sent;
                _context.next = 5;
                return resp.json();

              case 5:
                data = _context.sent;

                this.setState({
                  dataLoaded: true,
                  data: data
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadData() {
        return _ref.apply(this, arguments);
      }

      return loadData;
    }()
  }, {
    key: "render",
    value: function render() {
      if (!this.state.dataLoaded) {
        return null;
      }

      return _react2.default.createElement(
        "div",
        {
          className: "wysiwyg-ap-asset-block",
          "data-asset_id": this.state.assetId
        },
        _react2.default.createElement("img", { src: this.state.data.cms_thumbnail_url }),
        _react2.default.createElement(
          "div",
          { className: "details" },
          _react2.default.createElement(
            "h2",
            null,
            this.state.data.title
          ),
          _react2.default.createElement(
            "h3",
            null,
            this.state.data.filename
          )
        )
      );
    }
  }]);

  return ApAssetBlock;
}(_react2.default.Component);

exports.default = ApAssetBlock;

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/ApAssetBlock.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/ApEditor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditorMode = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDraftWysiwyg = __webpack_require__("./node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.js");

var _draftUtils = __webpack_require__("./enso_cms/static/enso-cms/js/utils/draftUtils.js");

var _EmbedAssetButton = __webpack_require__("./enso_cms/static/enso-cms/js/components/EmbedAssetButton.js");

var _EmbedAssetButton2 = _interopRequireDefault(_EmbedAssetButton);

var _PreviewButton = __webpack_require__("./enso_cms/static/enso-cms/js/components/PreviewButton.js");

var _PreviewButton2 = _interopRequireDefault(_PreviewButton);

var _ApAssetBlock = __webpack_require__("./enso_cms/static/enso-cms/js/components/ApAssetBlock.js");

var _ApAssetBlock2 = _interopRequireDefault(_ApAssetBlock);

__webpack_require__("./node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css");

__webpack_require__("./enso_cms/static/enso-cms/js/components/ApEditor.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditorMode = exports.EditorMode = {
  ITALIC: "ITALIC",
  SIMPLE: "SIMPLE",
  ADVANCED: "ADVANCED"
};

var ITALIC_TOOLBAR_OPTIONS = {
  options: ["inline"],
  inline: {
    inDropdown: false,
    className: undefined,
    options: ["italic"]
  }
};

var SIMPLE_TOOLBAR_OPTIONS = {
  options: ["inline", "list"],
  inline: {
    inDropdown: false,
    className: undefined,
    options: ["bold", "italic", "superscript", "subscript"]
  },
  list: {
    inDropdown: false,
    className: undefined,
    options: ["unordered", "ordered"]
  }
};

var ADVANCED_TOOLBAR_OPTIONS = {
  options: ["blockType", "inline", "list"],
  inline: {
    inDropdown: false,
    className: undefined,
    options: ["bold", "italic", "superscript", "subscript"]
  },
  blockType: {
    inDropdown: true,
    options: ["Normal", "H2", "H4", "Blockquote"],
    className: undefined,
    dropdownClassName: undefined
  },
  list: {
    inDropdown: false,
    className: undefined,
    options: ["unordered", "ordered"]
  }
};

var ADVANCED_CUSTOM_TOOLBAR_BUTTONS = [_react2.default.createElement(_EmbedAssetButton2.default, null), _react2.default.createElement(_PreviewButton2.default, null)];

function assetEmbedRenderer(contentBlock) {
  if (contentBlock.getType() == "atomic") {
    if (contentBlock.data.get("type") == "ap-asset") {
      return {
        component: _ApAssetBlock2.default,
        editable: false
      };
    }
  }
}

var ApEditor = function (_React$Component) {
  _inherits(ApEditor, _React$Component);

  function ApEditor(props) {
    _classCallCheck(this, ApEditor);

    var _this = _possibleConstructorReturn(this, (ApEditor.__proto__ || Object.getPrototypeOf(ApEditor)).call(this, props));

    _this.updateNativeInput = _this.updateNativeInput.bind(_this);
    _this.onFormSubmit = _this.onFormSubmit.bind(_this);
    _this.onChange = _this.onChange.bind(_this);

    _this.state = {
      editorState: (0, _draftUtils.nativeInputToEditorState)(props.nativeInput)
    };

    // set up event handler for when form is submitted
    (0, _jquery2.default)(_this.props.nativeInput).parents("form").on("submit", _this.onFormSubmit);
    return _this;
  }

  _createClass(ApEditor, [{
    key: "updateNativeInput",
    value: function updateNativeInput() {
      var contentState = this.state.editorState.getCurrentContent();
      var html;
      if (contentState.getPlainText() === "") {
        html = "";
      } else {
        html = (0, _draftUtils.extendedConvertToHTML)(contentState);
      }
      this.props.nativeInput.value = html;
    }
  }, {
    key: "onChange",
    value: function onChange(editorState) {
      this.setState({ editorState: editorState });
    }
  }, {
    key: "onFormSubmit",
    value: function onFormSubmit() {
      this.updateNativeInput();
    }
  }, {
    key: "render",
    value: function render() {
      var toolbarOptions = {},
          toolbarCustomButtons = [];
      switch (this.props.mode) {
        case EditorMode.ITALIC:
          toolbarOptions = ITALIC_TOOLBAR_OPTIONS;
          break;
        case EditorMode.SIMPLE:
          toolbarOptions = SIMPLE_TOOLBAR_OPTIONS;
          break;
        case EditorMode.ADVANCED:
          toolbarOptions = ADVANCED_TOOLBAR_OPTIONS;
          toolbarCustomButtons = ADVANCED_CUSTOM_TOOLBAR_BUTTONS;
          break;
      }

      return _react2.default.createElement(
        "div",
        { className: "ap-editor__container" },
        _react2.default.createElement(_reactDraftWysiwyg.Editor, {
          stripPastedStyles: true,
          toolbar: toolbarOptions,
          toolbarCustomButtons: toolbarCustomButtons,
          editorState: this.state.editorState,
          onEditorStateChange: this.onChange,
          blockRendererFn: assetEmbedRenderer
        })
      );
    }
  }]);

  return ApEditor;
}(_react2.default.Component);

exports.default = ApEditor;

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/ApEditor.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/ApModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__("./node_modules/react-modal/lib/index.js");

var _reactModal2 = _interopRequireDefault(_reactModal);

__webpack_require__("./enso_cms/static/enso-cms/js/components/ApModal.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ApModal = function (_React$Component) {
  _inherits(ApModal, _React$Component);

  function ApModal(props) {
    _classCallCheck(this, ApModal);

    var _this = _possibleConstructorReturn(this, (ApModal.__proto__ || Object.getPrototypeOf(ApModal)).call(this, props));

    _this.state = {
      modalBodyMaxHeight: window.innerHeight - 100
    };
    return _this;
  }

  _createClass(ApModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      (0, _jquery2.default)(window).on("resize", function () {
        _this2.setState({
          modalBodyMaxHeight: window.innerHeight - 100
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _reactModal2.default,
        {
          isOpen: this.props.isOpen,
          contentLabel: this.props.title,
          className: "enso-modal enso-modal__react",
          overlayClassName: "enso-modal-mask"
        },
        _react2.default.createElement(
          "a",
          { className: "close-btn", onClick: this.props.onRequestClose },
          "\xD7"
        ),
        _react2.default.createElement(
          "h1",
          null,
          this.props.title
        ),
        _react2.default.createElement(
          "div",
          {
            className: "modal-body modal-body__react",
            style: { maxHeight: this.state.modalBodyMaxHeight }
          },
          this.props.children
        )
      );
    }
  }]);

  return ApModal;
}(_react2.default.Component);

exports.default = ApModal;


ApModal.propTypes = {
  isOpen: _react2.default.PropTypes.bool.isRequired,
  title: _react2.default.PropTypes.string.isRequired,
  onRequestClose: _react2.default.PropTypes.func
};

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/ApModal.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/EmbedAssetButton.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _ApModal = __webpack_require__("./enso_cms/static/enso-cms/js/components/ApModal.js");

var _ApModal2 = _interopRequireDefault(_ApModal);

var _draftUtils = __webpack_require__("./enso_cms/static/enso-cms/js/utils/draftUtils.js");

__webpack_require__("./enso_cms/static/enso-cms/js/components/EmbedAssetButton.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function EmbedAssetTable(props) {
  return _react2.default.createElement(
    "table",
    { className: "embed-asset-button__table" },
    _react2.default.createElement(
      "thead",
      null,
      _react2.default.createElement(
        "tr",
        null,
        _react2.default.createElement(
          "th",
          null,
          "Thumbnail"
        ),
        _react2.default.createElement(
          "th",
          null,
          "Title"
        ),
        _react2.default.createElement(
          "th",
          null,
          "Embed"
        )
      )
    ),
    _react2.default.createElement(
      "tbody",
      null,
      props.assetData.map(function (asset) {
        return _react2.default.createElement(
          "tr",
          { key: asset.id },
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement("img", { src: asset.cms_thumbnail_url })
          ),
          _react2.default.createElement(
            "td",
            null,
            asset.title
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "button",
              {
                onClick: function onClick() {
                  props.onEmbedClick(asset.id);
                }
              },
              "Embed"
            )
          )
        );
      })
    )
  );
}

var EmbedAssetButton = function (_React$Component) {
  _inherits(EmbedAssetButton, _React$Component);

  function EmbedAssetButton(props) {
    _classCallCheck(this, EmbedAssetButton);

    var _this = _possibleConstructorReturn(this, (EmbedAssetButton.__proto__ || Object.getPrototypeOf(EmbedAssetButton)).call(this, props));

    _this.isButtonEnabled = _this.isButtonEnabled.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.onButtonClick = _this.onButtonClick.bind(_this);
    _this.onEmbedClick = _this.onEmbedClick.bind(_this);
    _this.state = {
      isModalOpen: false,
      data: []
    };
    _this.loadData();
    return _this;
  }

  _createClass(EmbedAssetButton, [{
    key: "loadData",
    value: function () {
      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var apObjectId, resp, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apObjectId = window.initial_js_data.ap_object_pk; // global

                _context.next = 3;
                return fetch("/api/core/assets/?ap_object_id=" + apObjectId, {
                  credentials: "same-origin"
                });

              case 3:
                resp = _context.sent;
                _context.next = 6;
                return resp.json();

              case 6:
                data = _context.sent;

                this.setState({ data: data.results });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadData() {
        return _ref.apply(this, arguments);
      }

      return loadData;
    }()
  }, {
    key: "onButtonClick",
    value: function onButtonClick(evt) {
      evt.preventDefault();
      if (this.isButtonEnabled()) {
        this.loadData();
        this.setState({ isModalOpen: true });
      }
    }
  }, {
    key: "onEmbedClick",
    value: function onEmbedClick(assetId) {
      var editorState = this.props.editorState;

      var newEditorState = (0, _draftUtils.replaceCurrentBlockWithAtomicBlock)(editorState, {
        type: "ap-asset",
        assetId: assetId
      });
      this.props.onChange(newEditorState);
      this.setState({ isModalOpen: false });
    }
  }, {
    key: "isButtonEnabled",
    value: function isButtonEnabled() {
      var editorState = this.props.editorState;

      var selectionState = editorState.getSelection();
      return (0, _draftUtils.isCurrentContentBlockBlank)(editorState) && selectionState.isCollapsed();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        "div",
        { className: "embed-wrapper" },
        _react2.default.createElement(
          "div",
          { className: "rdw-option-wrapper" },
          _react2.default.createElement("a", {
            className: "embed-asset-button__button",
            onClick: this.onButtonClick,
            disabled: !this.isButtonEnabled()
          }),
          _react2.default.createElement(
            _ApModal2.default,
            {
              isOpen: this.state.isModalOpen,
              title: "Embed Asset",
              onRequestClose: function onRequestClose() {
                return _this2.setState({ isModalOpen: false });
              }
            },
            _react2.default.createElement(EmbedAssetTable, {
              assetData: this.state.data,
              onEmbedClick: this.onEmbedClick
            })
          )
        )
      );
    }
  }]);

  return EmbedAssetButton;
}(_react2.default.Component);

exports.default = EmbedAssetButton;

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/EmbedAssetButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/PreviewButton.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _immutable = __webpack_require__("./node_modules/immutable/dist/immutable.js");

var Immutable = _interopRequireWildcard(_immutable);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactSpin = __webpack_require__("./node_modules/react-spin/lib/main.js");

var _reactSpin2 = _interopRequireDefault(_reactSpin);

var _ApModal = __webpack_require__("./enso_cms/static/enso-cms/js/components/ApModal.js");

var _ApModal2 = _interopRequireDefault(_ApModal);

var _VerticalStackContainer = __webpack_require__("./enso_cms/static/enso-cms/js/components/gazelle/VerticalStackContainer.js");

var _VerticalStackContainer2 = _interopRequireDefault(_VerticalStackContainer);

var _gazelle = __webpack_require__("./enso_cms/static/enso-cms/js/utils/gazelle.js");

var _draftUtils = __webpack_require__("./enso_cms/static/enso-cms/js/utils/draftUtils.js");

__webpack_require__("./enso_cms/static/enso-cms/js/components/PreviewButton.scss");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PreviewButton = function (_React$Component) {
  _inherits(PreviewButton, _React$Component);

  function PreviewButton(props) {
    _classCallCheck(this, PreviewButton);

    var _this = _possibleConstructorReturn(this, (PreviewButton.__proto__ || Object.getPrototypeOf(PreviewButton)).call(this, props));

    _this.state = {
      isLoading: false,
      isModalOpen: false,
      gazelleData: Immutable.List()
    };
    _this.onButtonClick = _this.onButtonClick.bind(_this);
    return _this;
  }

  _createClass(PreviewButton, [{
    key: "onButtonClick",
    value: function onButtonClick(evt) {
      var _this2 = this;

      evt.preventDefault();
      var currentHtml = (0, _draftUtils.extendedConvertToHTML)(this.props.editorState.getCurrentContent());
      var authorId = Number((0, _jquery2.default)("#id_author").val());
      if (authorId === 0) {
        authorId = null;
      }

      (0, _gazelle.fetchGazellePreviewData)({
        type: "blog_post",
        data: {
          title: (0, _jquery2.default)("#id_title").val(),
          author_id: authorId,
          body: currentHtml
        }
      }).then(function (gazelleData) {
        _this2.setState({
          gazelleData: gazelleData,
          isLoading: false
        });
      });

      this.setState({ isModalOpen: true, isLoading: true });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var modalBody = null;
      if (this.state.isLoading) {
        modalBody = _react2.default.createElement(_reactSpin2.default, null);
      } else {
        modalBody = _react2.default.createElement(_VerticalStackContainer2.default, { gazelleData: this.state.gazelleData });
      }
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "button",
          {
            onClick: this.onButtonClick,
            className: "btn wysiwyg-preview-btn"
          },
          "Preview"
        ),
        _react2.default.createElement(
          _ApModal2.default,
          {
            title: "Preview",
            isOpen: this.state.isModalOpen,
            onRequestClose: function onRequestClose() {
              return _this3.setState({ isModalOpen: false });
            }
          },
          _react2.default.createElement(
            "div",
            { style: { width: "320px" } },
            modalBody
          )
        )
      );
    }
  }]);

  return PreviewButton;
}(_react2.default.Component);

exports.default = PreviewButton;

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/PreviewButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/SummaryPreviewContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _immutable = __webpack_require__("./node_modules/immutable/dist/immutable.js");

var Immutable = _interopRequireWildcard(_immutable);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactSpin = __webpack_require__("./node_modules/react-spin/lib/main.js");

var _reactSpin2 = _interopRequireDefault(_reactSpin);

var _gazelle = __webpack_require__("./enso_cms/static/enso-cms/js/utils/gazelle.js");

var _ApModal = __webpack_require__("./enso_cms/static/enso-cms/js/components/ApModal.js");

var _ApModal2 = _interopRequireDefault(_ApModal);

var _VerticalStackContainer = __webpack_require__("./enso_cms/static/enso-cms/js/components/gazelle/VerticalStackContainer.js");

var _VerticalStackContainer2 = _interopRequireDefault(_VerticalStackContainer);

__webpack_require__("./enso_cms/static/enso-cms/js/components/SummaryPreviewContainer.scss");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SummaryPreviewContainer = function (_React$Component) {
  _inherits(SummaryPreviewContainer, _React$Component);

  function SummaryPreviewContainer(props) {
    _classCallCheck(this, SummaryPreviewContainer);

    var _this = _possibleConstructorReturn(this, (SummaryPreviewContainer.__proto__ || Object.getPrototypeOf(SummaryPreviewContainer)).call(this, props));

    _this.onButtonClick = _this.onButtonClick.bind(_this);
    _this.state = {
      isModalOpen: false,
      isLoading: false,
      gazelleData: Immutable.List()
    };
    return _this;
  }

  _createClass(SummaryPreviewContainer, [{
    key: "onButtonClick",
    value: function onButtonClick(evt) {
      var _this2 = this;

      evt.preventDefault();

      var body = {
        type: "summary",
        ap_object_id: window.initial_js_data.ap_object_pk,
        data: {}
      };

      // If on the summary update page, override what we can with the latest
      // field values
      if (window.location.pathname.includes("/summary/update/")) {
        this.props.updateNativeInputsFn();
        body.data = {
          description: (0, _jquery2.default)("#id_description").val(),
          production_info: (0, _jquery2.default)("#id_production_info").val(),
          overview_title: (0, _jquery2.default)("#id_overview_title").val(),
          overview_body: (0, _jquery2.default)("#id_overview_body").val()
        };
      }

      (0, _gazelle.fetchGazellePreviewData)(body).then(function (gazelleData) {
        _this2.setState({
          gazelleData: gazelleData,
          isLoading: false
        });
      });
      this.setState({ isModalOpen: true, isLoading: true });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var modalBody = null;
      if (this.state.isLoading) {
        modalBody = _react2.default.createElement(_reactSpin2.default, null);
      } else {
        modalBody = _react2.default.createElement(_VerticalStackContainer2.default, { gazelleData: this.state.gazelleData });
      }
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "a",
          { className: "summary-preview-btn btn", onClick: this.onButtonClick },
          "Summary Preview"
        ),
        _react2.default.createElement(
          _ApModal2.default,
          {
            title: "Summary Preview",
            isOpen: this.state.isModalOpen,
            onRequestClose: function onRequestClose() {
              return _this3.setState({ isModalOpen: false });
            }
          },
          _react2.default.createElement(
            "div",
            { style: { width: "320px" } },
            modalBody
          )
        )
      );
    }
  }]);

  return SummaryPreviewContainer;
}(_react2.default.Component);

exports.default = SummaryPreviewContainer;

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/SummaryPreviewContainer.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/gazelle/HtmlText.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = HtmlText;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _gazelle = __webpack_require__("./enso_cms/static/enso-cms/js/utils/gazelle.js");

__webpack_require__("./enso_cms/static/enso-cms/js/components/gazelle/HtmlText.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HtmlTextIframe = function (_React$Component) {
  _inherits(HtmlTextIframe, _React$Component);

  function HtmlTextIframe(props) {
    _classCallCheck(this, HtmlTextIframe);

    var _this = _possibleConstructorReturn(this, (HtmlTextIframe.__proto__ || Object.getPrototypeOf(HtmlTextIframe)).call(this, props));

    _this.state = {
      iframeHeight: 0
    };
    _this.onIframeLoad = _this.onIframeLoad.bind(_this);
    return _this;
  }

  _createClass(HtmlTextIframe, [{
    key: "onIframeLoad",
    value: function onIframeLoad(evt) {
      var iframeDocumentBody = evt.target.contentWindow.document.body;

      this.setState({ iframeHeight: iframeDocumentBody.scrollHeight });
    }
  }, {
    key: "render",
    value: function render() {
      var iframeSrc = "\n      <html>\n        <head>" + this.props.headHtml + "</head>\n        <body>" + this.props.bodyHtml + "</body>\n      </html>\n    ";
      return _react2.default.createElement("iframe", {
        className: "gazelle-preview__html-text-iframe",
        style: { height: this.state.iframeHeight },
        scrolling: "no",
        frameBorder: "0",
        srcDoc: iframeSrc,
        onLoad: this.onIframeLoad
      });
    }
  }]);

  return HtmlTextIframe;
}(_react2.default.Component);

function HtmlText(props) {
  var gazelleData = props.gazelleData,
      htmlTextData = props.htmlTextData;

  var attributes = htmlTextData.get("attributes");
  var htmlHeadData = (0, _gazelle.findRef)(gazelleData, attributes.get("head"));
  if (htmlHeadData == null) {
    return null;
  }

  return _react2.default.createElement(HtmlTextIframe, {
    headHtml: htmlHeadData.getIn(["attributes", "head-html"]),
    bodyHtml: attributes.get("body-html")
  });
}

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/gazelle/HtmlText.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/gazelle/InlineImage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InlineImage;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__("./node_modules/immutable/dist/immutable.js");

var _gazelle = __webpack_require__("./enso_cms/static/enso-cms/js/utils/gazelle.js");

__webpack_require__("./enso_cms/static/enso-cms/js/components/gazelle/InlineImage.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BASE_URL = "/media/files/";

function InlineImage(props) {
  var imageData = (0, _gazelle.findRef)(props.gazelleData, props.inlineImageData.getIn(["attributes", "image"], (0, _immutable.Map)()));
  if (imageData == null) {
    return null;
  }

  return _react2.default.createElement("img", {
    className: "gazelle-preview__inline-image",
    src: "" + BASE_URL + imageData.getIn(["attributes", "path"], "")
  });
}

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/gazelle/InlineImage.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/gazelle/PlayerPlaceholder.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PlayerPlaceholder;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("./enso_cms/static/enso-cms/js/components/gazelle/PlayerPlaceholder.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PlayerPlaceholder(props) {
  return _react2.default.createElement(
    "span",
    { className: "gazelle-preview__player-placeholder" },
    props.label
  );
}

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/gazelle/PlayerPlaceholder.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/gazelle/VerticalStackContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VerticalStackContainer;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__("./node_modules/immutable/dist/immutable.js");

var _gazelle = __webpack_require__("./enso_cms/static/enso-cms/js/utils/gazelle.js");

var _VerticalStackElement = __webpack_require__("./enso_cms/static/enso-cms/js/components/gazelle/VerticalStackElement.js");

var _VerticalStackElement2 = _interopRequireDefault(_VerticalStackElement);

__webpack_require__("./enso_cms/static/enso-cms/js/components/gazelle/VerticalStackContainer.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VerticalStackContainer(props) {
  var gazelleData = props.gazelleData;

  var verticalStackData = gazelleData.find(function (obj) {
    return obj.get("type") == "vertical-stack-container";
  });
  if (verticalStackData == null) {
    return _react2.default.createElement(
      "span",
      null,
      "Couldn't find a vertical stack"
    );
  }

  var verticalStackElements = [];
  verticalStackData.getIn(["attributes", "elements"], (0, _immutable.List)()).forEach(function (elementRef) {
    var obj = (0, _gazelle.findRef)(gazelleData, elementRef);
    if (obj != null) {
      verticalStackElements.push(obj);
    }
  });

  return _react2.default.createElement(
    "div",
    { className: "gazelle-preview__vertical-stack-container" },
    verticalStackElements.map(function (elem) {
      return _react2.default.createElement(_VerticalStackElement2.default, {
        key: elem.get("id"),
        gazelleData: gazelleData,
        verticalStackElementData: elem
      });
    })
  );
}

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/gazelle/VerticalStackContainer.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/components/gazelle/VerticalStackElement.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VerticalStackElement;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _gazelle = __webpack_require__("./enso_cms/static/enso-cms/js/utils/gazelle.js");

var _HtmlText = __webpack_require__("./enso_cms/static/enso-cms/js/components/gazelle/HtmlText.js");

var _HtmlText2 = _interopRequireDefault(_HtmlText);

var _InlineImage = __webpack_require__("./enso_cms/static/enso-cms/js/components/gazelle/InlineImage.js");

var _InlineImage2 = _interopRequireDefault(_InlineImage);

var _PlayerPlaceholder = __webpack_require__("./enso_cms/static/enso-cms/js/components/gazelle/PlayerPlaceholder.js");

var _PlayerPlaceholder2 = _interopRequireDefault(_PlayerPlaceholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HTML_TEXT = "html-text";

var INLINE_IMAGE = "inline-image";
var AUDIO_PLAYER = "audio-player";
var VIDEO_PLAYER = "video-player";

function VerticalStackElement(props) {
  var gazelleData = props.gazelleData,
      verticalStackElementData = props.verticalStackElementData;

  var attributes = verticalStackElementData.get("attributes");
  var contentData = (0, _gazelle.findRef)(gazelleData, attributes.get("content"));

  if (contentData == null) {
    return null;
  }

  var children = null;
  switch (contentData.get("type")) {
    case HTML_TEXT:
      children = _react2.default.createElement(_HtmlText2.default, { gazelleData: gazelleData, htmlTextData: contentData });
      break;
    case INLINE_IMAGE:
      children = _react2.default.createElement(_InlineImage2.default, { gazelleData: gazelleData, inlineImageData: contentData });
      break;
    case AUDIO_PLAYER:
      children = _react2.default.createElement(_PlayerPlaceholder2.default, { label: "Audio" });
      break;
    case VIDEO_PLAYER:
      children = _react2.default.createElement(_PlayerPlaceholder2.default, { label: "Video" });
      break;
  }

  return _react2.default.createElement(
    "div",
    {
      style: {
        paddingTop: attributes.get("top-padding"),
        paddingBottom: attributes.get("bottom-padding")
      }
    },
    children
  );
}

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/enso-html-cleanup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ensoPasteCleanup = exports.cleanHtml = undefined;

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__("./node_modules/underscore/underscore.js");

var _underscore2 = _interopRequireDefault(_underscore);

__webpack_require__("./enso_cms/static/enso-cms/js/enso-plugins.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WHITELIST_BLOCK_TAGS = ["p", "blockquote", "ul", "li", "h1", "h2", "h3", "h4"];
var WHITELIST_INLINE_TAGS = ["a", "p", "b", "strong", "em", "i", "br", "sub"];
var WHITELIST_TAGS = WHITELIST_BLOCK_TAGS.concat(WHITELIST_INLINE_TAGS);

/**
 * this decorator takes as its argument a function that takes a jQuery element and applies some manipuations on it.
 * The decorator takes care of converting the following types into jquery element:
 *  - a string containg html
 *  - an element of type Node (javascript native DOM node)
 *  - jQuery types remain unconvertor
 * Finally, after the funciont returns the data is converted back to the original type.
 * This way, when writing a manipulation function, you only need to deal with jQuery objects and the
 * decorator takes care of converting back and forth.
 *
 * @param func
 * @returns {Function}
 */
var HtmlTransformerDecorator = function HtmlTransformerDecorator(func) {
  return function (x) {
    var x = arguments[0];
    var extraArgs = Array.prototype.slice.call(arguments, 1);

    var STRING = "STRING";
    var DOM_ELEMENT = "DOM_ELEMENT";
    var DOM_FRAGMENT = "DOM_FRAGMENT";
    var JQUERY_ELEMENT = "JQUERY_ELEMENT";
    var JQUERY_FRAGMENT = "JQUERY_FRAGMENT";

    var dataFormat;
    if (typeof x === "string") {
      dataFormat = STRING;
    } else if (x instanceof Element) {
      dataFormat = DOM_ELEMENT;
    } else if (x instanceof DocumentFragment) {
      dataFormat = DOM_FRAGMENT;
    } else if (x instanceof jQuery) {
      if (x[0].parentNode instanceof DocumentFragment) {
        dataFormat = JQUERY_FRAGMENT;
      } else {
        dataFormat = JQUERY_ELEMENT;
      }
    }

    //todo: consider [jQuery] and [Node] as types
    var $e;
    if (dataFormat == "STRING") {
      $e = (0, _jquery2.default)("<wrapper>").append(x); //put in wrapper so there is a single root node. wrapper is removed on output
    } else if (dataFormat == DOM_ELEMENT || dataFormat == DOM_FRAGMENT) {
      $e = (0, _jquery2.default)(x);
    } else if (dataFormat == JQUERY_ELEMENT || dataFormat == JQUERY_FRAGMENT) {
      $e = x;
    }
    var args = [$e].concat(extraArgs);
    func.apply(this, args);

    switch (dataFormat) {
      case STRING:
        return $e.html(); //uses innerHTML, so the <wrapper> tag is removed
      case JQUERY_ELEMENT:
      case JQUERY_FRAGMENT:
        return $e;
      case DOM_ELEMENT:
      case DOM_FRAGMENT:
        return $e.get(0);
    }
  };
};

var _removeAttributesRecursive = HtmlTransformerDecorator(function ($e) {
  $e.removeAttributesRecursive();
});

var removeElementKeepContents = HtmlTransformerDecorator(function ($e) {
  var $new = $e.contents();
  (0, _jquery2.default)("<br>").appendTo($new);
  $e.replaceWith($new);
  return $e;
});

var cleanKeepWhiteListTags = HtmlTransformerDecorator(function ($e) {
  // todo: ability to specify tags... eg: severe, moderate, etc
  var e = $e.get(0);
  var view = this;
  var tag = e.tagName.toLowerCase();
  if (!_underscore2.default.contains(WHITELIST_TAGS, tag)) {
    $e = removeElementKeepContents($e);
  }
  $e.children().each(function (i, e) {
    cleanKeepWhiteListTags((0, _jquery2.default)(e));
  });
});

var clearInlineFormatting = HtmlTransformerDecorator(function ($e) {
  var view = this;

  var _clearInlineFormatting = function _clearInlineFormatting(e) {
    if (!_underscore2.default.contains(WHITELIST_BLOCK_TAGS, e.tagName.toLowerCase())) {
      removeElementKeepContents(e);
      return true;
    } else {
      return false;
    }
  };

  var elementsRemoved = false;
  while (elementsRemoved) {
    $e.children().each(function (i, e) {
      elementsRemoved = _clearInlineFormatting(e);
    });
  }
  $e.children().each(function (i, e) {
    elementsRemoved = clearInlineFormatting(e);
  });

  _clearInlineFormatting($e.get(0));
});

var _removeEmptyNodes = HtmlTransformerDecorator(function ($e) {
  $e.removeEmptyNodes();
});

var cleanHtml = exports.cleanHtml = HtmlTransformerDecorator(function ($e, userOptions) {
  var userOptions = typeof userOptions !== "undefined" ? userOptions : {};

  var options = {
    keepOnlyWhitelistTags: true,
    removeAttributesRecursive: true,
    removeInlineTags: true,
    removeEmptyNodes: true
  };

  //TODO: decorator needs to support indefinite length arguments

  _underscore2.default.extend(options, userOptions);

  console.log(options);

  serverSideHtmlTidy($e);

  $e.children().each(function (i, e) {
    console.log(e);
    _removeAttributesRecursive((0, _jquery2.default)(e));
  });

  var functions = {
    keepOnlyWhitelistTags: function keepOnlyWhitelistTags() {
      $e.children().each(function (i, e) {
        cleanKeepWhiteListTags(e);
      });
    },
    removeAttributesRecursive: function removeAttributesRecursive() {
      $e.children().each(function (i, e) {
        _removeAttributesRecursive((0, _jquery2.default)(e));
      });
    },
    removeInlineTags: function removeInlineTags() {
      $e.children().each(function (i, e) {
        clearInlineFormatting(e);
      });
    },
    removeEmptyNodes: function removeEmptyNodes() {
      _removeEmptyNodes($e);
    }
  };

  _jquery2.default.each(options, function (option, enabled) {
    console.log(option);
    if (enabled) {
      functions[option]();
    }
  });
});

var ensoPasteCleanup = exports.ensoPasteCleanup = HtmlTransformerDecorator(function ($e) {
  $e.removeClassesRecursive();
  return cleanHtml($e, { removeInlineTags: false });
});

var serverSideHtmlTidy = HtmlTransformerDecorator(function ($e) {
  // completely override Redactor's crappy regex paste cleanup and do it server side.
  var response = _jquery2.default.ajax({
    //            async: false,  // just so we don't have to deal with callbacks!
    url: "/api/cms/html-tidy/", //local htmltidy service
    data: { html: $e.getOuterHtml() },
    dataType: "json",
    method: "post"
  });
  $e.replaceWith(response.tidy_html);
});

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/enso-plugins.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openFormModal = openFormModal;
exports.getMimeObject = getMimeObject;
exports.stripExtension = stripExtension;
exports.crossDomainAjax = crossDomainAjax;

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _wysiwyg = __webpack_require__("./enso_cms/static/enso-cms/js/wysiwyg.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/******************************************************************************
 **  Enso Modal
 ******************************************************************************/
(function ($) {
  $.fn.ensoModal = function (action, preRenderFunction) {
    var destroy = function destroy() {
      $(".enso-modal").remove();
      $(".enso-modal-mask").remove();
    };

    if (typeof preRenderFunction === "undefined") {
      preRenderFunction = function preRenderFunction() {};
    }

    if (typeof action === "undefined" || action == "open") {
      // destroy any currently open modals

      destroy();

      var $content = $(this);

      var $h1 = $content.find("h1");

      var $body = $("body");
      var windowWidth = $(window).width();
      var windowHeight = $(window).height();
      var documentHeight = $(document).height();
      var documentWidth = $(document).width();
      var windowCentreX = windowWidth / 2;
      var scrollTop = $(window).scrollTop();
      var windowCentreY = scrollTop + windowHeight / 2;

      //do something with scrollTop!

      // get the width of the content we are going to insert into the modal
      // we must do this by drawing to the screen first, but we do it in a hidden div
      var $hiddenPreview = $("<div>").css({
        position: "absolute",
        //'left': -10000,   //draw it off screen
        left: 0, //draw it off screen
        top: 0
      }).attr("id", "hidden-preview").appendTo("body");
      $content.prependTo($hiddenPreview);
      preRenderFunction();
      var modalWidth = $hiddenPreview.width();
      var modalHeight = $hiddenPreview.width();

      var modalLeft = windowCentreX - modalWidth / 2;
      var modalTop = windowCentreY - modalHeight / 2;
      if (modalTop < 0) {
        modalTop = 20;
      }

      var $modalMask = $("<div></div>");
      $modalMask.addClass("enso-modal-mask").css({
        position: "fixed",
        "z-index": 100,
        width: "100%",
        height: "100%",
        left: 0,
        top: 0
      });

      var $modal = $("<div></div>");
      $modal.addClass("enso-modal").css({
        width: modalWidth,
        height: modalHeight,
        top: modalTop,
        left: modalLeft,
        position: "absolute",
        "z-index": 101
        //                     'overflow-y': 'auto'
      });

      var $closeButton = $('<a class="close-btn">×</a>');

      $closeButton.on("click", destroy);

      $content.prependTo($modal);
      $content.wrap('<div class="modal-body"></div>');
      $h1.prependTo($modal);
      $closeButton.prependTo($modal);

      $modalMask.appendTo($body);
      $modal.appendTo($body);
      return this;
    } else if (action === "destroy") {
      destroy();
    }
  };

  /* useful for when you want only the first click of a form to be sent */
  $.fn.preventDoubleClick = function () {
    $(this).on("click", function (e) {
      if ($(this).data("clicked") == true) {
        e.preventDefault();
        e.stopPropagation();
        console.log('double click prevented using data("clicked")');
      } else {
        $(this).data("clicked", true);
      }
    });
    $(this).on("dblclick", function (e) {
      console.log("double click prevented using dblclick event");
      e.preventDefault();
      e.stopPropagation();
    });
  };

  $.fn.getOuterHtml = function () {
    var $wrapper = $("<wrapper>");
    this.each(function (i, e) {
      $wrapper.append($(e).clone());
    });
    return $wrapper.html();
  };

  $.fn.isEmptyNode = function () {
    var empty;
    var $e = $(this.get(0));
    if ($e.text().trim() == "") {
      return true;
    } else {
      return false;
    }
  };

  $.fn.removeEmptyNodes = function () {
    this.children().each(function (i, e) {
      var $e = $(e);
      if ($e.text().trim() == "") {
        $e.remove();
      } else {
        $e.removeEmptyNodes();
      }
    });
  };

  $.fn.removeClassesRecursive = function () {
    this.removeAttr("class");
    this.children().each(function (i, e) {
      $(e).removeClassesRecursive();
    });
  };

  $.fn.removeAttributesRecursive = function () {
    var $e = this;

    var attributes = $e.get(0).attributes;

    for (var i = 0; i < attributes.length; i++) {
      var attribute = attributes[i];
      if (attribute.specified) {
        $e.removeAttr(attribute.name);
      }
    }
    $e.children().each(function (i, e) {
      $(e).removeAttributesRecursive();
    });
  };
})(jQuery);

function openFormModal(jquery_ajax_args, formClosedCallback, formInitializedCallback) {
  _jquery2.default.ajax(jquery_ajax_args).done(function (html) {
    html = _jquery2.default.trim(html); // trim whitespace to make it jquery1.9 compatible: http://bugs.jquery.com/ticket/13223
    var $relatedFormWrapper = (0, _jquery2.default)("<div>" + html + "</div>");
    $relatedFormWrapper.ensoModal();

    var $relatedForm = $relatedFormWrapper.find("form");

    if (typeof formInitializedCallback !== "undefined") {
      formInitializedCallback($relatedFormWrapper);
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = $relatedFormWrapper.find("[js-ap-editor]")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var textInput = _step.value;

        (0, _wysiwyg.initializeApEditor)(textInput);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    $relatedForm.ajaxForm(function (response) {
      $relatedFormWrapper.ensoModal("destroy");
      formClosedCallback(response);
    });
  });
}

/******************************************************************************
 ** Tab Sets
 ******************************************************************************/

(function ($) {
  $.fn.tabSet = function () {
    // items in tab sets must be rendered with the following structure:
    //      <div class="tab-section"><h2>***<h2><div class="tab-content">***</div><div>
    // if JS is turned off, the content is rendered as separate sections rather than as tabs
    // this plugin makes this content tabbable

    return this.each(function (i, e) {
      var $tabSet = $(e);
      var $sections = $tabSet.find(".tab-section");
      var $tabs = $tabSet.find(".sub-nav > li");
      var $activeTab = $tabs.filter(".active");
      var $activeSection = getSection($activeTab);
      $activeSection.addClass("active");
      $sections.find("h2").remove();
      $sections.not(".active").hide();

      $tabs.on("click", function (e) {
        e.preventDefault();
        var $tab = $(this);
        $tabs.removeClass("active");
        $tab.addClass("active");
        var $section = getSection($tab);
        $sections.removeClass("active").hide();
        $section.addClass("active");
        $section.show();
      });

      /**
             * @param tab  (can be the name of a section or a tab JQ object)
             */
      function getSection(tab) {
        if (typeof tab === "string") {
          var name = tab;
        } else {
          var name = getSectionName(tab);
        }
        return $tabSet.find('[name="' + name + '"]').parent();
      }

      function getSectionName($tab) {
        return $tab.find("a").attr("href").substr(1);
      }
    });
  };
})(jQuery);

/******************************************************************************
 ** Tabbed Fieldsets
 ******************************************************************************/
(function ($) {
  $.fn.tabbedFieldsets = function () {
    return this.each(function (i, e) {
      var $fieldsets = $(e).find("fieldset");
      var $firstFieldset = $fieldsets[0];
      var $tabs = $('<ul class="sub-nav">');
      $tabs.addClass("fieldset-tabs");
      $tabs.insertBefore($firstFieldset);
      $fieldsets.each(function (i, e) {
        var $legend = $(this).find("legend");
        var $li = $("<li>").attr("data-fieldset-index", i).on("click", function (e) {
          e.preventDefault();
          var fieldsetIndex = $(this).data("fieldset-index");
          console.log(fieldsetIndex);
          $fieldsets.hide();
          $($fieldsets[fieldsetIndex]).show();
          $lis.removeClass("active");
          $(this).addClass("active");
        });
        $('<a href=""></a>').text($legend.text()).prependTo($li);
        $li.appendTo($tabs);
        $tabs.find("li:first").addClass("active");

        $(this).find("legend").hide();
      });

      var $lis = $tabs.find("li");
      for (var i = 1; i < $fieldsets.length; i++) {
        $($fieldsets[i]).hide();
        //                $fieldsets[i].remove();
      }
    });
  };
})(jQuery);

/******************************************************************************
 ** Vertical Drop Down
 ******************************************************************************/

(function ($) {
  $.fn.ensoVerticalDropdown = function () {
    return this.each(function (i, e) {
      $(e).on("mousemove", function () {
        $(this).find("ul").show();
      }).on("mouseleave", function () {
        $(this).find("ul").hide();
      }).on("mouseleave", "ul", function () {
        $(this).hide();
      });
    });
  };
})(jQuery);

/******************************************************************************
 **  Other
 ******************************************************************************/
function getMimeObject(mimeTypeStr) {
  var a = mimeTypeStr.split("/");
  return {
    mediaType: a[0],
    subType: a[1]
  };
}

function stripExtension(s) {
  return s.replace(/\.[^/.]+$/, "");
}

/******************************************************************************
 **  DOM Manipulation
 ******************************************************************************/

(function ($) {
  var NODE_TYPES = {
    ELEMENT_NODE: 1,
    ATTRIBUTE_NODE: 2,
    TEXT_NODE: 3,
    CDATA_SECTION_NODE: 4,
    ENTITY_REFERENCE_NODE: 5,
    ENTITY_NODE: 6,
    PROCESSING_INSTRUCTION_NODE: 7,
    COMMENT_NODE: 8,
    DOCUMENT_NODE: 9,
    DOCUMENT_TYPE_NODE: 10,
    DOCUMENT_FRAGMENT_NODE: 11,
    NOTATION_NODE: 12
  };

  $.fn.getNodeType = function () {
    return this.get(0).nodeType;
  };

  $.fn.isElementNode = function () {
    return $(this).getNodeType() == NODE_TYPES.ELEMENT_NODE;
  };

  $.fn.isTextNode = function () {
    return $(this).getNodeType() == NODE_TYPES.TEXT_NODE;
  };
})(jQuery);

function crossDomainAjax(url, callback) {
  // from http://ajaxian.com/archives/using-yql-as-a-proxy-for-cross-domain-ajax
  var yql_url = "http://query.yahooapis.com/v1/public/yql?q=select%20*%20from%20html%20where%20url%3D%22" + encodeURIComponent(url) + "%22&format=xml'&callback=?";

  console.log(yql_url);

  _jquery2.default.getJSON(yql_url, function (data) {
    callback(data);
  });
}

/******************************************************************************
 ** Javascript Extensions
 ******************************************************************************/

String.prototype.capitalizeFirstLetter = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/main.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./enso_cms/static/enso-cms/css/main.scss");

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _ensoHtmlCleanup = __webpack_require__("./enso_cms/static/enso-cms/js/enso-html-cleanup.js");

var _jsCookie = __webpack_require__("./node_modules/js-cookie/src/js.cookie.js");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _underscore = __webpack_require__("./node_modules/underscore/underscore.js");

var _underscore2 = _interopRequireDefault(_underscore);

var _backbone = __webpack_require__("./node_modules/backbone/backbone.js");

var _backbone2 = _interopRequireDefault(_backbone);

var _thirdParty = __webpack_require__("./enso_cms/static/enso-cms/js/third-party.js");

var _ensoPlugins = __webpack_require__("./enso_cms/static/enso-cms/js/enso-plugins.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// styles
var $fullscreenSpinner = (0, _jquery2.default)(".fullscreen-spinner");

// Require dependencies


function start_fullscreen_spinner() {
  $fullscreenSpinner.show();
}

function stop_fullscreen_spinner() {
  $fullscreenSpinner.hide();
}

var ALLOWED_FILE_TYPES = ["image/jpg", "image/jpeg", "image/png", "audio/m4a", "audio/mp3", "audio/mpeg", "audio/x-m4a", "video/mp4", "audio/wav", "audio/x-wav", "audio/aac", "application/zip"];

/******************************************************************************
 ** utility functions
 ******************************************************************************/

function get_uuid() {
  //http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == "x" ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

/******************************************************************************
 ** initialise server side generated javascript data
 ******************************************************************************/

var initial_data = {};
if (typeof initial_js_data !== "undefined") {
  initial_data = initial_js_data;
  //initial_js_data is generated server side and rendered to a <script> tag
  //below the end of <body> and just before loading of external js files
}

/******************************************************************************
 ** often used jquery lookups
 ******************************************************************************/

var $body = (0, _jquery2.default)("body");

function startMainLoading() {
  $body.addClass("loading");
}

function stopMainLoading() {
  $body.removeClass("loading");
}

/******************************************************************************
 ** get Jquery to always send a CSRF token with each POST request
 ******************************************************************************/

// see https://docs.djangoproject.com/en/dev/ref/contrib/csrf/#ajax

var csrftoken = _jsCookie2.default.get("csrftoken");

function csrfSafeMethod(method) {
  // these HTTP methods do not require CSRF protection
  return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method)
  );
}
_jquery2.default.ajaxSetup({
  crossDomain: false, // obviates need for sameOrigin test
  beforeSend: function beforeSend(xhr, settings) {
    if (!csrfSafeMethod(settings.type)) {
      xhr.setRequestHeader("X-CSRFToken", csrftoken);
    }
  }
});

/******************************************************************************
 ** site-wide Backbone Events
 ******************************************************************************/

var globalEvents = {};
_underscore2.default.extend(globalEvents, _backbone2.default.Events);

/******************************************************************************
 ** Backbone models
 ******************************************************************************/

var BaseModel = _backbone2.default.Model.extend({
  destroyLocalOnly: function destroyLocalOnly() {
    this.trigger("destroy", this); //trigger destroy event without sending a DELETE request to the server
  }
});

var AssetModel = BaseModel.extend({
  urlRoot: "/api/core/assets/"
});

var ImageAssetModel = BaseModel.extend({
  urlRoot: "/api/core/imageassets/"
});

var AudioAssetModel = BaseModel.extend({
  urlRoot: "/api/core/audioassets/"
});

var VideoAssetModel = BaseModel.extend({
  urlRoot: "/api/core/videoassets/"
});

var MakerModel = BaseModel.extend();

var CurrentlyDraggingObject = _backbone2.default.Model.extend();

var Autoscroller = _backbone2.default.Model.extend({
  /**
   * It's a Backone model just to use its Object Oriented features
   */

  initialize: function initialize() {
    this.directions = ["UP", "DOWN", "LEFT", "RIGHT"];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this.directions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var direction = _step.value;

        this[this.getIntervalName(direction)] = null;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    this.SPEED = 10;
    this.FRAMERATE = 20;
  },

  getIntervalName: function getIntervalName(direction) {
    return "intervalScroll" + direction;
  },

  /**
   *
   * @param scrolling true | false
   * @param direction 'UP' | 'DOWN' | 'LEFT' | 'RIGHT'
   */
  changeState: function changeState(scrolling, direction) {
    var model = this;
    var intervalName = this.getIntervalName(direction);
    direction = direction.toUpperCase();
    if (scrolling) {
      switch (direction) {
        case "UP":
          model[intervalName] = setInterval(function () {
            var scrollTop = (0, _jquery2.default)(document).scrollTop();
            (0, _jquery2.default)(document).scrollTop(scrollTop - model.SPEED);
          }, this.FRAMERATE);
          break;
        case "DOWN":
          model[intervalName] = setInterval(function () {
            var scrollTop = (0, _jquery2.default)(document).scrollTop();
            (0, _jquery2.default)(document).scrollTop(scrollTop + model.SPEED);
          }, this.FRAMERATE);
          break;
        case "LEFT":
          model[intervalName] = setInterval(function () {
            var scrollLeft = (0, _jquery2.default)(document).scrollLeft();
            (0, _jquery2.default)(document).scrollLeft(scrollLeft - model.SPEED);
          }, this.FRAMERATE);
          break;
        case "RIGHT":
          model[intervalName] = setInterval(function () {
            var scrollLeft = (0, _jquery2.default)(document).scrollLeft();
            (0, _jquery2.default)(document).scrollLeft(scrollLeft + model.SPEED);
          }, this.FRAMERATE);
          break;
      }
    } else {
      clearInterval(this[intervalName]);
    }
  }
});

/******************************************************************************
 ** Backbone collections
 ******************************************************************************/

var AssetCollection = _backbone2.default.Collection.extend({
  model: AssetModel,
  url: "/api/core/assets/",

  parse: function parse(response) {
    return response.results;
  },

  initialize: function initialize(models, options) {
    this.viewModel = options.viewModel;
  }
});

/******************************************************************************
 ** Backbone Views
 ******************************************************************************/

var BaseView = _backbone2.default.View.extend({});

var BodyView = BaseView.extend({
  el: "body",

  initialize: function initialize() {
    var view = this;
    this.dragging = false;

    this.currDraggingObjectView = null;
    this.VIEWPORT_EDGE_SIZE = 20;

    this.listenTo(globalEvents, "enso:startDragging", function (data) {
      view.dragging = true;
      $body.addClass("dragging");
      this.currDraggingObjectView = new CurrentlyDraggingObjectView(data);
    });

    this.autoscroller = new Autoscroller();
    this.initializeViewPortEdgeFunctionality();
  },

  events: {
    mousemove: function mousemove(e) {
      this.currX = e.pageX;
      this.currY = e.pageY;

      this.triggerViewPortEdgeEvents(e);

      if (this.dragging) {
        this.currDraggingObjectView.setPos(this.currX, this.currY);
      }
    },
    mouseup: function mouseup(e) {
      if (this.dragging) {
        globalEvents.trigger("enso:stopDragging");
        this.dragging = false;
        $body.removeClass("dragging");

        var data = this.currDraggingObjectView.options;
        this.currDraggingObjectView.remove(); //this must be removed BEFORE we get the mouseOverElement
        var $mouseOverElement = (0, _jquery2.default)(_jquery2.default.elementFromPoint(e.clientX, e.clientY));
        data.$elementDroppedOn = $mouseOverElement;
        $mouseOverElement.trigger("enso:drop", data);
      }
    }
  },

  initializeViewPortEdgeFunctionality: function initializeViewPortEdgeFunctionality() {
    var view = this;
    this.EDGES = ["TOP", "RIGHT", "BOTTOM", "LEFT"];
    this.viewportEdgesMousePreviouslyAt = {};

    var getEventName = function getEventName(edge, direction) {
      return "enso:mouse" + direction + "ViewportEdge" + edge.toLowerCase().capitalizeFirstLetter();
    };

    var edgeDirectionMap = {
      TOP: "UP",
      BOTTOM: "DOWN",
      RIGHT: "RIGHT",
      LEFT: "LEFT"
    };

    var _loop = function _loop(edge) {
      var enterEventName = getEventName(edge, "Enter");
      var leaveEventName = getEventName(edge, "Leave");

      view.listenTo(globalEvents, enterEventName, function (eventName) {
        if (eventName == enterEventName && view.dragging == true) {
          view.autoscroller.changeState(true, edgeDirectionMap[edge]);
        }
      });
      view.listenTo(globalEvents, leaveEventName, function (eventName) {
        if (eventName == leaveEventName && view.dragging == true) {
          view.autoscroller.changeState(false, edgeDirectionMap[edge]);
        }
      });
      view.viewportEdgesMousePreviouslyAt[edge] = false;
    };

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = this.EDGES[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var edge = _step2.value;

        _loop(edge);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  },

  triggerViewPortEdgeEvents: function triggerViewPortEdgeEvents(e) {
    var view = this;
    this.viewportEdgesMouseCurrentlyAt = this.getViewportEdgesMouseCurrentlyAt(e);

    var mouseEnterViewportEdge = function mouseEnterViewportEdge(edge) {
      return view.viewportEdgesMouseCurrentlyAt[edge] && !view.viewportEdgesMousePreviouslyAt[edge];
    };

    var mouseLeaveViewportEdge = function mouseLeaveViewportEdge(edge) {
      return !view.viewportEdgesMouseCurrentlyAt[edge] && view.viewportEdgesMousePreviouslyAt[edge];
    };

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = this.EDGES[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var edge = _step3.value;

        var eventNames = [];
        if (mouseEnterViewportEdge(edge)) {
          eventNames.push("enso:mouseEnterViewportEdge" + edge.toLowerCase().capitalizeFirstLetter());
        }
        if (mouseLeaveViewportEdge(edge)) {
          eventNames.push("enso:mouseLeaveViewportEdge" + edge.toLowerCase().capitalizeFirstLetter());
        }
        _underscore2.default.each(eventNames, function (eventName) {
          globalEvents.trigger(eventName, eventName);
        });
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    view.viewportEdgesMousePreviouslyAt = view.viewportEdgesMouseCurrentlyAt;
  },

  getViewportEdgesMouseCurrentlyAt: function getViewportEdgesMouseCurrentlyAt(mouseEvent) {
    this.cursorAtViewPortEdge = false;
    var e = mouseEvent;
    var width = this.getViewportWidth();
    var height = this.getViewportHeight();
    var x = e.clientX;
    var y = e.clientY;
    return {
      LEFT: x <= this.VIEWPORT_EDGE_SIZE && x >= 0,
      TOP: y <= this.VIEWPORT_EDGE_SIZE && y >= 0,
      RIGHT: x <= width && x >= width - this.VIEWPORT_EDGE_SIZE,
      BOTTOM: y <= height && y >= height - this.VIEWPORT_EDGE_SIZE
    };
  },

  getViewportHeight: function getViewportHeight() {
    return (0, _jquery2.default)(window).height();
  },

  getViewportWidth: function getViewportWidth() {
    return (0, _jquery2.default)(window).width();
  }
});

var getCropKeys = function getCropKeys() {
  var main_image_crop_data = initial_data.main_image_crop_data;
  if (typeof main_image_crop_data !== "undefined") {
    return Object.keys(main_image_crop_data);
  } else {
    return [];
  }
};

var getCropButtonSlug = function getCropButtonSlug(cropKey) {
  return "js-crop-" + cropKey.replace(/\./g, "-") + "-btn";
};

var ForeignKeyWidgetEnhancementView = _backbone2.default.View.extend({
  events: function events() {
    var cropEventHandler = this.clickCropImageBtn;

    var cropButtonEvents = {};

    var _loop2 = function _loop2(cropKey) {
      cropButtonEvents["click [" + getCropButtonSlug(cropKey) + "]"] = function (e) {
        cropEventHandler(this, e, cropKey);
      };
    };

    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = getCropKeys()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var cropKey = _step4.value;

        _loop2(cropKey);
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    return Object.assign({
      "click [js-new-foreign-key-btn]": "clickAddBtn",
      "click [js-edit-foreign-key-btn]": "clickEditBtn",
      "click [js-remove-foreign-key-btn]": "clickRemoveBtn",
      "enso:drop": "drop"
    }, cropButtonEvents);
  },

  initialize: function initialize(options) {
    var view = this;

    view.options = Object.assign({}, view.defaultOptions, options);
    view.foreignKeyView = view.options.foreignKeyView;
    view.options = view.foreignKeyView.options;
    view.listenTo(globalEvents, "enso:startDragging", view.startDragging);
    view.listenTo(globalEvents, "enso:stopDragging", view.stopDragging);
    view.render();
  },

  render: function render() {
    var options = this.foreignKeyView.options;
    var context = {
      showEditBtn: options.showEditBtn,
      showAddBtn: options.showAddBtn,
      showRemoveBtn: options.showRemoveBtn
    };

    if (this.model == null) {
      context.model = null;
    } else {
      context.model = this.model.toJSON();
    }

    var tmpl = __webpack_require__("./enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-widget.html");
    var html = tmpl.render(context);
    this.$el.html(html);
  },

  clickAddBtn: function clickAddBtn(e) {
    e.preventDefault();
    var view = this;

    (0, _ensoPlugins.openFormModal)({
      url: this.foreignKeyView.createUrl,
      data: view.formDefaultsAjaxData
    }, function (response) {
      var response;
      view.foreignKeyView.modelDataChanged(response);
    }, function () {
      view.modalOpenedCallback();
    });
  },

  clickEditBtn: function clickEditBtn(e) {
    //TODO: make Edit and Add DRY

    e.preventDefault();
    var view = this;
    var updateUrl = this.model.get("cms_update_url");

    console.log("clicked edit button for FK");

    (0, _ensoPlugins.openFormModal)({ url: updateUrl }, function (response) {
      var imageAssetData = response;
      view.model.set(imageAssetData);
    }, function () {
      initializePluginsAndWidgets();
      console.log("initiializePluginsAndWIdgets from popup");
      view.modalOpenedCallback();
    });
  },

  clickCropImageBtn: function clickCropImageBtn(context, e, cropKey) {
    e.preventDefault();
  },

  clickRemoveBtn: function clickRemoveBtn(e) {
    e.preventDefault();
    var view = this;
    if (view.options.removeElementOnRemove) {
      view.model.destroyLocalOnly();
    }
  },

  drop: function drop() {}, //must override to implement

  startDragging: function startDragging() {}, //override to implement

  stopDragging: function stopDragging() {
    this.$el.find("[js-drop-area]").removeClass("wrong-type");
  },

  modalOpenedCallback: function modalOpenedCallback() {
    //override to implement
    (0, _jquery2.default)("[js-tabbed-fieldsets]").tabbedFieldsets();
    (0, _jquery2.default)("[js-image-input-widget]").each(function (i, el) {
      new ImageAssetInputWidgetView({ el: el });
    });
  }
});

var ForeignKeyWidgetView = BaseView.extend({
  //TODO: abstract out the stuff inside //IMAGE comments

  defaultOptions: {
    showAddBtn: true,
    showEditBtn: true,
    showRemoveBtn: true,
    removeElementOnRemove: true
  },

  modelClass: BaseModel,

  enhancementViewClass: ForeignKeyWidgetEnhancementView,

  initialize: function initialize(options) {
    var view = this;

    view.options = Object.assign({}, view.defaultOptions, options);

    var $el = view.$el;
    view.$inputElement = $el.find(".native-widget").find("select, input"); //can be either a <select> or an <input> element
    view.$inputElementTag = view.$inputElement.prop("tagName").toLowerCase();

    // form default values:
    view.formDefaults = {};
    _underscore2.default.each($el.data(), function (value, key) {
      if (key.indexOf("default") == 0) {
        var fieldName = key.toLowerCase().replace("default", "");
        view.formDefaults[fieldName] = value;
      }
    });

    view.formDefaultsAjaxData = {};
    _underscore2.default.each(view.formDefaults, function (value, key) {
      view.formDefaultsAjaxData["form-" + key] = value;
    });

    this.createUrl = $el.data("create-url");
    var modelId = view.$inputElement.val();
    if (modelId.trim() == "") {
      modelId = null;
    }
    if (!modelId) {
      view.model = null;
      view.render();
    } else {
      this.createInitialModel(modelId, function (model) {
        view.model = model;

        // ALL these need to be rebinded when the model is swapped!
        view.enhancementView = null;
        view.rebindModelEvents();
        view.render();
      });
    }
  },

  rebindModelEvents: function rebindModelEvents() {
    var view = this;
    view.listenTo(view.model, "destroy", function () {
      view.modelRemoved();
    });
    view.listenTo(view.model, "change", function () {
      if (view.$inputElementTag == "select") {
        var $option = view.$inputElement.find(":selected");
        $option.text(view.model.get("unicode"));
        view.$inputElement.trigger("liszt:updated");
      }
    });
  },

  createInitialModel: function createInitialModel(modelId, callback) {
    var view = this;
    var initData = {
      id: modelId,
      cms_update_url: view.$el.data("update-url")
    };
    callback(new view.modelClass(initData));
  },

  modelRemoved: function modelRemoved() {
    this.model = null;
    var view = this;
    this.render();
  },

  fetchModelById: function fetchModelById(id, _success) {
    var view = this;
    var model = new view.modelClass({ id: id });
    model.fetch({
      success: function success() {
        _success(model);
      }
    });
  },

  modelIdChanged: function modelIdChanged(id) {
    var view = this;
    view.model = new view.modelClass({ id: id });
    view.model.fetch({
      success: function success() {
        view.modelChanged(view.model);
      }
    });
  },

  modelDataChanged: function modelDataChanged(data) {
    var view = this;
    var modelData = data;
    view.model = new view.modelClass(modelData);
    view.modelChanged(view.model);
  },

  modelChanged: function modelChanged(model) {
    var view = this;
    if (view.$inputElementTag == "select") {
      view.$inputElement.append((0, _jquery2.default)("<option></option>").attr("value", view.model.id).text(view.model.get("unicode")));
      view.$inputElement.val(view.model.id);
      view.$inputElement.trigger("liszt:updated"); //TODO: i think the latest plugin uses chose:updated rather than liszt:updated
    } else {
      view.$inputElement.val(view.model.id);
    }
    view.rebindModelEvents();
    view.render();
  },

  render: function render() {
    var view = this;
    if (view.$inputElementTag == "select") {
      this.$inputElement.chosen();
    }
    this.renderNativeWidget();
    this.renderEnhancementView();
  },

  renderNativeWidget: function renderNativeWidget() {
    if (this.model == null) {
      this.$inputElement.val(""); //this should be part of render ??
      if (this.$inputElementTag == "select") {
        this.$inputElement.trigger("liszt:updated"); //TODO: i think the latest plugin uses chose:updated rather than liszt:updated
      }
    }
  },

  removeExistingEnhancementView: function removeExistingEnhancementView() {
    if (this.enhancementView != null) {
      this.enhancementView.remove(); //recreate the enhancement view everytime the foreign key is changed!
    }
  },

  renderEnhancementView: function renderEnhancementView() {
    var view = this;
    view.removeExistingEnhancementView();

    var enhancementViewClass = this.enhancementViewClass;

    this.enhancementView = new enhancementViewClass({
      className: "enhanced-widget",
      foreignKeyView: view,
      model: view.model
    });
    view.$el.find(".enhanced-widget").remove();
    view.enhancementView.$el.appendTo(view.$el);
  }
});

var ImageAssetWidgetEnhancementView = ForeignKeyWidgetEnhancementView.extend({
  render: function render() {
    var options = this.foreignKeyView.options;
    var context = {
      showEditBtn: options.showEditBtn,
      showAddBtn: options.showAddBtn,
      showRemoveBtn: options.showRemoveBtn,
      cropButtons: {}
    };

    var cropKeys = getCropKeys();
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = cropKeys[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var cropKey = _step5.value;

        var data = initial_data.main_image_crop_data[cropKey];
        data.cropped = data.crop != null;
        context.cropButtons[getCropButtonSlug(cropKey)] = data;
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    if (this.model == null) {
      context.model = null;
    } else {
      var modelData = this.model.toJSON();
      context.model = modelData;
      context.imageUrl = modelData[options.imageUrlParam];
    }

    var tmpl = __webpack_require__("./enso_cms/static/enso-cms/nunjucks-templates/widgets/image-asset-widget.html");
    var html = tmpl.render(context);
    this.$el.html(html);
  },

  drop: function drop(e, data) {
    var view = this;
    var assetId = data.assetId;
    var assetType = data.assetType;
    switch (assetType) {
      case "image":
        view.foreignKeyView.modelIdChanged(data.assetId);
        break;
      default:
        break;
    }
  },

  clickCropImageBtn: function clickCropImageBtn(context, e, cropKey) {
    e.preventDefault();
    context.openAoiModal(cropKey);
  },

  openAoiModal: function openAoiModal(cropKey) {
    console.log("cropKey", cropKey);
    var title, aspectRatio;
    var type = "CROP";
    title = "CROP";
    var view = this;

    var cropSettings = initial_data.main_image_crop_data[cropKey];
    console.log("cropSettings", cropSettings);

    var cropperView = null;

    aspectRatio = cropSettings.aspect_ratio;

    var options = {
      imageUrl: view.model.get("cms_normal_url"),
      aspectRatio: aspectRatio,
      onreadyCallback: function onreadyCallback() {
        cropperView.$el.ensoModal("open", function () {
          cropperView.initJcrop();
        });
      },
      submitCallback: function submitCallback() {
        var urlTail;
        var data = {
          coords: cropperView.getNormalisedCoords(),
          cropKey: cropKey
        };

        start_fullscreen_spinner();
        urlTail = type.toLowerCase();

        _jquery2.default.ajax({
          url: "/api/core/imageassets/" + view.model.id + "/" + urlTail,
          data: JSON.stringify(data),
          type: "PATCH",
          processData: false,
          contentType: "application/json" //typically 'application/x-www-form-urlencoded', but the service you are calling may expect 'text/json'... check with the service to see what they expect as content-type in the HTTP header.
        }).done(function (response) {
          cropperView.$el.ensoModal("destroy");
          stop_fullscreen_spinner();
        });
      }
    };

    options.title = title;
    if (this.foreignKeyView.cropWidthOverride && this.foreignKeyView.cropHeightOverride) {
      options.cropWidth = this.foreignKeyView.cropWidthOverride;
      options.cropHeight = this.foreignKeyView.cropHeightOverride;
    }
    cropperView = new ImageCropperView(options);
  },

  startDragging: function startDragging(data) {
    var assetType = data.assetType;
    switch (assetType) {
      case "image":
        break;
      default:
        this.$el.find("[js-drop-area]").addClass("wrong-type");
    }
  }
});

var ImageAssetWidgetView = ForeignKeyWidgetView.extend({
  modelClass: ImageAssetModel,

  enhancementViewClass: ImageAssetWidgetEnhancementView,

  initialize: function initialize(options) {
    var defaults = {
      imageUrlParam: "cms_thumbnail_url"
    };

    options = Object.assign({}, defaults, options);

    ForeignKeyWidgetView.prototype.initialize.call(this, options);
  },

  createInitialModel: function createInitialModel(modelId, callback) {
    var view = this;
    view.fetchModelById(modelId, function (model) {
      callback(model);
    });
  },

  render: function render() {
    this.$inputElement.hide();
    this.renderNativeWidget();
    this.renderEnhancementView();
  }
});

var GalleryEditView = BaseView.extend({
  initialize: function initialize() {
    var view = this;
    view.imageWidgets = [];
    view.blankImageWidget = null;

    view.$el.find(".update-entries [js-image-gallery-image-widget]").each(function (i, el) {
      view.imageWidgets.push(new GalleryImageAssetWidgetView({
        el: el,
        gallery: view,
        isBlank: false
      }));
    });
    view.$el.find(".new-entries [js-image-gallery-image-widget]").each(function (i, el) {
      view.blankImageWidget = new GalleryImageAssetWidgetView({
        el: el,
        gallery: view,
        isBlank: true
      });
    });
  },

  createNewBlankEntry: function createNewBlankEntry() {
    var view = this;

    /**
     * copied from contrib/admin/static/admin/js/inlines.js
     */
    var updateElementIndex = function updateElementIndex(el, prefix, ndx) {
      var id_regex = new RegExp("(" + prefix + "-(\\d+|__prefix__))");
      var replacement = prefix + "-" + ndx;
      if ((0, _jquery2.default)(el).attr("for")) {
        (0, _jquery2.default)(el).attr("for", (0, _jquery2.default)(el).attr("for").replace(id_regex, replacement));
      }
      if (el.id) {
        el.id = el.id.replace(id_regex, replacement);
      }
      if (el.name) {
        el.name = el.name.replace(id_regex, replacement);
      }
    };

    var prefix = "galleryimages_set";
    var totalFormsInput = (0, _jquery2.default)("#id_" + prefix + "-TOTAL_FORMS");
    var totalForms = parseInt(totalFormsInput.val());

    var $newEntriesSection = (0, _jquery2.default)(".image-gallery-edit .new-entries");
    var $newBlankEntry = view.blankImageWidget.$el.clone(false);
    $newBlankEntry.appendTo($newEntriesSection);

    $newBlankEntry.find("*").each(function () {
      updateElementIndex(this, prefix, totalForms);
    });
    new GalleryImageAssetWidgetView({
      el: $newBlankEntry.get(0),
      gallery: view,
      isBlank: true
    });
    (0, _jquery2.default)(totalFormsInput).val(parseInt(totalFormsInput.val()) + 1);
  }
});

var GalleryImageAssetWidgetView = BaseView.extend({
  initialize: function initialize(options) {
    var view = this;
    view.gallery = options.gallery;
    view.isBlank = options.isBlank;

    view.innerWidget = new GalleryInnerImageAssetWidget({
      el: (0, _jquery2.default)(view.el).find("[js-gallery-inner-image-asset-widget]")[0]
    });
  },

  events: {
    "click [js-remove-foreign-key-btn]": "clickRemoveBtn",
    "enso:drop [js-drop-area]": "drop"
  },

  clickRemoveBtn: function clickRemoveBtn(e) {
    e.preventDefault();
    this.$el.find("input[name$='DELETE']").prop("checked", true);
    this.$el.hide(200);
  },

  drop: function drop(e, data) {
    var view = this;
    if (view.isBlank) {
      view.gallery.createNewBlankEntry();
      view.isBlank = false;
    }
  }
});

var GalleryInnerImageAssetWidget = ImageAssetWidgetView.extend({
  defaultOptions: _jquery2.default.extend({}, ImageAssetWidgetView.prototype.defaultOptions, {
    removeElementOnRemove: false
  })
});

var MainImageAssetWidgetView = ImageAssetWidgetView.extend({
  defaultOptions: _jquery2.default.extend({}, ImageAssetWidgetView.prototype.defaultOptions, {
    imageUrlParam: "cms_normal_url"
  }),

  createInitialModel: function createInitialModel(modelId, callback) {
    callback(this.model); //it's already been passed on iti
  }
});

var MediaAssetWidgetEnhancementView = ForeignKeyWidgetEnhancementView.extend({
  render: function render() {
    var options = this.foreignKeyView.options;
    var context = {
      showEditBtn: options.showEditBtn,
      showAddBtn: options.showAddBtn,
      showRemoveBtn: options.showRemoveBtn
    };

    if (this.model == null) {
      context.model = null;
    } else {
      var modelData = this.model.toJSON();
      context.model = modelData;
      context.imageUrl = modelData[options.imageUrlParam];
    }

    var tmpl = __webpack_require__("./enso_cms/static/enso-cms/nunjucks-templates/widgets/media-asset-widget.html");
    var html = tmpl.render(context);
    this.$el.html(html);
  },

  drop: function drop(e, data) {
    var view = this;
    var assetId = data.assetId;
    var assetType = data.assetType;
    switch (assetType) {
      case "audio":
      case "video":
        view.foreignKeyView.modelIdChanged(data.assetId);
        break;
      default:
        break;
    }
  },

  startDragging: function startDragging(data) {
    var assetType = data.assetType;
    switch (assetType) {
      case "audio":
      case "video":
        break;
      default:
        this.$el.find("[js-drop-area]").addClass("wrong-type");
    }
  }
});

var MediaAssetWidgetView = ForeignKeyWidgetView.extend({
  modelClass: AssetModel,

  enhancementViewClass: MediaAssetWidgetEnhancementView,

  defaultOptions: _jquery2.default.extend({}, ForeignKeyWidgetView.prototype.defaultOptions, {
    showAddBtn: false,
    showEditBtn: true,
    showRemoveBtn: true
  }),

  createInitialModel: function createInitialModel(modelId, callback) {
    var view = this;
    view.fetchModelById(modelId, function (model) {
      callback(model);
    });
  },

  render: function render() {
    this.$inputElement.hide();
    this.renderNativeWidget();
    this.renderEnhancementView();
  }
});

/*******************************************************************************
 * Asset Manager Panel
 ******************************************************************************/

var AssetManagerPanelViewModel = BaseModel.extend({
  defaults: {
    ap_object_id: initial_data.ap_object_pk,
    query: "",
    show_related: false,
    page: 1,
    loading: false
  },

  showRelated: function showRelated(force_update) {
    var force_update = typeof force_update === "undefined" ? false : force_update;
    this.clear();

    if (force_update) {
      this.trigger("refresh"); //trigger change event even though nothing has changed
    } else {
      this.set({
        show_related: true,
        page: 1,
        query: ""
      });
    }
  },

  showAll: function showAll() {
    this.clear();
    this.set({
      show_related: false,
      page: 1,
      query: ""
    });
  },

  submitQuery: function submitQuery(query) {
    this.clear();
    this.set({
      page: 1,
      show_related: false,
      query: query
    });
  },

  getNextPage: function getNextPage() {
    this.set({
      page: this.get("page") + 1
    });
  },

  clear: function clear() {
    this.trigger("clear-collection");
  }
});

/**
 * this is essentially a "controller" to coordinate the parts of the asset panel
 * A "ViewModel" is used to store frontend UI state data (as opposed to backend asset data)
 */
var AssetManagerPanelView = BaseView.extend({
  initialize: function initialize() {
    var view = this;
    var htmlSettings = view.$el.data(); //settings defined in html using data- attributes
    view.ap_object_id = htmlSettings.relatedApObjectId !== "undefined" ? htmlSettings.relatedApObjectId : null;
    view.viewModel = new AssetManagerPanelViewModel({
      ap_object_id: view.ap_object_id,
      show_related: view.ap_object_id != null
    });
    view.render();

    view.listenTo(view.viewModel, "refresh", function () {
      view.refresh();
    });

    view.listenTo(view.viewModel, "change", function () {
      var changedAttributes = view.viewModel.changedAttributes();

      view.bottomView.render();

      var queryChanged = _underscore2.default.has(changedAttributes, "query");
      var showRelatedChanged = _underscore2.default.has(changedAttributes, "show_related");
      var pageChanged = _underscore2.default.has(changedAttributes, "page");

      if (showRelatedChanged || queryChanged || pageChanged) {
        view.refresh();
      }
    });

    view.listenTo(view.viewModel, "clear-collection", function () {
      view.assetListView.clear();
    });

    view.listenTo(view.viewModel, "change:loading", function (__, loading) {
      if (loading) {
        view.$spinnerContainer.show();
      } else {
        view.$spinnerContainer.hide();
      }
    });

    view.refresh();
  },

  refresh: function refresh() {
    var view = this;

    var data = {
      page: view.viewModel.get("page")
    };

    if (view.viewModel.get("show_related") == true) {
      data.ap_object_id = view.viewModel.get("ap_object_id");
    }
    var query = view.viewModel.get("query");
    if (query) {
      data.q = query;
    }

    view.viewModel.set("loading", true);
    view.collection.fetch({
      data: data,
      success: function success() {
        view.viewModel.set("loading", false);
        view.assetListView.render();
      },
      error: function error() {
        // trying to get a next page that doesn't exist throws a 404, so let's at
        // least stop the spinner!
        view.viewModel.set("loading", false);
      }
    });
  },

  render: function render() {
    var view = this;

    view.collection = new AssetCollection([], {
      viewModel: view.viewModel
    });

    var tmpl = __webpack_require__("./enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/panel.html");
    var html = tmpl.render({});
    view.$el.html(html);

    view.topView = new AssetManagerPanelTopView({
      el: view.$("[js-asset-manager-panel-top]"),
      viewModel: view.viewModel,
      panelView: view
    });

    view.assetListView = new AssetManagerPanelListView({
      el: view.$("[js-asset-list]"),
      viewModel: view.viewModel,
      collection: view.collection,
      panelView: view
    });

    view.bottomView = new AssetManagerPanelBottomView({
      el: view.$("[js-asset-manager-panel-bottom]"),
      viewModel: view.viewModel,
      collection: view.collection,
      panelView: view
    });

    // put a spinner in
    view.$spinnerContainer = (0, _jquery2.default)(".asset-panel-spinner");
    view.$("[js-asset-panel-spinner]").spin({
      lines: 11, // The number of lines to draw
      length: 2, // The length of each line
      width: 2, // The line thickness
      radius: 5, // The radius of the inner circle
      corners: 1, // Corner roundness (0..1)
      rotate: 0, // The rotation offset
      direction: 1, // 1: clockwise, -1: counterclockwise
      color: "#000", // #rgb or #rrggbb or array of colors
      speed: 1, // Rounds per second
      trail: 60, // Afterglow percentage
      shadow: false, // Whether to render a shadow
      hwaccel: false, // Whether to use hardware acceleration
      className: "spinner", // The CSS class to assign to the spinner
      zIndex: 2e9 // The z-index (defaults to 2000000000)
      //                top: '50%', // Top position relative to parent
      //                left: '50%' // Left position relative to parent
    });
  }
});

var AssetManagerPanelTopView = BaseView.extend({
  initialize: function initialize(options) {
    var view = this;
    view.viewModel = options.viewModel;
    view.panelView = options.panelView;
    view.$assetSearchForm = (0, _jquery2.default)("#asset-search-form");
    view.$assetSearchQ = (0, _jquery2.default)("#asset-search-q");
    view.render();

    view.listenTo(view.viewModel, "change", function () {
      view.render();
    });
  },

  events: {
    "submit #asset-search-form": "submitAssetSearchForm"
  },

  render: function render() {
    var view = this;
    var context = view.viewModel.toJSON();
    var tmpl = __webpack_require__("./enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/top.html");
    var html = tmpl.render(context);
    view.$el.html(html);
  },

  submitAssetSearchForm: function submitAssetSearchForm(e) {
    e.preventDefault();
    var view = this;
    var query = (0, _jquery2.default)("#asset-search-q").val();
    view.viewModel.submitQuery(query);
  }
});

var AssetManagerPanelBottomView = BaseView.extend({
  initialize: function initialize(options) {
    var view = this;
    view.viewModel = options.viewModel;
    view.panelView = options.panelView;
    view.render();
    view.$showRelatedAssetsBtn = view.$("[js-show-related-assets]");
    view.$showAllAssetsBtn = view.$("[js-show-all-assets]");
    view.$fileInput = (0, _jquery2.default)("#asset-library-multi-file-input");
  },

  events: {
    "click [js-asset-library-add-btn]": "clickAddAssetButton",
    "click [js-show-all-assets]": "clickShowAllAssetsButton",
    "click [js-show-related-assets]": "clickShowRelatedAssetsButton"
  },

  render: function render() {
    var view = this;
    var tmpl = __webpack_require__("./enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/bottom.html");
    var html = tmpl.render(view.viewModel.toJSON());
    view.$el.html(html);
  },

  clickShowAllAssetsButton: function clickShowAllAssetsButton(e) {
    e.preventDefault();
    var view = this;
    view.viewModel.showAll();
  },

  clickShowRelatedAssetsButton: function clickShowRelatedAssetsButton(e) {
    e.preventDefault();
    var view = this;
    view.viewModel.showRelated();
  },

  clickAddAssetButton: function clickAddAssetButton(e) {
    var view = this;
    e.preventDefault();

    var MAX_FILENAME_LENGTH = 64; //a total of 64 UTF8 4 byte characters are possible on linux ext3

    var url = initial_data.asset_create_multiple_url;

    view.$fileInput.trigger("click");

    view.$fileInput.on("change", function () {
      var fileInput = view.$fileInput[0];
      //TODO: if html5 FileApi is not supported, then assume only one file could be uploaded at a time

      var files = fileInput.files;
      var fileUploadsLeft = files.length;

      var fileData = []; //to be sent to the server to generate forms
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        console.log("file type", file.type);
        if (file.name.length > MAX_FILENAME_LENGTH) {
          alert("Unfortunately the file " + file.name + " cannot be uploaded as it is " + file.name.length + " characters long. The file name must be less than " + MAX_FILENAME_LENGTH + " characters long.");
        } else if (!_underscore2.default.contains(ALLOWED_FILE_TYPES, file.type)) {
          alert("Unfortunately the file " + file.name + " cannot be uploaded as the type " + file.type + " is not supported");
        } else {
          fileData.push({
            js_id: i,
            name: file.name,
            size: file.size,
            type: file.type
          });
        }
      }

      if (fileData.length > 0) {
        _jquery2.default.ajax({
          type: "POST",
          url: url,
          data: {
            data: JSON.stringify(fileData),
            method: "GET"
          }
        }).done(function (response) {
          var $assetsWrapper = (0, _jquery2.default)(response);
          var $saveAssetsBtn = $assetsWrapper.find("#save-assets-btn");
          $saveAssetsBtn.addClass("disabled");

          $assetsWrapper.ensoModal(); //open the modal

          var $assetMetaDataForms = $assetsWrapper.find("form.asset-metadata-form");
          $assetMetaDataForms.each(function (i, e) {
            var $form = (0, _jquery2.default)(e);
            $form.on("submit", function (e) {
              e.preventDefault();
            });
          });

          var fileUploadUrl = $assetsWrapper.data("file-upload-url");
          var createAssetsUrl = $assetsWrapper.data("asset-create-multiple-url");

          var $uploadWidgets = $assetsWrapper.find("[js-asset-upload]");

          // now that we have server side generated uuid's for the files, we can upload them
          //TODO: don't just upload them all at once, do a maximum of 3 or so at a time
          $uploadWidgets.each(function (i, e) {
            var $uploadWidget = (0, _jquery2.default)(e);
            var $progressBar = $uploadWidget.find("[js-progress] .progress-bar");
            var uuid = $uploadWidget.data("uuid");

            // upload the file asynchronously wile the user fills out the rest of the form
            var fileUploadFormData = new FormData($uploadWidget.find("form.file-upload-form")[0]);
            var file = files[parseInt($uploadWidget.data("js-id"))];
            var mimeType = (0, _ensoPlugins.getMimeObject)(file.type);
            fileUploadFormData.append("file", file);

            var xhr = new window.XMLHttpRequest();
            xhr.open("POST", fileUploadUrl);
            xhr.onload = function (event) {
              fileUploadsLeft--;
              if (fileUploadsLeft == 0) {
                $saveAssetsBtn.removeClass("disabled");
              }
            };

            xhr.upload.onprogress = function (event) {
              if (!event.lengthComputable) {
                return; //TODO: in this case we should turn the progress meter into a 'spinner' type view
              }
              // Update file size because it might be bigger than reported by the fileSize:
              var percentComplete = event.loaded / event.total * 100.0;
              $progressBar.css("width", percentComplete + "%");
            };

            setTimeout(function () {
              xhr.send(fileUploadFormData);
            }, 500);

            // show a preview of the file using html5 FileReader

            var fileReader = new FileReader();

            fileReader.onload = function (e) {
              uri = e.target.result;
              switch (mimeType.mediaType) {
                case "image":
                  var $previewImage = $uploadWidget.find("[js-image-preview]");
                  $previewImage.attr("src", uri);
                  break;
                case "audio":
                  var $previewAudio = $uploadWidget.find("[js-audio-preview]");
                  var uri = e.target.result;
                  //$previewAudio.find('source')[0].src = uri;
                  //$previewAudio[0].load();
                  break;
                case "video":
                  var $previewVideo = $uploadWidget.find("[js-video-preview]");
                  var uri = e.target.result;
                  //$previewVideo.find('source')[0].src = uri;
                  //$previewVideo[0].load();
                  break;
              }
            };
            fileReader.readAsDataURL(file);

            // seeing as the page has multiple of the same form and it's
            // a hassle to have to namespace each field by appending a number (title-1, title-2, etc)
            // we are going to serialise each form as a JSON structure where the key to each object
            // is the uuid for the file. This will be posted as a single querystring parameter 'data'
          });

          $saveAssetsBtn.on("click", function (e) {
            // don't let the user save until all files have been uploaded
            if (!(0, _jquery2.default)(this).hasClass(".disabled")) {
              start_fullscreen_spinner();
              e.preventDefault();

              var allFormData = {};

              $uploadWidgets.each(function () {
                var $widget = (0, _jquery2.default)(this);
                var $form = $widget.find(".asset-metadata-form");
              });

              $assetsWrapper.find(".asset-metadata-form").each(function () {
                var $form = (0, _jquery2.default)(this);
                var formData = $form.serializeObject();
                formData.related_ap_object_pk = initial_data.ap_object_pk;
                allFormData[formData.uuid] = formData;
              });

              _jquery2.default.ajax({
                type: "POST",
                url: createAssetsUrl,
                data: {
                  data: JSON.stringify(allFormData),
                  method: "POST"
                }
              }).done(function (response) {
                $assetsWrapper.ensoModal("destroy");
                view.relatedOnly = true;
                view.viewModel.showRelated(true);
                stop_fullscreen_spinner();
              });
            }
          });
        });
      }
    });
  }
});

//TODO: we really need a collection, and all the necessary endpoints

var AssetManagerPanelListView = BaseView.extend({
  initialize: function initialize(options) {
    var view = this;
    view.viewModel = options.viewModel;
    view.assetItemViews = [];
    view.collection = options.collection;

    //TODO: this assumes we are using this from an ap object page.
    // perhaps pass as an initialization argument?
  },

  events: {
    scroll: "scrollAssetList"
  },

  render: function render() {
    var view = this;
    view.collection.each(function (asset) {
      view.appendAssetView(asset);
    });
  },

  clear: function clear() {
    this.$el.empty();
  },

  appendAssetView: function appendAssetView(asset) {
    var view = this;
    var assetView = new AssetManagerPanelItemView({
      model: asset
    });
    view.assetItemViews.push(assetView);
    assetView.$el.appendTo(view.$el);
  },

  //TODO!
  scrollAssetList: function scrollAssetList() {
    var view = this;
    var $list = (0, _jquery2.default)(this);
    if (view.$el.scrollTop() + view.$el.innerHeight() >= view.el.scrollHeight) {
      view.viewModel.getNextPage();
    }
  }
});

var AssetManagerPanelItemView = BaseView.extend({
  tagName: "li",
  className: "draggable",

  initialize: function initialize() {
    var view = this;
    view.render();
  },

  render: function render() {
    var tmpl = __webpack_require__("./enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/item.html");
    var html = tmpl.render({ asset: this.model.toJSON() });
    this.$el.html(html);
  },

  events: {
    mousedown: "clickDraggableAsset",
    "click     [js-edit-foreign-key-btn]": "clickEditForeignKeyButton"
  },

  clickDraggableAsset: function clickDraggableAsset(e) {
    var view = this;
    e.preventDefault();
    var assetId = this.model.get("id");
    var assetType = this.model.get("media_type_slug");

    globalEvents.trigger("enso:startDragging", {
      $draggable: view.$el,
      assetId: assetId,
      assetType: assetType
    });
  },

  clickEditForeignKeyButton: function clickEditForeignKeyButton(e) {
    e.stopPropagation();
    e.preventDefault();

    var view = this;
    var updateUrl = "/" + view.model.get("media_type_slug") + "-asset/" + view.model.id + "/update/";

    (0, _ensoPlugins.openFormModal)({ url: updateUrl }, function (response) {
      //var imageAssetData = response;
      //view.model.set(imageAssetData);
    }, function ($modal) {
      (0, _jquery2.default)("[js-tabbed-fieldsets]").tabbedFieldsets();
      (0, _jquery2.default)("[js-image-input-widget]").each(function (i, el) {
        new ImageAssetInputWidgetView({ el: el });
      });
      initializePluginsAndWidgets();

      var $deleteButton = (0, _jquery2.default)("[js-delete-button]");
      $deleteButton.on("click", function (e) {
        console.log("click");
        e.preventDefault();
        var id = $deleteButton.data("object-id");
        _jquery2.default.get("/api/core/imageassets/" + id + "/related-objects", function (data) {
          var canDelete = false;
          var message = "";
          if (_jquery2.default.isEmptyObject(data.related_objects)) {
            canDelete = true;
            message += "\n Are you sure you want to delete this asset?";
          } else {
            message = "This asset can not be deleted as it is being used by the following items:\n\n";
            _jquery2.default.each(data.related_objects, function (type, items) {
              console.log(type);
              message += type + "\n";
              _jquery2.default.each(items, function (i, item) {
                message += item + "\n";
              });
            });
            message += "\n\nThe asset must be detached from these items by clicking the [x] button on the asset for the item, and then saving the item.";
          }
          if (canDelete) {
            confirmed = confirm(message);
            if (confirmed) {
              _jquery2.default.ajax({
                url: "/api/core/imageassets/" + id + "/delete",
                type: "DELETE",
                success: function success(result) {
                  location.reload();
                }
              });
            }
          } else {
            alert(message);
          }
        });
      });
    });
  }
});

var CurrentlyDraggingObjectView = BaseView.extend({
  initialize: function initialize(options) {
    this.options = options;
    //do render here:
    var $draggable = this.options.$draggable;

    var $fromImg = $draggable.find("img");
    var origWidth = $fromImg[0].clientWidth;
    var origHeight = $fromImg[0].clientHeight;
    var ENLARGE_MULTIPLIER = 1.5;
    var spriteWidth = origWidth * ENLARGE_MULTIPLIER;
    var spriteHeight = origHeight * ENLARGE_MULTIPLIER;

    var src = $fromImg.attr("src");
    var $spriteImage = (0, _jquery2.default)('<img src="' + src + '" />');
    $spriteImage.css({
      position: "relative",
      top: -(spriteHeight / 2),
      left: -(spriteWidth / 2),
      width: spriteWidth,
      height: spriteHeight,
      border: "2px solid white"
    });

    var $sprite = (0, _jquery2.default)("<div>");
    $spriteImage.appendTo($sprite);
    $sprite.css({
      "pointer-events": "none", // This is a very important css property which means that the underlying element can still recieve mouse events. Does not work in IE10!
      position: "absolute",
      "z-index": "1000",
      left: bodyView.currX - origWidth / 2,
      top: bodyView.currY - origHeight / 2
    });
    $sprite.appendTo("body");
    this.$el = $sprite;
  },

  setPos: function setPos(left, top) {
    this.$el.css({
      left: left,
      top: top
    });
  }
});

var MultipleAssetsView = BaseView.extend({
  initialize: function initialize() {
    var view = this;

    this.$selectElement = this.$("select");
    this.$selectElement.addClass("hidden");
    this.$el.closest("field").find(".helptext").hide();
    this.$fileInput = (0, _jquery2.default)('<input type="file" multiple />');
    var $fileInput = this.$fileInput;
    $fileInput.appendTo(this.$el);

    this.$expectedFilenamesInput = (0, _jquery2.default)("#id_filenames");
    this.expectedFilenames = _underscore2.default.map(this.$expectedFilenamesInput.text().split("\n"), function (filename) {
      return filename.trim();
    });

    this.fetchAssetData();

    $fileInput.on("change", function () {
      startMainLoading();
      //TODO: if html5 FileApi is not supported, then assume only one file could be uploaded at a time

      var files = this.files;

      var fileData = []; //to be sent to the server to generate forms
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        fileData.push({
          js_id: i,
          name: file.name,
          size: file.size,
          type: file.type
        });
      }
      var filenames = _underscore2.default.map(fileData, function (file) {
        return file.name;
      });
      var fileCheck = view.checkFiles(filenames);
      var filesToUpload = [];
      _underscore2.default.each(fileData, function (file) {
        if (_underscore2.default.contains(fileCheck.correctFiles, (0, _ensoPlugins.stripExtension)(file.name))) {
          filesToUpload.push(file);
        }
      });

      var fileUploadsLeft = filesToUpload.length;

      var template = __webpack_require__("./enso_cms/static/enso-cms/nunjucks-templates/device-files-confirm.html");
      var $confirmBox = (0, _jquery2.default)(template.render(fileCheck));
      $confirmBox.find(".cancel-button").on("click", function () {
        $confirmBox.ensoModal("destroy");
      });
      $confirmBox.find(".ok-button").on("click", function () {
        $confirmBox.ensoModal("destroy");

        var createAssetsUrl = "/asset/create-update-multiple/";
        _jquery2.default.ajax({
          type: "POST", // semantically it should be GET, but the payload is often too large for nginx/UWSGI to handle
          url: createAssetsUrl,
          data: {
            "file-data": JSON.stringify(filesToUpload),
            type: "GET"
          } //encode json as a querystring parameter
        }).done(function (response) {
          var $assetsWrapper = (0, _jquery2.default)(response);
          var $saveAssetsBtn = $assetsWrapper.find("#save-assets-btn");
          $saveAssetsBtn.addClass("disabled");
          $assetsWrapper.ensoModal(); //open the modal
          var fileUploadUrl = $assetsWrapper.data("file-upload-url");
          var createAssetsUrl = $assetsWrapper.data("asset-create-multiple-url");

          var $uploadWidgets = $assetsWrapper.find("[js-asset-upload]");

          // now that we have server side generated uuid's for the files, we can upload them
          //TODO: don't just upload them all at once, do a maximum of 3 or so at a time
          $uploadWidgets.each(function (i, e) {
            var $uploadWidget = (0, _jquery2.default)(e);
            var $progressBar = $uploadWidget.find("[js-progress] .progress-bar");
            var uuid = $uploadWidget.data("uuid");

            // upload the file asynchronously wile the user fills out the rest of the form
            var fileUploadFormData = new FormData($uploadWidget.find("form.file-upload-form")[0]);
            var file = files[parseInt($uploadWidget.data("js-id"))];
            var mimeType = (0, _ensoPlugins.getMimeObject)(file.type);
            fileUploadFormData.append("file", file);

            var xhr = new window.XMLHttpRequest();
            xhr.open("POST", fileUploadUrl);
            xhr.onload = function (event) {
              fileUploadsLeft--;
              if (fileUploadsLeft == 0) {
                $saveAssetsBtn.removeClass("disabled");
              }
            };

            xhr.upload.onprogress = function (event) {
              if (!event.lengthComputable) {
                return; //TODO: in this case we should turn the progress meter into a 'spinner' type view
              }
              // Update file size because it might be bigger than reported by the fileSize:
              var percentComplete = event.loaded / event.total * 100.0;
              $progressBar.css("width", percentComplete + "%");
            };

            setTimeout(function () {
              xhr.send(fileUploadFormData);
            }, 500);

            // show a preview of the file using html5 FileReader

            var fileReader = new FileReader();

            fileReader.onload = function (e) {
              uri = e.target.result;
              switch (mimeType.mediaType) {
                case "image":
                  var $previewImage = $uploadWidget.find("[js-image-preview]");
                  $previewImage.attr("src", uri);
                  break;
                case "audio":
                  var $previewAudio = $uploadWidget.find("[js-audio-preview]");
                  var uri = e.target.result;
                  //$previewAudio.find('source')[0].src = uri;
                  //$previewAudio[0].load();
                  break;
                case "video":
                  var $previewVideo = $uploadWidget.find("[js-video-preview]");
                  var uri = e.target.result;
                  //$previewVideo.find('source')[0].src = uri;
                  //$previewVideo[0].load(); //disabled as it kills the
                  break;
              }
            };
            fileReader.readAsDataURL(file);

            // seeing as the page has multiple of the same form and it's
            // a hassle to have to namespace each field by appending a number (title-1, title-2, etc)
            // we are going to serialise each form as a JSON structure where the key to each object
            // is the uuid for the file. This will be posted as a single querystring parameter 'data'
          });

          $saveAssetsBtn.on("click", function (e) {
            // don't let the user save until all files have been uploaded
            if (!(0, _jquery2.default)(this).hasClass(".disabled")) {
              startMainLoading();
              e.preventDefault();

              var allFormData = {};

              $uploadWidgets.each(function () {
                var $widget = (0, _jquery2.default)(this);
                var $form = $widget.find(".asset-metadata-form");
              });

              $assetsWrapper.find(".asset-metadata-form").each(function () {
                var $form = (0, _jquery2.default)(this);
                var formData = $form.serializeObject();
                formData.related_ap_object_pk = initial_data.ap_object_pk;
                allFormData[formData.uuid] = formData;
              });

              _jquery2.default.ajax({
                type: "POST",
                url: createAssetsUrl,
                data: { data: JSON.stringify(allFormData) }
              }).done(function (response) {
                $assetsWrapper.ensoModal("destroy");

                var uploadedAssets = response.assets;
                var uploadedFilenames = [];
                _underscore2.default.each(uploadedAssets, function (asset) {
                  uploadedFilenames.push((0, _ensoPlugins.stripExtension)(asset.original_filename));
                });
                var uploadedAssetIds = [];
                _underscore2.default.each(uploadedAssets, function (asset) {
                  uploadedAssetIds.push(asset.id);
                });

                var newAssetIds = _underscore2.default.difference(uploadedAssetIds, view.currUploadedAssetIds);
                // add option elements for these, we don't really care what the label is as it won't be seen
                _underscore2.default.each(newAssetIds, function (id) {
                  view.$selectElement.append('<option value="' + id + '">' + id + "</option>");
                });
                view.currUploadedAssetIds = _underscore2.default.union(view.currUploadedAssetIds, uploadedAssetIds);
                view.$selectElement.val(view.currUploadedAssetIds);
                stopMainLoading();
              });
            }
          });
        });
      });

      $confirmBox.ensoModal();
      stopMainLoading();
    });
  },

  checkFiles: function checkFiles(filenames) {
    filenames = _underscore2.default.map(filenames, function (f) {
      return (0, _ensoPlugins.stripExtension)(f);
    });

    var notExpected = _underscore2.default.difference(filenames, this.expectedFilenames);
    var notSupplied = _underscore2.default.difference(this.expectedFilenames, filenames);
    var correctFiles = _underscore2.default.intersection(this.expectedFilenames, filenames);

    return {
      notExpected: notExpected,
      notSupplied: notSupplied,
      correctFiles: correctFiles,
      toBeReplaced: _underscore2.default.intersection(correctFiles, this.currUploadedFilenames),
      toBeCreated: _underscore2.default.difference(correctFiles, this.currUploadedFilenames),
      perfect: notExpected.length + notSupplied.length == 0
    };
  },

  formatFileCheck: function formatFileCheck(fileCheck) {
    var s = "";
    if (fileCheck.notSupplied.length) {
      s += "Warning - The following expected files were not supplied and will not be created or replaced:\n\n";
      _underscore2.default.each(fileCheck.notSupplied, function (filename) {
        s += filename + "\n";
      });
    }
    if (fileCheck.notExpected.length) {
      s += "\nWarning - The following files were not expected and will be ignored:\n\n";
      _underscore2.default.each(fileCheck.notExpected, function (filename) {
        s += filename + "\n";
      });
    }

    if (fileCheck.toBeReplaced.length) {
      s += "\nThe following assets will be replaced:\n\n";
      _underscore2.default.each(fileCheck.toBeReplaced, function (filename) {
        s += filename + "\n";
      });
    }

    if (fileCheck.toBeCreated.length) {
      s += "\nThe following assets will be created:\n\n";
      _underscore2.default.each(fileCheck.toBeCreated, function (filename) {
        s += filename + "\n";
      });
    }

    s += "\n\nAre you sure you want to go ahead?";
    return s;
  },

  fetchAssetData: function fetchAssetData() {
    var view = this;
    view.currUploadedAssetIds = _underscore2.default.map(this.$selectElement.val(), function (val) {
      return parseInt(val);
    });
    if (view.currUploadedAssetIds != null) {
      var assetIdsCsv = view.currUploadedAssetIds.join(",");

      _jquery2.default.get("/api/core/assets/get_batch/?page_size=1000", { ids: assetIdsCsv }, function (data) {
        view.currUploadedAssets = data.results;
        view.currUploadedFilenames = [];
        _underscore2.default.each(view.currUploadedAssets, function (asset) {
          view.currUploadedFilenames.push((0, _ensoPlugins.stripExtension)(asset.original_filename));
        });
      });
    } else {
      view.currUploadedAssetIds = [];
    }
  }
});

var BulkUploadView = BaseView.extend({
  initialize: function initialize() {
    var view = this;

    this.$fileInput = (0, _jquery2.default)('<input type="file" multiple />');
    var $fileInput = this.$fileInput;
    $fileInput.appendTo(this.$el);

    var replaceConfirmTemplate = __webpack_require__("./enso_cms/static/enso-cms/nunjucks-templates/asset-replace-confirm.html");

    $fileInput.on("change", function () {
      startMainLoading();
      //TODO: if html5 FileApi is not supported, then assume only one file could be uploaded at a time

      var files = this.files;

      var selectedFiles = []; //to be sent to the server to generate forms
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        selectedFiles.push({
          js_id: i,
          name: file.name,
          size: file.size,
          type: file.type
        });
      }
      var selectedFilenames = _underscore2.default.map(selectedFiles, function (file) {
        return file.name;
      });
      view.fetchAssetData(selectedFilenames, function (assets) {
        var filenamesToBeReplaced = [];
        _underscore2.default.each(assets, function (asset) {
          filenamesToBeReplaced.push(asset.original_filename);
        });
        var notExpected = _underscore2.default.difference(selectedFilenames, filenamesToBeReplaced);

        var filesToUpload = [];
        _underscore2.default.each(filenamesToBeReplaced, function (filename) {
          _underscore2.default.each(selectedFiles, function (file) {
            if (file.name == filename) {
              filesToUpload.push(file);
            }
          });
        });

        var fileUploadsLeft = filesToUpload.length;

        var $confirmBox = (0, _jquery2.default)(replaceConfirmTemplate.render({
          toBeReplaced: filenamesToBeReplaced,
          notExpected: notExpected
        }));

        $confirmBox.find(".cancel-button").on("click", function () {
          $confirmBox.ensoModal("destroy");
        });
        $confirmBox.find(".ok-button").on("click", function () {
          $confirmBox.ensoModal("destroy");

          var createAssetsUrl = "/asset/create-update-multiple/";
          _jquery2.default.ajax({
            type: "POST", // semantically it should be GET, but the payload is often too large for nginx/UWSGI to handle
            url: createAssetsUrl,
            data: {
              "file-data": JSON.stringify(filesToUpload),
              type: "GET"
            } //encode json as a querystring parameter
          }).done(function (response) {
            var $assetsWrapper = (0, _jquery2.default)(response);
            var $saveAssetsBtn = $assetsWrapper.find("#save-assets-btn");
            $saveAssetsBtn.addClass("disabled");
            $assetsWrapper.ensoModal(); //open the modal
            var fileUploadUrl = $assetsWrapper.data("file-upload-url");
            var createAssetsUrl = $assetsWrapper.data("asset-create-multiple-url");

            var $uploadWidgets = $assetsWrapper.find("[js-asset-upload]");

            // now that we have server side generated uuid's for the files, we can upload them
            //TODO: don't just upload them all at once, do a maximum of 3 or so at a time
            $uploadWidgets.each(function (i, e) {
              var $uploadWidget = (0, _jquery2.default)(e);
              var $progressBar = $uploadWidget.find("[js-progress] .progress-bar");
              var uuid = $uploadWidget.data("uuid");

              // upload the file asynchronously wile the user fills out the rest of the form
              var fileUploadFormData = new FormData($uploadWidget.find("form.file-upload-form")[0]);
              var file = files[parseInt($uploadWidget.data("js-id"))];
              var mimeType = (0, _ensoPlugins.getMimeObject)(file.type);
              fileUploadFormData.append("file", file);

              var xhr = new window.XMLHttpRequest();
              xhr.open("POST", fileUploadUrl);
              xhr.onload = function (event) {
                fileUploadsLeft--;
                if (fileUploadsLeft == 0) {
                  $saveAssetsBtn.removeClass("disabled");
                }
              };

              xhr.upload.onprogress = function (event) {
                if (!event.lengthComputable) {
                  return; //TODO: in this case we should turn the progress meter into a 'spinner' type view
                }
                // Update file size because it might be bigger than reported by the fileSize:
                var percentComplete = event.loaded / event.total * 100.0;
                $progressBar.css("width", percentComplete + "%");
              };

              setTimeout(function () {
                xhr.send(fileUploadFormData);
              }, 500);

              // show a preview of the file using html5 FileReader

              var fileReader = new FileReader();

              fileReader.onload = function (e) {
                uri = e.target.result;
                switch (mimeType.mediaType) {
                  case "image":
                    var $previewImage = $uploadWidget.find("[js-image-preview]");
                    $previewImage.attr("src", uri);
                    break;
                  case "audio":
                    var $previewAudio = $uploadWidget.find("[js-audio-preview]");
                    var uri = e.target.result;
                    //$previewAudio.find('source')[0].src = uri;
                    //$previewAudio[0].load();
                    break;
                  case "video":
                    var $previewVideo = $uploadWidget.find("[js-video-preview]");
                    var uri = e.target.result;
                    //$previewVideo.find('source')[0].src = uri;
                    //$previewVideo[0].load();
                    break;
                }
              };
              fileReader.readAsDataURL(file);

              // seeing as the page has multiple of the same form and it's
              // a hassle to have to namespace each field by appending a number (title-1, title-2, etc)
              // we are going to serialise each form as a JSON structure where the key to each object
              // is the uuid for the file. This will be posted as a single querystring parameter 'data'
            });

            $saveAssetsBtn.on("click", function (e) {
              // don't let the user save until all files have been uploaded
              if (!(0, _jquery2.default)(this).hasClass(".disabled")) {
                startMainLoading();
                e.preventDefault();

                var allFormData = {};

                $uploadWidgets.each(function () {
                  var $widget = (0, _jquery2.default)(this);
                  var $form = $widget.find(".asset-metadata-form");
                });

                $assetsWrapper.find(".asset-metadata-form").each(function () {
                  var $form = (0, _jquery2.default)(this);
                  var formData = $form.serializeObject();
                  formData.related_ap_object_pk = initial_data.ap_object_pk;
                  allFormData[formData.uuid] = formData;
                });

                _jquery2.default.ajax({
                  type: "POST",
                  url: createAssetsUrl,
                  data: { data: JSON.stringify(allFormData) }
                }).done(function (response) {
                  $assetsWrapper.ensoModal("destroy");

                  var uploadedAssets = response.assets;
                  var uploadedFilenames = [];
                  _underscore2.default.each(uploadedAssets, function (asset) {
                    uploadedFilenames.push((0, _ensoPlugins.stripExtension)(asset.original_filename));
                  });
                  var uploadedAssetIds = [];
                  _underscore2.default.each(uploadedAssets, function (asset) {
                    uploadedAssetIds.push(asset.id);
                  });
                  var newAssetIds = _underscore2.default.difference(uploadedAssetIds, view.currUploadedAssetIds);
                  // add option elements for these, we don't really care what the label is as it won't be seen
                  stopMainLoading();
                  alert("done");
                  window.location.reload();
                });
              }
            });
          });
        });
        $confirmBox.ensoModal();
        stopMainLoading();
      });
    });
  },

  fetchAssetData: function fetchAssetData(filenames, callback) {
    var view = this;
    filenamesJson = JSON.stringify(filenames);

    _jquery2.default.get("/api/core/assets/get_batch/?page_size=1000", { "original-filenames": filenamesJson }, function (data) {
      view.currUploadedAssets = data.results;
      callback(data.results);
    });
  }
});

var ImageAssetInputWidgetView = BaseView.extend({
  initialize: function initialize() {
    var view = this;
    view.fileUuid = null;
    view.$fileInput = this.$el.find("#id_file");
    view.fileUploadUrl = view.$el.data("file-upload-url");
    view.$progressBar = view.$el.find("[js-progress] .progress-bar");
    view.$parentForm = view.$el.closest("form");
    view.$submitBtn = view.$parentForm.find(".submit-btn");
    view.$parentForm.prepend('<input type="hidden" name="file-uuid" value="">');
    view.$hiddenUuidField = view.$parentForm.find("input[name=file-uuid]");
    view.csrfmiddlewaretoken = view.$parentForm.find("[name=csrfmiddlewaretoken]").val();
    view.uploading = false;

    //        view.$parentForm.on('submit', function (e) {
    //            if (view.uploading) {
    //                e.preventDefault();
    //                alert('please wait for the file to upload before submitting');
    //            }
    //        });

    view.$fileInput.on("change", function () {
      view.$submitBtn.addClass("disabled");
      view.fileUuid = get_uuid();
      view.$hiddenUuidField.val(view.fileUuid);

      var file = this.files[0];
      if (!_underscore2.default.contains(ALLOWED_FILE_TYPES, file.type)) {
        alert("Unfortunately the file " + file.name + " cannot be uploaded as the type " + file.type + " is not supported");
        return;
      }

      //so now we set the value of the <input> element to null, as we
      // don't want to use it to upload the file (file upload happens in the background
      // via Ajax)
      var $clonedFileInput = view.$fileInput.clone(true);
      view.$fileInput.replaceWith($clonedFileInput); //http://stackoverflow.com/questions/1043957/clearing-input-type-file-using-jquery
      //            view.$fileInput.hide();
      view.$fileInput = $clonedFileInput;
      view.$fileInput.hide();

      // upload the file asynchronously wile the user fills out the rest of the form
      var fileUploadFormData = new FormData();
      fileUploadFormData.append("csrfmiddlewaretoken", view.csrfmiddlewaretoken);
      fileUploadFormData.append("uuid", view.fileUuid);
      fileUploadFormData.append("file", file);

      var xhr = new window.XMLHttpRequest();
      xhr.open("POST", view.fileUploadUrl);
      xhr.onload = function (event) {
        view.uploading = false;
        view.$submitBtn.removeClass("disabled");
      };

      view.uploading = true;

      xhr.upload.onprogress = function (event) {
        if (!event.lengthComputable) {
          return; //TODO: in this case we should turn the progress meter into a 'spinner' type view
        }
        // Update file size because it might be bigger than reported by the fileSize:
        var percentComplete = event.loaded / event.total * 100.0;
        view.$progressBar.css("width", percentComplete + "%");
      };

      setTimeout(function () {
        xhr.send(fileUploadFormData);
      }, 500);
    });
  }
});

var ImageCropperView = _backbone2.default.View.extend({
  defaultOptions: {
    initialSelection: null,
    aspectRatio: 1.0,
    onreadyCallback: null,
    submitCallback: null
  },

  events: {
    submit: "submit"
  },

  initialize: function initialize(options) {
    var view = this;
    view.cropPaddingHorz = 250;
    view.cropPaddingVert = 50;
    view.options = Object.assign({}, view.defaultOptions, options);
    console.log("image cropper view options", view.options);

    var coords;

    view.$image = (0, _jquery2.default)("<img>");
    view.$image.attr("src", view.options.imageUrl);

    view.$image.on("load", function () {
      var tmpl = __webpack_require__("./enso_cms/static/enso-cms/nunjucks-templates/cropper.html");
      var html = tmpl.render({ title: view.options.title });
      var $cropper = (0, _jquery2.default)(html);
      view.$image.appendTo($cropper.find(".canvas"));

      view.imageWidth = view.$image[0].width;
      view.imageHeight = view.$image[0].height;

      $cropper.appendTo(view.$el);

      if (view.options.onreadyCallback) {
        view.options.onreadyCallback();
      }
      view.$el.html();
    });
  },

  submit: function submit(e) {
    var view = this;
    e.preventDefault();
    if (view.options.submitCallback) {
      view.options.submitCallback(view.coords);
    }
  },

  /**
   * Jcropt can only be initialise after the html has been rendered to the dom.
   * so if you are dynamically generating and rendering outer html, then you
   * need to call this function after you've rendered it to screen
   */
  initJcrop: function initJcrop() {
    var jcropApi;
    var view = this;
    var initialSelection = view.options.initialSelection;

    var _onchangeCallback = function _onchangeCallback(c) {
      view.coords = {
        topLeft: {
          x: c.x,
          y: c.y
        },
        bottomRight: {
          x: c.x2,
          y: c.y2
        }
      };
      if (view.options.onchangeCallback) {
        view.options.onchangeCallback(coords);
      }
    };

    var PADDING_VERT = 150;
    var PADDING_HORZ = 250;

    var options = {
      aspectRatio: view.options.aspectRatio,
      //onSelect: showCoords,
      onChange: _onchangeCallback,
      paddingVert: PADDING_VERT, //this is a custom feature of the forked Jcrop
      paddingHorz: PADDING_HORZ
    };

    if (view.options.aspectRatio != null) {
      options.aspectRatio = view.options.aspectRatio;
    }

    view.$image.Jcrop(options, function () {
      jcropApi = this;
      if (initialSelection) {
        console.log("initialSelection", initialSelection);
        jcropApi.setSelect([initialSelection.topLeft.x + PADDING_HORZ, initialSelection.topLeft.y + PADDING_VERT, initialSelection.bottomRight.x + PADDING_HORZ, initialSelection.bottomRight.y + PADDING_VERT]);
      }
    });
  },

  normalisePoint: function normalisePoint(point) {
    var view = this;
    return {
      x: point.x / view.imageWidth,
      y: point.y / view.imageHeight
    };
  },

  getNormalisedCoords: function getNormalisedCoords() {
    var view = this;
    return {
      topLeft: view.normalisePoint(view.coords.topLeft),
      bottomRight: view.normalisePoint(view.coords.bottomRight)
    };
  }
});

var MultimediaFormView = BaseView.extend({
  initialize: function initialize() {
    var view = this;
    view.$multimediaSelect = view.$("#id_multimedia_type");
    view.render();
  },

  events: {
    "change #id_multimedia_type": function changeId_multimedia_type(e) {
      var view = this;
      view.render();
    },

    submit: function submit(e) {
      var view = this;
      view.$multimediaSelect.prop("disabled", false);
      return;
    }
  },

  render: function render() {
    var view = this;
    view.selectedType = view.$multimediaSelect.val().toLowerCase().trim();
    if (view.selectedType == "" || view.selectedType == "  ") {
      //'  ' is because of wierd bug I can't explain
    } else {
      view.$(".reveal").show();
      view.$("." + view.selectedType).show();
      view.$multimediaSelect.prop("disabled", true);
    }
  }
});

/******************************************************************************
 ** Page specific initilisation
 ******************************************************************************/
// code that we only want initialized/executed when we are on specific pages
// the current page is determined by $('.body').data('page-slugs')
// a page can have multiple page slugs

var ensoEditorView;

/**
 * this should be called after any pages are loaded via ajax
 * TODO: this should be scoped to an element. Eg if a div is loaded
 * into a popup, only plugins inside the popup should be initialized, or
 * else elements will be initialized multiple times
 */
var initializePluginsAndWidgets = function initializePluginsAndWidgets() {
  (0, _jquery2.default)("[js-tab-set]").tabSet();
};

var pages = {
  all: function all() {
    (0, _jquery2.default)("[js-prevent-double-click]").preventDoubleClick();

    (0, _jquery2.default)(".fullscreen-spinner .spinner").spin({
      lines: 11, // The number of lines to draw
      length: 9, // The length of each line
      width: 4, // The line thickness
      radius: 6, // The radius of the inner circle
      corners: 1, // Corner roundness (0..1)
      rotate: 0, // The rotation offset
      direction: 1, // 1: clockwise, -1: counterclockwise
      //color: '#FFF' // #rgb or #rrggbb or array of colors
      color: "#333"

      //speed: 1, // Rounds per second
      //trail: 60, // Afterglow percentage
      //shadow: false, // Whether to render a shadow
      //hwaccel: false, // Whether to use hardware acceleration
      //className: 'spinner', // The CSS class to assign to the spinner
      //zIndex: 2e9, // The z-index (defaults to 2000000000)
      //top: 'auto', // Top position relative to parent in px
      //left: 'auto' // Left position relative to parent in px
    });

    (0, _jquery2.default)("[js-foreign-key-widget]").each(function (i, el) {
      new ForeignKeyWidgetView({ el: el });
    });

    (0, _jquery2.default)("[js-multiple-assets-widget]").each(function (i, el) {
      new MultipleAssetsView({ el: el });
    });

    (0, _jquery2.default)("[js-image-input-widget]").each(function (i, el) {
      new ImageAssetInputWidgetView({ el: el });
    });

    (0, _jquery2.default)("[js-image-asset-widget]").each(function (i, el) {
      new ImageAssetWidgetView({ el: el });
    });

    (0, _jquery2.default)("[js-media-asset-widget]").each(function (i, el) {
      new MediaAssetWidgetView({ el: el });
    });

    (0, _jquery2.default)("[js-asset-manager-panel]").each(function (i, el) {
      new AssetManagerPanelView({ el: el });
    });

    (0, _jquery2.default)("[js-image-gallery-edit]").each(function (i, el) {
      new GalleryEditView({ el: el });
    });

    // // WARNING: extremely ugly code ahead. It assumes there is only
    // // one 'enso-editor' (blog post) on the page
    // $('.enso-editor').each(function (i, el) {
    //     ensoEditorView = new EnsoEditorView({
    //         textareaSelector: '.enso-editor'
    //     });
    // });

    (function () {
      // select all checkboxes toggle  // TODO: make it a jquery plugin
      var $btn = (0, _jquery2.default)("#select-all-checkboxes");

      $btn.on("click", function () {
        var $form = $btn.closest("form");
        var $checkboxes = $form.find("tbody .selection input[type=checkbox]");
        var $selectedCheckboxes = $form.find("tbody .selection input[type=checkbox]:checked");
        if ($checkboxes.length === $selectedCheckboxes.length) {
          // uncheck all
          $btn.prop("checked", false);
          $selectedCheckboxes.prop("checked", false);
        } else {
          $btn.prop("checked", true);
          $checkboxes.prop("checked", true);
        }
      });
    })();

    // render the (accessible) actions select with buttons interface as a
    // dynamic drop down in the left column
    var $oldUi = (0, _jquery2.default)("[js-accessible-actions-ui]");
    var $select = $oldUi.find("select");
    var $newUi = (0, _jquery2.default)('<ul class="actions-dropdown">');
    var $form = $oldUi.closest("form");
    $oldUi.find("option").each(function (i, e) {
      var $option = (0, _jquery2.default)(e);
      if ($option.val() != "") {
        var $li = (0, _jquery2.default)("<li>").append('<a href="">' + $option.text() + "</a>").appendTo($newUi);
        $li.on("click", function (e) {
          e.preventDefault();
          $select.val($option.val());
          $form.submit();
        });
      }
    });
    (0, _jquery2.default)("[js-actions-ui]").append($newUi).ensoVerticalDropdown();

    (0, _jquery2.default)("[js-vertical-drop-down]").ensoVerticalDropdown();

    (0, _jquery2.default)(".is-live").tooltip();

    initializePluginsAndWidgets();
  },

  "ap-object-list": function apObjectList() {
    (0, _jquery2.default)("#new-object-btn").on("click", function (e) {
      e.preventDefault();
      var url = (0, _jquery2.default)(this).attr("href");
      (0, _ensoPlugins.openFormModal)({ url: url }, function (apObject) {
        apObject.id;
        window.location.href = "/object/" + apObject.id + "/update/";
      }, function () {
        (0, _jquery2.default)("#id_maker").chosen({
          no_results_text: "no results matched"
        });
      });
    });
  },

  "media-item-create-update": function mediaItemCreateUpdate() {
    globalEvents.on("enso:assetChanged", function (data) {
      (0, _jquery2.default)("#id_title").val(data.generated_title);
    });
  },

  "ap-object": function apObject() {
    (0, _jquery2.default)("[js-overview-image-link]").magnificPopup({ type: "image" });
  },

  "ap-object-create-update": function apObjectCreateUpdate() {
    (0, _jquery2.default)("#id_maker").chosen({
      no_results_text: "no results matched. click the plus button to add a maker."
    });

    mainImageData = {};
    if (typeof initial_data !== "undefined" && "main_image" in initial_data) {
      var mainImageData = initial_data.main_image;
    }
    new MainImageAssetWidgetView({
      model: new ImageAssetModel(mainImageData),
      el: (0, _jquery2.default)("#main-image").get(0)
    });
  },

  "ap-object-content-list": function apObjectContentList() {
    //todo: get this from the inner widget

    if (jQuery.fn.sortable) {
      //don't break the site if we forget to include the plugin!
      // ../jquery-plugins/ui/js/jquery-ui-1.9.2.custom.min.js
      (0, _jquery2.default)(".content-items tbody").sortable({
        axis: "y",
        stop: function stop(event, ui) {
          var $contentItems = ui.item.closest(".content-items");
          sendNewOrdering($contentItems);
        }
      });
    } else {
      console.warn("jQuery.fn.sortable not loaded");
    }

    function sendNewOrdering($contentItems) {
      var itemIds = [];
      $contentItems.find("tbody tr").each(function () {
        itemIds.push((0, _jquery2.default)(this).attr("data-item-id"));
      });
      //                $.ajax
      _jquery2.default.ajax({
        type: "POST",
        url: "/object/reorder-content-items/",
        data: { new_ordering: JSON.stringify(itemIds) }
      }).done(function (response) {});
    }
  },

  "image-asset-create-update": function imageAssetCreateUpdate() {
    (0, _jquery2.default)("[js-tabbed-fieldsets]").tabbedFieldsets();
  },

  //    'audio-asset-create-update': function() {
  //        $('[js-tabbed-fieldsets]').tabbedFieldsets();
  //    },
  //
  //    'video-asset-create-update': function() {
  //        $('[js-tabbed-fieldsets]').tabbedFieldsets();
  //    },

  "ap-collection-create-update": function apCollectionCreateUpdate() {
    (0, _jquery2.default)("[js-image-asset-widget]").each(function (i, el) {
      new ImageAssetWidgetView({ el: el });
    });
  },

  "upload-and-replace-files": function uploadAndReplaceFiles() {
    (0, _jquery2.default)("[js-bulk-upload-widget]").each(function (i, el) {
      new BulkUploadView({ el: el });
    });
  },

  //TODO: figure out away to isolate this inside the django plugin module (this shouldn't be seen by apps not including the 'apcm_multimedia' module
  "multimedia-create-update": function multimediaCreateUpdate() {
    new MultimediaFormView({
      el: (0, _jquery2.default)(".multimedia-create-update #content-main form")[0]
    });
  }
};

var currPageSlugs = $body.data("page-slugs").split(" "); //an array of page names (page may have multiple names for different levels of abstraction)

pages["all"]();
_jquery2.default.each(pages, function (pageSlug, pageInitializationFunction) {
  if (_underscore2.default.contains(currPageSlugs, pageSlug)) {
    pageInitializationFunction();
  }
});

/******************************************************************************
 ** initial Backbone model instances
 ******************************************************************************/

var bodyView = new BodyView();

var mainImage = null; //TODO: this only applies to ap object create view

/******************************************************************************
 ******************************************************************************/

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/publish.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSpin = __webpack_require__("./node_modules/react-spin/lib/main.js");

var _reactSpin2 = _interopRequireDefault(_reactSpin);

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PRODUCTION = 1;
var CONTENT_STAGING = 2;

function PublishHeading(props) {
  var target = props.target;
  if (target == null) {
    return null;
  }
  if (target == PRODUCTION) {
    return _react2.default.createElement(
      "div",
      { className: "publish-heading production" },
      _react2.default.createElement(
        "h2",
        null,
        "Publishing to Production App"
      )
    );
  }
  if (target == CONTENT_STAGING) {
    return _react2.default.createElement(
      "div",
      { className: "publish-heading preview" },
      _react2.default.createElement(
        "h2",
        null,
        "Publishing to Preview App"
      )
    );
  }
}

var PublishMessage = function (_React$PureComponent) {
  _inherits(PublishMessage, _React$PureComponent);

  function PublishMessage() {
    _classCallCheck(this, PublishMessage);

    return _possibleConstructorReturn(this, (PublishMessage.__proto__ || Object.getPrototypeOf(PublishMessage)).apply(this, arguments));
  }

  _createClass(PublishMessage, [{
    key: "getClassName",
    value: function getClassName() {
      var logLevel = this.props.message.log_level;
      return (0, _classnames2.default)({
        alert: true,
        warning: logLevel == "WARNING",
        success: logLevel == "SUCCESS",
        error: logLevel == "ERROR" || logLevel == "PUBLISH_ABORTED"
      });
    }
  }, {
    key: "getText",
    value: function getText() {
      var logLevel = this.props.message.log_level;
      var message = this.props.message.message;

      var text = message;
      switch (logLevel) {
        case "BEGIN":
          text = "generating JSON";
          break;
        case "ERROR":
        case "PUBLISH_ABORTED":
          text = "ERROR: " + message;
          break;
      }

      return text;
    }
  }, {
    key: "getSeconds",
    value: function getSeconds() {
      var seconds = this.props.message.time_taken_seconds;
      var text = "";

      if (seconds == null) {
        return "";
      }

      if (seconds < 2.0) {
        text = "less than 2 seconds";
      } else if (seconds < 60.0) {
        text = seconds + " seconds";
      } else {
        var minutes = Math.floor(seconds / 60.0);
        var remainderSeconds = seconds - minutes * 60;
        text = minutes + " minutes " + remainderSeconds + " seconds";
      }

      return " (" + text + ")";
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: this.getClassName() },
        this.getText(),
        this.getSeconds()
      );
    }
  }]);

  return PublishMessage;
}(_react2.default.PureComponent);

var PublishContainer = function (_React$Component) {
  _inherits(PublishContainer, _React$Component);

  function PublishContainer(props) {
    _classCallCheck(this, PublishContainer);

    var _this2 = _possibleConstructorReturn(this, (PublishContainer.__proto__ || Object.getPrototypeOf(PublishContainer)).call(this, props));

    _this2.state = {
      messages: [],
      publishInProgress: false,
      publishTarget: null,
      jobId: null
    };
    return _this2;
  }

  _createClass(PublishContainer, [{
    key: "onFetchMessagesTick",
    value: function onFetchMessagesTick() {
      var _this3 = this;

      if (this.state.jobId == null || this.state.publishInProgress == false) {
        return;
      }
      _jquery2.default.ajax({
        type: "GET",
        url: "/app-server-api/ajax/get-publish-status/",
        data: { job_id: this.state.jobId }
      }).done(function (response) {
        if (response.messages.length == 0) {
          return;
        }
        _this3.setState({
          messages: response.messages,
          publishInProgress: !response.finished
        });
      });
    }
  }, {
    key: "onPublishClick",
    value: function onPublishClick(evt) {
      var _this4 = this;

      evt.preventDefault();
      var button = (0, _jquery2.default)(evt.target);
      var publishTarget = button.hasClass("production") ? PRODUCTION : CONTENT_STAGING;

      _jquery2.default.get("/app-server-api/ajax/get-publish-job-id/", function (data) {
        var jobId = data.publish_job_id;
        _this4.setState({
          jobId: jobId,
          messages: [{
            message: "Starting publish routine (id " + jobId + ")"
          }]
        });
        _jquery2.default.ajax({
          type: "POST",
          url: "/app-server-api/ajax/publish/",
          data: {
            job_id: jobId,
            target: publishTarget
          }
        }).always(function (response) {
          //nothing to do here. The final update of UI status messages is handled by
          // the get_latest_messages interval.
        }).done(function (response) {
          //nothing to do here. The final update of UI status messages is handled by
          // the get_latest_messages interval.
        }).fail(function (response) {
          _this4.setState({
            publishInProgress: false,
            messages: [{
              log_level: "ERROR",
              message: response.responseText
            }]
          });
        });
      });

      (0, _jquery2.default)("[js-publish-button]").addClass("disabled");
      this.setState({
        publishTarget: publishTarget,
        publishInProgress: true
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _jquery2.default)("[js-publish-button]").on("click", this.onPublishClick.bind(this));
      window.setInterval(this.onFetchMessagesTick.bind(this), 2000);
    }
  }, {
    key: "render",
    value: function render() {
      var spinner = null;
      if (this.state.publishInProgress) {
        spinner = _react2.default.createElement(
          "div",
          { className: "spinner-container" },
          _react2.default.createElement(_reactSpin2.default, { config: { color: "#00a8bd" } })
        );
      }
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(PublishHeading, { target: this.state.publishTarget }),
        _react2.default.createElement(
          "div",
          { id: "results" },
          this.state.messages.map(function (message, index) {
            return _react2.default.createElement(PublishMessage, { message: message, key: index });
          })
        ),
        spinner
      );
    }
  }]);

  return PublishContainer;
}(_react2.default.Component);

if (document.getElementById("react-publish-container")) {
  _reactDom2.default.render(_react2.default.createElement(PublishContainer, null), document.getElementById("react-publish-container"));
}

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/third-party.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// a collection of small javascript extensions and jquery plugins collected from the web

//http://www.zehnet.de/2010/11/19/document-elementfrompoint-a-jquery-solution/
(function ($) {
  var check = false,
      isRelative = true;

  $.elementFromPoint = function (x, y) {
    if (!document.elementFromPoint) return null;

    if (!check) {
      var sl;
      if ((sl = $(document).scrollTop()) > 0) {
        isRelative = document.elementFromPoint(0, sl + $(window).height() - 1) == null;
      } else if ((sl = $(document).scrollLeft()) > 0) {
        isRelative = document.elementFromPoint(sl + $(window).width() - 1, 0) == null;
      }
      check = sl > 0;
    }

    if (!isRelative) {
      x += $(document).scrollLeft();
      y += $(document).scrollTop();
    }

    return document.elementFromPoint(x, y);
  };

  $.elementUnderMouseEvent = function (e) {
    return $.elementFromPoint(e.clientX, e.clientY);
  };
})(jQuery);

(function ($) {
  // the jquery function serializeArray serializes the array in the format [{'name':_, 'value':_}, ...], but
  // we want it in this format {'field1': value, 'field2': value,...}
  // taken from http://jsfiddle.net/sxGtM/3/
  $.fn.serializeObject = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function () {
      if (o[this.name] !== undefined) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }
        o[this.name].push(this.value || "");
      } else {
        o[this.name] = this.value || "";
      }
    });
    return o;
  };
})(jQuery);

/******************************************************************************
 ** Javascript Extensions
 ******************************************************************************/

// A var storing all useful keys for easy access
var KEYCODES = exports.KEYCODES = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  PAUSE: 19,
  CAPSLOCK: 20,
  ESC: 27,
  PAGEUP: 33,
  PAGEDOWN: 34,
  END: 35,
  HOME: 36,
  LEFTARROW: 37,
  UPARROW: 38,
  RIGHTARROW: 39,
  DOWNARROW: 40,
  INSERT: 45,
  DELETE: 46,
  "0": 48,
  "1": 49,
  "2": 50,
  "3": 51,
  "4": 52,
  "5": 53,
  "6": 54,
  "7": 55,
  "8": 56,
  "9": 57,
  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  F: 70,
  G: 71,
  H: 72,
  I: 73,
  J: 74,
  K: 75,
  L: 76,
  M: 77,
  N: 78,
  O: 79,
  P: 80,
  Q: 81,
  R: 82,
  S: 83,
  T: 84,
  U: 85,
  V: 86,
  W: 87,
  X: 88,
  Y: 89,
  Z: 90,
  "0NUMPAD": 96,
  "1NUMPAD": 97,
  "2NUMPAD": 98,
  "3NUMPAD": 99,
  "4NUMPAD": 100,
  "5NUMPAD": 101,
  "6NUMPAD": 102,
  "7NUMPAD": 103,
  "8NUMPAD": 104,
  "9NUMPAD": 105,
  MULTIPLY: 106,
  PLUS: 107,
  MINUT: 109,
  DOT: 110,
  SLASH1: 111,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  EQUAL: 187,
  COMA: 188,
  SLASH: 191,
  BACKSLASH: 220
};

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/utils/draftUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceCurrentBlockWithAtomicBlock = replaceCurrentBlockWithAtomicBlock;
exports.getCurrentContentBlock = getCurrentContentBlock;
exports.isCurrentContentBlockBlank = isCurrentContentBlockBlank;
exports.extendedConvertFromHTML = extendedConvertFromHTML;
exports.extendedConvertToHTML = extendedConvertToHTML;
exports.nativeInputToEditorState = nativeInputToEditorState;
exports.cleanHTML = cleanHTML;

var _immutable = __webpack_require__("./node_modules/immutable/dist/immutable.js");

var Immutable = _interopRequireWildcard(_immutable);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _draftJs = __webpack_require__("./node_modules/draft-js/lib/Draft.js");

var _draftConvert = __webpack_require__("./node_modules/draft-convert/lib/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function replaceCurrentBlockWithAtomicBlock(editorState, atomicBlockData) {
  var contentState = editorState.getCurrentContent();
  var currentContentBlock = getCurrentContentBlock(editorState);
  var currentBlockKey = currentContentBlock.get("key");

  var newAtomicBlock = new _draftJs.ContentBlock({
    key: currentBlockKey,
    type: "atomic",
    text: "",
    characterList: Immutable.List(),
    data: Immutable.Map(atomicBlockData)
  });

  var contentStateWithNewBlock = contentState.setIn(["blockMap", currentBlockKey], newAtomicBlock);

  return _draftJs.EditorState.push(editorState, contentStateWithNewBlock, "insert-fragment");
}
function getCurrentContentBlock(editorState) {
  var selectionState = editorState.getSelection();
  var anchorKey = selectionState.getAnchorKey();
  return editorState.getCurrentContent().getBlockForKey(anchorKey);
}

function isCurrentContentBlockBlank(editorState) {
  var currentContentBlock = getCurrentContentBlock(editorState);
  return Boolean(currentContentBlock.text === "" && currentContentBlock.type === "unstyled");
}

function extendedConvertFromHTML(html) {
  return (0, _draftConvert.convertFromHTML)({
    htmlToStyle: function htmlToStyle(nodeName, node, currentStyle) {
      if (nodeName == "sup") {
        return currentStyle.add("SUPERSCRIPT");
      }
      if (nodeName == "sub") {
        return currentStyle.add("SUBSCRIPT");
      }
      return currentStyle;
    },
    htmlToBlock: function htmlToBlock(nodeName, node) {
      if (nodeName == "div") {
        var assetId = Number((0, _jquery2.default)(node).attr("data-asset_id"));
        if (assetId > 0) {
          var type = "ap-asset";
          return {
            type: "atomic",
            data: { type: type, assetId: assetId }
          };
        }
      }
    }
  })(html);
}

function extendedConvertToHTML(contentState) {
  var result = (0, _draftConvert.convertToHTML)({
    styleToHTML: function styleToHTML(style) {
      if (style == "SUPERSCRIPT") {
        return _react2.default.createElement("sup", null);
      }
      if (style == "SUBSCRIPT") {
        return _react2.default.createElement("sub", null);
      }
    },
    blockToHTML: function blockToHTML(block) {
      if (block.type == "atomic") {
        if (block.data.type == "ap-asset") {
          return _react2.default.createElement("div", { "data-asset_id": block.data.assetId });
        }
      }
    }
  })(contentState);
  if (result == null) {
    return "";
  }
  return result;
}

function cleanContentState(contentState) {
  var blockMap = contentState.blockMap;

  var updatedBlockMap = blockMap
  // trim leading and trailing whitespace from text
  .map(function (block) {
    return block.set("text", block.text.trim());
  })
  // delete empty unstyled blocks
  .filterNot(function (block) {
    return block.text.trim() === "" && block.type === "unstyled";
  });
  // if we've ended up with an empty blockmap, return a new contentstate
  // with a single empty unstyled block
  if (updatedBlockMap.size == 0) {
    return _draftJs.ContentState.createFromText("");
  } else {
    return contentState.set("blockMap", updatedBlockMap);
  }
}

function nativeInputToEditorState(nativeInput) {
  var contentState = extendedConvertFromHTML(nativeInput.value);
  var cleanedContentState = cleanContentState(contentState);
  return _draftJs.EditorState.createWithContent(cleanedContentState);
}

function cleanHTML(html) {
  // parse html string into draft content state, then serialize it back to a
  // html string
  var contentState = extendedConvertFromHTML(html);
  var cleanedContentState = cleanContentState(contentState);
  var editorState = _draftJs.EditorState.createWithContent(cleanedContentState);
  return extendedConvertToHTML(cleanedContentState);
}

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/utils/fetch.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.csrfFetch = csrfFetch;

var _jsCookie = __webpack_require__("./node_modules/js-cookie/src/js.cookie.js");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CSRF_TOKEN = _jsCookie2.default.get("csrftoken");
function csrfFetch(url, opts) {
  var headers = {};
  if (opts && opts.headers) {
    headers = opts.headers;
  }

  return fetch(url, Object.assign({}, opts, {
    credentials: "same-origin",
    headers: Object.assign({ "X-CSRFToken": CSRF_TOKEN }, headers)
  }));
}

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/utils/gazelle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchGazellePreviewData = undefined;

var fetchGazellePreviewData = exports.fetchGazellePreviewData = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(body) {
    var resp, jsonData;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _fetch.csrfFetch)("/app-server-api/ajax/html-to-vertical-stack-json/", {
              method: "POST",
              headers: {
                "Content-Type": "application/json; charset=utf-8"
              },
              body: JSON.stringify(body)
            });

          case 2:
            resp = _context.sent;
            _context.next = 5;
            return resp.json();

          case 5:
            jsonData = _context.sent;
            return _context.abrupt("return", Immutable.fromJS(jsonData));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function fetchGazellePreviewData(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.findRef = findRef;

var _immutable = __webpack_require__("./node_modules/immutable/dist/immutable.js");

var Immutable = _interopRequireWildcard(_immutable);

var _fetch = __webpack_require__("./enso_cms/static/enso-cms/js/utils/fetch.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function findRef(gazelleData, ref) {
  var gazelleObject = gazelleData.find(function (obj) {
    return obj.get("id") == ref.get("id") && obj.get("type") == ref.get("type");
  });
  if (gazelleObject == null) {
    console.error("Could not find gazelle object", ref.toJS());
  }
  return gazelleObject;
}

/***/ }),

/***/ "./enso_cms/static/enso-cms/js/wysiwyg.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeApEditor = initializeApEditor;

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ApEditor = __webpack_require__("./enso_cms/static/enso-cms/js/components/ApEditor.js");

var _ApEditor2 = _interopRequireDefault(_ApEditor);

var _SummaryPreviewContainer = __webpack_require__("./enso_cms/static/enso-cms/js/components/SummaryPreviewContainer.js");

var _SummaryPreviewContainer2 = _interopRequireDefault(_SummaryPreviewContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var editors = [];


function updateNativeInputs() {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = editors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var editor = _step.value;

      if (editor instanceof _ApEditor2.default) {
        editor.updateNativeInput();
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function initializeApEditor(textInput) {
  (0, _jquery2.default)(textInput).prop("required", false);
  var editorMode = (0, _jquery2.default)(textInput).attr("js-ap-editor");
  var reactContainer = document.createElement("div");
  textInput.after(reactContainer);
  return _reactDom2.default.render(_react2.default.createElement(_ApEditor2.default, { nativeInput: textInput, mode: editorMode }), reactContainer);
}

var _iteratorNormalCompletion2 = true;
var _didIteratorError2 = false;
var _iteratorError2 = undefined;

try {
  for (var _iterator2 = (0, _jquery2.default)("[js-ap-editor]")[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
    var textInput = _step2.value;

    editors.push(initializeApEditor(textInput));
  }
} catch (err) {
  _didIteratorError2 = true;
  _iteratorError2 = err;
} finally {
  try {
    if (!_iteratorNormalCompletion2 && _iterator2.return) {
      _iterator2.return();
    }
  } finally {
    if (_didIteratorError2) {
      throw _iteratorError2;
    }
  }
}

var summaryPreviewContainer = (0, _jquery2.default)("[js-summary-preview]")[0];
if (summaryPreviewContainer !== undefined) {
  _reactDom2.default.render(_react2.default.createElement(_SummaryPreviewContainer2.default, { updateNativeInputsFn: updateNativeInputs }), summaryPreviewContainer);
}

/***/ }),

/***/ "./enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/bottom.html":
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__("./node_modules/nunjucks/browser/nunjucks-slim.js");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__("./node_modules/nunjucks-loader/runtime-shim.js");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/bottom.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "query")) {
output += "\n    <div class=\"status\">Showing search results</div>\n";
;
}
else {
output += "\n    <div class=\"status\">Showing ";
if(runtime.contextOrFrameLookup(context, frame, "show_related")) {
output += "related";
;
}
else {
output += "all";
;
}
output += " assets</div>\n";
;
}
output += "\n";
if(runtime.contextOrFrameLookup(context, frame, "show_related")) {
output += "\n    <a js-show-all-assets class=\"show-all-assets-btn\" href=\"\">Show all assets</a>\n";
;
}
else {
output += "\n    ";
output += " ";
output += "\n    <a js-show-related-assets class=\"show-all-assets-btn\" href=\"\">Show related assets</a>\n";
;
}
output += "\n<div class=\"asset-library-add\">\n    <a href=\"\" js-asset-library-add-btn class=\"upload-btn\" data-url=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "asset_create_multiple_url"), env.opts.autoescape);
output += "\">Upload assets</a>\n    <input id=\"asset-library-multi-file-input\" type=\"file\" multiple />\n    <p>Add files from your computer to add to this object's asset</p>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/bottom.html"] , dependencies)

/***/ }),

/***/ "./enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/item.html":
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__("./node_modules/nunjucks/browser/nunjucks-slim.js");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__("./node_modules/nunjucks-loader/runtime-shim.js");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/item.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n";
output += "\n\n\n    <img src=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "asset")),"cms_thumbnail_url")), env.opts.autoescape);
output += "\"/> <figcaption title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "asset")),"generated_title"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "asset")),"generated_title"), env.opts.autoescape);
output += "</figcaption>\n    <a href=\"\" js-edit-foreign-key-btn=\"\" class=\"edit-foreign-key-btn edit-btn\">Edit</a>\n\n</li>\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/item.html"] , dependencies)

/***/ }),

/***/ "./enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/panel.html":
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__("./node_modules/nunjucks/browser/nunjucks-slim.js");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__("./node_modules/nunjucks-loader/runtime-shim.js");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/panel.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"ap-object-assets-block\">\n    <div js-asset-manager-panel-top>\n    </div>\n    <ul js-asset-list class=\"asset-list\">\n    </ul>\n    <div class=\"asset-panel-spinner\">\n        <div class=\"spinner-wrapper\" js-asset-panel-spinner>\n        </div>\n    </div>\n    <div js-asset-manager-panel-bottom>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/panel.html"] , dependencies)

/***/ }),

/***/ "./enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/top.html":
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__("./node_modules/nunjucks/browser/nunjucks-slim.js");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__("./node_modules/nunjucks-loader/runtime-shim.js");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/top.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += " ";
output += "\n\n<form class=\"search\" id=\"asset-search-form\">\n    <input type=\"text\" id=\"asset-search-q\" placeholder=\"Search...\"><input type=\"submit\" value=\"go\" class=\"submit\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "query"), env.opts.autoescape);
output += "\">\n</form>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/top.html"] , dependencies)

/***/ }),

/***/ "./enso_cms/static/enso-cms/nunjucks-templates/asset-replace-confirm.html":
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__("./node_modules/nunjucks/browser/nunjucks-slim.js");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__("./node_modules/nunjucks-loader/runtime-shim.js");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/asset-replace-confirm.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"width-span6\">\n    <h1>Are you sure?</h1>\n    <div class=\"span-100\">\n        ";
if(runtime.contextOrFrameLookup(context, frame, "toBeReplaced")) {
output += "\n        <h3>The following files will be replaced:</h3>\n        <p>\n            ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "toBeReplaced");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("filename", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                ";
output += runtime.suppressValue(t_4, env.opts.autoescape);
output += "<br/>\n            ";
;
}
}
frame = frame.pop();
output += "\n        </p>\n        ";
;
}
output += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "notExpected")) {
output += "\n        <h3>Warning - The following files were not expected as they do not exist in the CMS. They will not be uploaded.</h3>\n        <p>\n            ";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "notExpected");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("filename", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n                ";
output += runtime.suppressValue(t_8, env.opts.autoescape);
output += "<br/>\n            ";
;
}
}
frame = frame.pop();
output += "\n        </p>\n        ";
;
}
output += "\n        <h2>Are you sure you want to go ahead?</h2>\n        <div>\n            <button class=\"cancel-button\">Cancel</button>\n            <button class=\"ok-button\">OK</button>\n        </div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/asset-replace-confirm.html"] , dependencies)

/***/ }),

/***/ "./enso_cms/static/enso-cms/nunjucks-templates/cropper.html":
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__("./node_modules/nunjucks/browser/nunjucks-slim.js");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__("./node_modules/nunjucks-loader/runtime-shim.js");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/cropper.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<h1>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += "</h1>\n<form>\n    <div class=\"form standard-form\">\n        <div class=\"form-body\">\n            <div class=\"span-100\">\n                <div class=\"form-row\">\n                    <div class=\"canvas\" style=\"margin-right:15px\">\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div style=\"clear:both\">\n        <input class=\"submit-btn btn span2\" type=\"submit\" value=\"Save\">\n    </div>\n</form>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/cropper.html"] , dependencies)

/***/ }),

/***/ "./enso_cms/static/enso-cms/nunjucks-templates/device-files-confirm.html":
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__("./node_modules/nunjucks/browser/nunjucks-slim.js");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__("./node_modules/nunjucks-loader/runtime-shim.js");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/device-files-confirm.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"width-span6\">\n    <h1>Are you sure?</h1>\n    <div class=\"span-100\">\n        ";
if(runtime.contextOrFrameLookup(context, frame, "toBeReplaced")) {
output += "\n        <h3>The following files will be replaced:</h3>\n        <p>\n            ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "toBeReplaced");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("filename", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                ";
output += runtime.suppressValue(t_4, env.opts.autoescape);
output += "<br/>\n            ";
;
}
}
frame = frame.pop();
output += "\n        </p>\n        ";
;
}
output += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "toBeCreated")) {
output += "\n        <h3>The following files will be created:</h3>\n        <p>\n            ";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "toBeCreated");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("filename", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n                ";
output += runtime.suppressValue(t_8, env.opts.autoescape);
output += "<br/>\n            ";
;
}
}
frame = frame.pop();
output += "\n        </p>\n        ";
;
}
output += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "notSupplied")) {
output += "\n        <h3>Warning - The following expected files were not supplied and will not be created or replaced:</h3>\n        <p>\n            ";
frame = frame.push();
var t_11 = runtime.contextOrFrameLookup(context, frame, "notSupplied");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("filename", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n                ";
output += runtime.suppressValue(t_12, env.opts.autoescape);
output += "<br/>\n            ";
;
}
}
frame = frame.pop();
output += "\n        </p>\n        ";
;
}
output += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "notExpected")) {
output += "\n        <h3>Warning - The following files were not expected and will be ignored:</h3>\n        <p>\n            ";
frame = frame.push();
var t_15 = runtime.contextOrFrameLookup(context, frame, "notExpected");
if(t_15) {var t_14 = t_15.length;
for(var t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13];
frame.set("filename", t_16);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
output += "\n                ";
output += runtime.suppressValue(t_16, env.opts.autoescape);
output += "<br/>\n            ";
;
}
}
frame = frame.pop();
output += "\n        </p>\n        ";
;
}
output += "\n        <h2>Are you sure you want to go ahead?</h2>\n        <div>\n            <button class=\"cancel-button\">Cancel</button>\n            <button class=\"ok-button\">OK</button>\n        </div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/device-files-confirm.html"] , dependencies)

/***/ }),

/***/ "./enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-buttons.html":
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__("./node_modules/nunjucks/browser/nunjucks-slim.js");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__("./node_modules/nunjucks-loader/runtime-shim.js");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-buttons.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "model") && runtime.contextOrFrameLookup(context, frame, "showRemoveBtn")) {
output += "\n    <a href=\"\" js-remove-foreign-key-btn class=\"remove-btn icon-btn\">Remove</a>\n";
;
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "model") && runtime.contextOrFrameLookup(context, frame, "showEditBtn")) {
output += "\n    <a href=\"\" js-edit-foreign-key-btn class=\"edit-foreign-key-btn icon-btn edit-btn\">Edit</a>\n";
;
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "showAddBtn")) {
output += "\n    <a href=\"\" js-new-foreign-key-btn class=\"new-foreign-key-btn icon-btn add-btn\">New</a>\n";
;
}
output += "\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-buttons.html"] , dependencies)

/***/ }),

/***/ "./enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-widget.html":
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__("./node_modules/nunjucks/browser/nunjucks-slim.js");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./foreign-key-buttons.html"] = __webpack_require__( "./enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-buttons.html" );




var shim = __webpack_require__("./node_modules/nunjucks-loader/runtime-shim.js");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-widget.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"buttons\">\n    ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("./foreign-key-buttons.html", false, "enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-widget.html", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
callback(null,t_1);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
callback(null,t_2);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-widget.html"] , dependencies)

/***/ }),

/***/ "./enso_cms/static/enso-cms/nunjucks-templates/widgets/image-asset-widget.html":
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__("./node_modules/nunjucks/browser/nunjucks-slim.js");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./foreign-key-buttons.html"] = __webpack_require__( "./enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-buttons.html" );




var shim = __webpack_require__("./node_modules/nunjucks-loader/runtime-shim.js");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/widgets/image-asset-widget.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "model")) {
output += "\n    <img js-drop-area=\"\" class=\"main-image drop-area\" src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "imageUrl"), env.opts.autoescape);
output += "\">\n";
;
}
else {
output += "\n    <div js-drop-area class=\"instance-not-set drop-area\"></div>\n";
;
}
output += "\n\n<div class=\"buttons\">\n    ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("./foreign-key-buttons.html", false, "enso_cms/static/enso-cms/nunjucks-templates/widgets/image-asset-widget.html", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
callback(null,t_1);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
callback(null,t_2);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n    ";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "cropButtons");
if(t_7) {var t_5;
if(runtime.isArray(t_7)) {
var t_6 = t_7.length;
for(t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5][0]
frame.set("key", t_7[t_5][0]);
var t_9 = t_7[t_5][1]
frame.set("data", t_7[t_5][1]);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n        <a href=\"\" ";
output += runtime.suppressValue(t_8, env.opts.autoescape);
output += " class=\"crop-image-btn icon-btn ";
if(runtime.memberLookup((t_9),"cropped")) {
output += "cropped";
;
}
output += "\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((t_9),"label"), env.opts.autoescape);
output += "\">Crop</a>\n    ";
;
}
} else {
t_5 = -1;
var t_6 = runtime.keys(t_7).length;
for(var t_10 in t_7) {
t_5++;
var t_11 = t_7[t_10];
frame.set("key", t_10);
frame.set("data", t_11);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n        <a href=\"\" ";
output += runtime.suppressValue(t_10, env.opts.autoescape);
output += " class=\"crop-image-btn icon-btn ";
if(runtime.memberLookup((t_11),"cropped")) {
output += "cropped";
;
}
output += "\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((t_11),"label"), env.opts.autoescape);
output += "\">Crop</a>\n    ";
;
}
}
}
frame = frame.pop();
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/widgets/image-asset-widget.html"] , dependencies)

/***/ }),

/***/ "./enso_cms/static/enso-cms/nunjucks-templates/widgets/media-asset-widget.html":
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__("./node_modules/nunjucks/browser/nunjucks-slim.js");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./foreign-key-buttons.html"] = __webpack_require__( "./enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-buttons.html" );




var shim = __webpack_require__("./node_modules/nunjucks-loader/runtime-shim.js");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/widgets/media-asset-widget.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "model")) {
output += "\n    <h3>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "model")),"title"), env.opts.autoescape);
output += "</h3>\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "model")),"media_type_slug") == "audio") {
output += "\n    <audio controls=\"controls\" class=\"preview\">\n        <source src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "model")),"cms_url"), env.opts.autoescape);
output += "\">\n    </audio>\n    ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "model")),"media_type_slug") == "video") {
output += "\n    <video controls=\"controls\" class=\"preview\">\n        <source src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "model")),"cms_url"), env.opts.autoescape);
output += "\">\n    </video>\n    ";
;
}
;
}
output += "\n";
;
}
else {
output += "\n    <div js-drop-area class=\"instance-not-set drop-area\"></div>\n";
;
}
output += "\n\n<div class=\"buttons\">\n    ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("./foreign-key-buttons.html", false, "enso_cms/static/enso-cms/nunjucks-templates/widgets/media-asset-widget.html", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
callback(null,t_1);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
callback(null,t_2);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/widgets/media-asset-widget.html"] , dependencies)

/***/ }),

/***/ "./node_modules/classnames/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ "./node_modules/draft-convert/lib/blockEntities.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _updateMutation = __webpack_require__("./node_modules/draft-convert/lib/util/updateMutation.js");

var _updateMutation2 = _interopRequireDefault(_updateMutation);

var _rangeSort = __webpack_require__("./node_modules/draft-convert/lib/util/rangeSort.js");

var _rangeSort2 = _interopRequireDefault(_rangeSort);

var _getElementHTML = __webpack_require__("./node_modules/draft-convert/lib/util/getElementHTML.js");

var _getElementHTML2 = _interopRequireDefault(_getElementHTML);

var _getElementPrefix = __webpack_require__("./node_modules/draft-convert/lib/util/getElementPrefix.js");

var _getElementPrefix2 = _interopRequireDefault(_getElementPrefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var converter = function converter() {
  var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var originalText = arguments[1];

  return originalText;
};

exports.default = function (block, entityMap) {
  var entityConverter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : converter;

  var resultText = block.text;

  var getEntityHTML = entityConverter;

  if (entityConverter.__isMiddleware) {
    getEntityHTML = entityConverter(converter);
  }

  if (Object.prototype.hasOwnProperty.call(block, 'entityRanges') && block.entityRanges.length > 0) {
    var entities = block.entityRanges.sort(_rangeSort2.default);

    var styles = block.inlineStyleRanges;

    var _loop = function _loop(index) {
      var entityRange = entities[index];
      var entity = entityMap[entityRange.key];

      var originalText = resultText.substr(entityRange.offset, entityRange.length);

      var entityHTML = getEntityHTML(entity, originalText);
      var converted = (0, _getElementHTML2.default)(entityHTML, originalText) || originalText;

      var prefixLength = (0, _getElementPrefix2.default)(entityHTML);

      var updateLaterMutation = function updateLaterMutation(mutation, mutationIndex) {
        if (mutationIndex >= index || Object.prototype.hasOwnProperty.call(mutation, 'style')) {
          return (0, _updateMutation2.default)(mutation, entityRange.offset, entityRange.length, converted.length, prefixLength);
        }
        return mutation;
      };

      entities = entities.map(updateLaterMutation);
      styles = styles.map(updateLaterMutation);

      resultText = resultText.substring(0, entityRange.offset) + converted + resultText.substring(entityRange.offset + entityRange.length);
    };

    for (var index = 0; index < entities.length; index++) {
      _loop(index);
    }

    return Object.assign({}, block, {
      text: resultText,
      inlineStyleRanges: styles,
      entityRanges: entities
    });
  }

  return block;
};

/***/ }),

/***/ "./node_modules/draft-convert/lib/blockInlineStyles.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invariant = __webpack_require__("./node_modules/invariant/browser.js");

var _invariant2 = _interopRequireDefault(_invariant);

var _styleObjectFunction = __webpack_require__("./node_modules/draft-convert/lib/util/styleObjectFunction.js");

var _styleObjectFunction2 = _interopRequireDefault(_styleObjectFunction);

var _accumulateFunction = __webpack_require__("./node_modules/draft-convert/lib/util/accumulateFunction.js");

var _accumulateFunction2 = _interopRequireDefault(_accumulateFunction);

var _getElementHTML = __webpack_require__("./node_modules/draft-convert/lib/util/getElementHTML.js");

var _getElementHTML2 = _interopRequireDefault(_getElementHTML);

var _rangeSort = __webpack_require__("./node_modules/draft-convert/lib/util/rangeSort.js");

var _rangeSort2 = _interopRequireDefault(_rangeSort);

var _defaultInlineHTML = __webpack_require__("./node_modules/draft-convert/lib/default/defaultInlineHTML.js");

var _defaultInlineHTML2 = _interopRequireDefault(_defaultInlineHTML);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var subtractStyles = function subtractStyles(original, toRemove) {
  return original.filter(function (el) {
    return !toRemove.some(function (elToRemove) {
      return elToRemove.style === el.style;
    });
  });
};

var popEndingStyles = function popEndingStyles(styleStack, endingStyles) {
  return endingStyles.reduceRight(function (stack, style) {
    var styleToRemove = stack[stack.length - 1];

    (0, _invariant2.default)(styleToRemove.style === style.style, 'Style ' + styleToRemove.style + ' to be removed doesn\'t match expected ' + style.style);

    return stack.slice(0, -1);
  }, styleStack);
};

var characterStyles = function characterStyles(offset, ranges) {
  return ranges.filter(function (range) {
    return offset >= range.offset && offset < range.offset + range.length;
  });
};

var rangeIsSubset = function rangeIsSubset(firstRange, secondRange) {
  // returns true if the second range is a subset of the first
  var secondStartWithinFirst = firstRange.offset <= secondRange.offset;
  var secondEndWithinFirst = firstRange.offset + firstRange.length >= secondRange.offset + secondRange.length;

  return secondStartWithinFirst && secondEndWithinFirst;
};

var latestStyleLast = function latestStyleLast(s1, s2) {
  // make sure longer-lasting styles are added first
  var s2endIndex = s2.offset + s2.length;
  var s1endIndex = s1.offset + s1.length;
  return s2endIndex - s1endIndex;
};

var getStylesToReset = function getStylesToReset(remainingStyles, newStyles) {
  var i = 0;
  while (i < remainingStyles.length) {
    if (newStyles.every(rangeIsSubset.bind(null, remainingStyles[i]))) {
      i++;
    } else {
      return remainingStyles.slice(i);
    }
  }
  return [];
};

var appendStartMarkup = function appendStartMarkup(inlineHTML, string, styleRange) {
  return string + (0, _getElementHTML2.default)(inlineHTML(styleRange.style)).start;
};

var prependEndMarkup = function prependEndMarkup(inlineHTML, string, styleRange) {
  return (0, _getElementHTML2.default)(inlineHTML(styleRange.style)).end + string;
};

var defaultCustomInlineHTML = function defaultCustomInlineHTML(next) {
  return function (style) {
    return next(style);
  };
};
defaultCustomInlineHTML.__isMiddleware = true;

exports.default = function (rawBlock) {
  var customInlineHTML = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCustomInlineHTML;

  (0, _invariant2.default)(rawBlock !== null && rawBlock !== undefined, 'Expected raw block to be non-null');

  var inlineHTML = void 0;
  if (customInlineHTML.__isMiddleware === true) {
    inlineHTML = customInlineHTML(_defaultInlineHTML2.default);
  } else {
    inlineHTML = (0, _accumulateFunction2.default)((0, _styleObjectFunction2.default)(customInlineHTML), (0, _styleObjectFunction2.default)(_defaultInlineHTML2.default));
  }

  var result = '';
  var styleStack = [];

  var sortedRanges = rawBlock.inlineStyleRanges.sort(_rangeSort2.default);

  for (var i = 0; i < rawBlock.text.length; i++) {
    var styles = characterStyles(i, sortedRanges);

    var endingStyles = subtractStyles(styleStack, styles);
    var newStyles = subtractStyles(styles, styleStack);
    var remainingStyles = subtractStyles(styleStack, endingStyles);

    // reset styles: look for any already existing styles that will need to
    // end before styles that are being added on this character. to solve this
    // close out those current tags and all nested children,
    // then open new ones nested within the new styles.
    var resetStyles = getStylesToReset(remainingStyles, newStyles);

    var openingStyles = resetStyles.concat(newStyles).sort(latestStyleLast);

    var openingStyleTags = openingStyles.reduce(appendStartMarkup.bind(null, inlineHTML), '');
    var endingStyleTags = endingStyles.concat(resetStyles).reduce(prependEndMarkup.bind(null, inlineHTML), '');

    result += endingStyleTags + openingStyleTags + rawBlock.text[i];

    styleStack = popEndingStyles(styleStack, resetStyles.concat(endingStyles));
    styleStack = styleStack.concat(openingStyles);

    (0, _invariant2.default)(styleStack.length === styles.length, 'Character ' + i + ': ' + (styleStack.length - styles.length) + ' styles left on stack that should no longer be there');
  }

  result = styleStack.reduceRight(function (res, openStyle) {
    return res + (0, _getElementHTML2.default)(inlineHTML(openStyle.style)).end;
  }, result);

  return result;
};

/***/ }),

/***/ "./node_modules/draft-convert/lib/convertFromHTML.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright (c) 2013-present, Facebook, Inc.
                                                                                                                                                                                                                                                                               * All rights reserved.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Copyright (c) 2013-present, Facebook, Inc.
                                                                                                                                                                                                                                                                               * All rights reserved.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                               * LICENSE file in the /src directory of this source tree. An additional grant
                                                                                                                                                                                                                                                                               * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                                                                                                                                                                               */

var _immutable = __webpack_require__("./node_modules/draft-convert/node_modules/immutable/dist/immutable.js");

var _draftJs = __webpack_require__("./node_modules/draft-js/lib/Draft.js");

var _parseHTML = __webpack_require__("./node_modules/draft-convert/lib/util/parseHTML.js");

var _parseHTML2 = _interopRequireDefault(_parseHTML);

var _rangeSort = __webpack_require__("./node_modules/draft-convert/lib/util/rangeSort.js");

var _rangeSort2 = _interopRequireDefault(_rangeSort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NBSP = '&nbsp;';
var SPACE = ' ';

// Arbitrary max indent
var MAX_DEPTH = 4;

// used for replacing characters in HTML
/* eslint-disable no-control-regex */
var REGEX_CR = new RegExp('\r', 'g');
var REGEX_LF = new RegExp('\n', 'g');
var REGEX_NBSP = new RegExp(NBSP, 'g');
var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');
/* eslint-enable no-control-regex */

// Block tag flow is different because LIs do not have
// a deterministic style ;_;
var blockTags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'blockquote', 'pre'];
var inlineTags = {
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE'
};

var handleMiddleware = function handleMiddleware(maybeMiddleware, base) {
  if (maybeMiddleware && maybeMiddleware.__isMiddleware === true) {
    return maybeMiddleware(base);
  }

  return maybeMiddleware;
};

var defaultHTMLToBlock = function defaultHTMLToBlock(nodeName, node, lastList) {
  return undefined;
};

var defaultHTMLToStyle = function defaultHTMLToStyle(nodeName, node, currentStyle) {
  return currentStyle;
};

var defaultHTMLToEntity = function defaultHTMLToEntity(nodeName, node) {
  return undefined;
};

var defaultTextToEntity = function defaultTextToEntity(text) {
  return [];
};

var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }
  throw new Error('Got unexpected null or undefined');
};

var sanitizeDraftText = function sanitizeDraftText(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, '');
};

function getEmptyChunk() {
  return {
    text: '',
    inlines: [],
    entities: [],
    blocks: []
  };
}

function getWhitespaceChunk(inEntity) {
  var entities = new Array(1);
  if (inEntity) {
    entities[0] = inEntity;
  }
  return {
    text: SPACE,
    inlines: [(0, _immutable.OrderedSet)()],
    entities: entities,
    blocks: []
  };
}

function getSoftNewlineChunk(block, depth) {
  var flat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (0, _immutable.Map)();

  if (flat === true) {
    return {
      text: '\r',
      inlines: [(0, _immutable.OrderedSet)()],
      entities: new Array(1),
      blocks: [{
        type: block,
        data: data,
        depth: Math.max(0, Math.min(MAX_DEPTH, depth))
      }],
      isNewline: true
    };
  }

  return {
    text: '\n',
    inlines: [(0, _immutable.OrderedSet)()],
    entities: new Array(1),
    blocks: []
  };
}

function getBlockDividerChunk(block, depth) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _immutable.Map)();

  return {
    text: '\r',
    inlines: [(0, _immutable.OrderedSet)()],
    entities: new Array(1),
    blocks: [{
      type: block,
      data: data,
      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
    }]
  };
}

function getBlockTypeForTag(tag, lastList) {
  switch (tag) {
    case 'h1':
      return 'header-one';
    case 'h2':
      return 'header-two';
    case 'h3':
      return 'header-three';
    case 'h4':
      return 'header-four';
    case 'h5':
      return 'header-five';
    case 'h6':
      return 'header-six';
    case 'li':
      if (lastList === 'ol') {
        return 'ordered-list-item';
      }
      return 'unordered-list-item';
    case 'blockquote':
      return 'blockquote';
    case 'pre':
      return 'code-block';
    case 'div':
    case 'p':
      return 'unstyled';
    default:
      return null;
  }
}

function baseCheckBlockType(nodeName, node, lastList) {
  return getBlockTypeForTag(nodeName, lastList);
}

function processInlineTag(tag, node, currentStyle) {
  var styleToCheck = inlineTags[tag];
  if (styleToCheck) {
    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
  } else if (node instanceof HTMLElement) {
    (function () {
      var htmlElement = node;
      currentStyle = currentStyle.withMutations(function (style) {
        if (htmlElement.style.fontWeight === 'bold') {
          style.add('BOLD');
        }

        if (htmlElement.style.fontStyle === 'italic') {
          style.add('ITALIC');
        }

        if (htmlElement.style.textDecoration === 'underline') {
          style.add('UNDERLINE');
        }

        if (htmlElement.style.textDecoration === 'line-through') {
          style.add('STRIKETHROUGH');
        }
      }).toOrderedSet();
    })();
  }
  return currentStyle;
}

function baseProcessInlineTag(tag, node) {
  return processInlineTag(tag, node, (0, _immutable.OrderedSet)());
}

function joinChunks(A, B) {
  var flat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  // Sometimes two blocks will touch in the DOM and we need to strip the
  // extra delimiter to preserve niceness.
  var firstInB = B.text.slice(0, 1);
  var lastInA = A.text.slice(-1);

  var adjacentDividers = lastInA === '\r' && firstInB === '\r';
  var isJoiningBlocks = A.text !== '\r' && B.text !== '\r'; // when joining two full blocks like this we want to pop one divider
  var addingNewlineToEmptyBlock = A.text === '\r' && !A.isNewline && B.isNewline; // when joining a newline to an empty block we want to remove the newline

  if (adjacentDividers && (isJoiningBlocks || addingNewlineToEmptyBlock)) {
    A.text = A.text.slice(0, -1);
    A.inlines.pop();
    A.entities.pop();
    A.blocks.pop();
  }

  // Kill whitespace after blocks if flat mode is on
  if (A.text.slice(-1) === '\r' && flat === true) {
    if (B.text === SPACE || B.text === '\n') {
      return A;
    } else if (firstInB === SPACE || firstInB === '\n') {
      B.text = B.text.slice(1);
      B.inlines.shift();
      B.entities.shift();
    }
  }

  var isNewline = A.text.length === 0 && B.isNewline;

  return {
    text: A.text + B.text,
    inlines: A.inlines.concat(B.inlines),
    entities: A.entities.concat(B.entities),
    blocks: A.blocks.concat(B.blocks),
    isNewline: isNewline
  };
}

/*
 * Check to see if we have anything like <p> <blockquote> <h1>... to create
 * block tags from. If we do, we can use those and ignore <div> tags. If we
 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
 */
function containsSemanticBlockMarkup(html) {
  return blockTags.some(function (tag) {
    return html.indexOf('<' + tag) !== -1;
  });
}

function genFragment(node, inlineStyle, lastList, inBlock, fragmentBlockTags, depth, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, options, inEntity) {
  var nodeName = node.nodeName.toLowerCase();
  var newBlock = false;
  var nextBlockType = 'unstyled';

  // Base Case
  if (nodeName === '#text') {
    var _ret2 = function () {
      var text = node.textContent;
      if (text.trim() === '' && inBlock === null) {
        return {
          v: getEmptyChunk()
        };
      }

      if (text.trim() === '' && inBlock !== 'code-block') {
        return {
          v: getWhitespaceChunk(inEntity)
        };
      }
      if (inBlock !== 'code-block') {
        // Can't use empty string because MSWord
        text = text.replace(REGEX_LF, SPACE);
      }

      var entities = Array(text.length).fill(inEntity);

      var offsetChange = 0;
      var textEntities = checkEntityText(text).sort(_rangeSort2.default);
      textEntities.forEach(function (_ref) {
        var entity = _ref.entity,
            offset = _ref.offset,
            length = _ref.length,
            result = _ref.result;

        var adjustedOffset = offset + offsetChange;

        if (result === null || result === undefined) {
          result = text.substr(adjustedOffset, length);
        }

        var textArray = text.split('');
        textArray.splice.bind(textArray, adjustedOffset, length).apply(textArray, result.split(''));
        text = textArray.join('');

        entities.splice.bind(entities, adjustedOffset, length).apply(entities, Array(result.length).fill(entity));
        offsetChange += result.length - length;
      });

      return {
        v: {
          text: text,
          inlines: Array(text.length).fill(inlineStyle),
          entities: entities,
          blocks: []
        }
      };
    }();

    if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
  }

  // BR tags
  if (nodeName === 'br') {
    var _blockType = inBlock;

    if (_blockType === null) {
      //  BR tag is at top level, treat it as an unstyled block
      return getSoftNewlineChunk('unstyled', depth, true);
    }

    return getSoftNewlineChunk(_blockType || 'unstyled', depth, options.flat);
  }

  var chunk = getEmptyChunk();
  var newChunk = null;

  // Inline tags
  inlineStyle = processInlineTag(nodeName, node, inlineStyle);
  inlineStyle = processCustomInlineStyles(nodeName, node, inlineStyle);

  // Handle lists
  if (nodeName === 'ul' || nodeName === 'ol') {
    if (lastList) {
      depth += 1;
    }
    lastList = nodeName;
    inBlock = null;
  }

  // Block Tags
  var blockInfo = checkBlockType(nodeName, node, lastList, inBlock) || {};
  var blockType = void 0;
  var blockDataMap = void 0;
  if (typeof blockInfo === 'string') {
    blockType = blockInfo;
    blockDataMap = (0, _immutable.Map)();
  } else {
    blockType = typeof blockInfo === 'string' ? blockInfo : blockInfo.type;
    blockDataMap = blockInfo.data ? (0, _immutable.Map)(blockInfo.data) : (0, _immutable.Map)();
  }
  if (!inBlock && (fragmentBlockTags.indexOf(nodeName) !== -1 || blockType)) {
    chunk = getBlockDividerChunk(blockType || getBlockTypeForTag(nodeName, lastList), depth, blockDataMap);
    inBlock = blockType || getBlockTypeForTag(nodeName, lastList);
    newBlock = true;
  } else if (lastList && (inBlock === 'ordered-list-item' || inBlock === 'unordered-list-item') && nodeName === 'li') {
    var listItemBlockType = getBlockTypeForTag(nodeName, lastList);
    chunk = getBlockDividerChunk(listItemBlockType, depth);
    inBlock = listItemBlockType;
    newBlock = true;
    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
  } else if (inBlock && inBlock !== 'atomic' && blockType === 'atomic') {
    inBlock = blockType;
    newBlock = true;
    chunk = getSoftNewlineChunk(blockType, depth, true, // atomic blocks within non-atomic blocks must always be split out
    blockDataMap);
  }

  // Recurse through children
  var child = node.firstChild;

  // hack to allow conversion of atomic blocks from HTML (e.g. <figure><img
  // src="..." /></figure>). since metadata must be stored on an entity text
  // must exist for the entity to apply to. the way chunks are joined strips
  // whitespace at the end so it cannot be a space character.

  if (child == null && inEntity && (blockType === 'atomic' || inBlock === 'atomic')) {
    child = document.createTextNode('a');
  }

  if (child != null) {
    nodeName = child.nodeName.toLowerCase();
  }

  var entityId = null;

  while (child) {
    entityId = checkEntityNode(nodeName, child);

    newChunk = genFragment(child, inlineStyle, lastList, inBlock, fragmentBlockTags, depth, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, options, entityId || inEntity);

    chunk = joinChunks(chunk, newChunk, options.flat);
    var sibling = child.nextSibling;

    // Put in a newline to break up blocks inside blocks
    if (sibling && fragmentBlockTags.indexOf(nodeName) >= 0 && inBlock) {
      var newBlockInfo = checkBlockType(nodeName, child, lastList, inBlock) || {};

      var newBlockType = void 0;
      var newBlockData = void 0;

      if (typeof newBlockInfo === 'string') {
        newBlockType = newBlockInfo;
        newBlockData = (0, _immutable.Map)();
      } else {
        newBlockType = newBlockInfo.type || getBlockTypeForTag(nodeName, lastList);
        newBlockData = newBlockInfo.data ? (0, _immutable.Map)(newBlockInfo.data) : (0, _immutable.Map)();
      }

      chunk = joinChunks(chunk, getSoftNewlineChunk(newBlockType, depth, options.flat, newBlockData), options.flat);
    }
    if (sibling) {
      nodeName = sibling.nodeName.toLowerCase();
    }
    child = sibling;
  }

  if (newBlock) {
    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, (0, _immutable.Map)()), options.flat);
  }

  return chunk;
}

function getChunkForHTML(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, options, DOMBuilder) {
  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE);

  var safeBody = DOMBuilder(html);
  if (!safeBody) {
    return null;
  }

  // Sometimes we aren't dealing with content that contains nice semantic
  // tags. In this case, use divs to separate everything out into paragraphs
  // and hope for the best.
  var workingBlocks = containsSemanticBlockMarkup(html) ? blockTags.concat(['div']) : ['div'];

  // Start with -1 block depth to offset the fact that we are passing in a fake
  // UL block to sta rt with.
  var chunk = genFragment(safeBody, (0, _immutable.OrderedSet)(), 'ul', null, workingBlocks, -1, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, options);

  // join with previous block to prevent weirdness on paste
  if (chunk.text.indexOf('\r') === 0) {
    chunk = {
      text: chunk.text.slice(1),
      inlines: chunk.inlines.slice(1),
      entities: chunk.entities.slice(1),
      blocks: chunk.blocks
    };
  }

  // Kill block delimiter at the end
  if (chunk.text.slice(-1) === '\r') {
    chunk.text = chunk.text.slice(0, -1);
    chunk.inlines = chunk.inlines.slice(0, -1);
    chunk.entities = chunk.entities.slice(0, -1);
    chunk.blocks.pop();
  }

  // If we saw no block tags, put an unstyled one in
  if (chunk.blocks.length === 0) {
    chunk.blocks.push({ type: 'unstyled', data: (0, _immutable.Map)(), depth: 0 });
  }

  // Sometimes we start with text that isn't in a block, which is then
  // followed by blocks. Need to fix up the blocks to add in
  // an unstyled block for this content
  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
    chunk.blocks.unshift({ type: 'unstyled', data: (0, _immutable.Map)(), depth: 0 });
  }

  return chunk;
}

function convertFromHTMLtoContentBlocks(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, options, DOMBuilder) {
  // Be ABSOLUTELY SURE that the dom builder you pass hare won't execute
  // arbitrary code in whatever environment you're running this in. For an
  // example of how we try to do this in-browser, see getSafeBodyFromHTML.

  var chunk = getChunkForHTML(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, options, DOMBuilder);
  if (chunk == null) {
    return [];
  }
  var start = 0;
  return chunk.text.split('\r').map(function (textBlock, blockIndex) {
    // Make absolutely certain that our text is acceptable.
    textBlock = sanitizeDraftText(textBlock);
    var end = start + textBlock.length;
    var inlines = nullthrows(chunk).inlines.slice(start, end);
    var entities = nullthrows(chunk).entities.slice(start, end);
    var characterList = (0, _immutable.List)(inlines.map(function (style, entityIndex) {
      var data = { style: style, entity: null };
      if (entities[entityIndex]) {
        data.entity = entities[entityIndex];
      }
      return _draftJs.CharacterMetadata.create(data);
    }));
    start = end + 1;

    return new _draftJs.ContentBlock({
      key: (0, _draftJs.genKey)(),
      type: nullthrows(chunk).blocks[blockIndex].type,
      data: nullthrows(chunk).blocks[blockIndex].data,
      depth: nullthrows(chunk).blocks[blockIndex].depth,
      text: textBlock,
      characterList: characterList
    });
  });
}

var convertFromHTML = function convertFromHTML(_ref2) {
  var _ref2$htmlToStyle = _ref2.htmlToStyle,
      htmlToStyle = _ref2$htmlToStyle === undefined ? defaultHTMLToStyle : _ref2$htmlToStyle,
      _ref2$htmlToEntity = _ref2.htmlToEntity,
      htmlToEntity = _ref2$htmlToEntity === undefined ? defaultHTMLToEntity : _ref2$htmlToEntity,
      _ref2$textToEntity = _ref2.textToEntity,
      textToEntity = _ref2$textToEntity === undefined ? defaultTextToEntity : _ref2$textToEntity,
      _ref2$htmlToBlock = _ref2.htmlToBlock,
      htmlToBlock = _ref2$htmlToBlock === undefined ? defaultHTMLToBlock : _ref2$htmlToBlock;
  return function (html) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      flat: false
    };
    var DOMBuilder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _parseHTML2.default;

    return _draftJs.ContentState.createFromBlockArray(convertFromHTMLtoContentBlocks(html, handleMiddleware(htmlToStyle, baseProcessInlineTag), handleMiddleware(htmlToEntity, defaultHTMLToEntity), handleMiddleware(textToEntity, defaultTextToEntity), handleMiddleware(htmlToBlock, baseCheckBlockType), options, DOMBuilder));
  };
};

exports.default = function () {
  if (arguments.length >= 1 && typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
    return convertFromHTML({}).apply(undefined, arguments);
  }
  return convertFromHTML.apply(undefined, arguments);
};

/***/ }),

/***/ "./node_modules/draft-convert/lib/convertToHTML.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invariant = __webpack_require__("./node_modules/invariant/browser.js");

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _server = __webpack_require__("./node_modules/react-dom/server.js");

var _server2 = _interopRequireDefault(_server);

var _draftJs = __webpack_require__("./node_modules/draft-js/lib/Draft.js");

var _encodeBlock = __webpack_require__("./node_modules/draft-convert/lib/encodeBlock.js");

var _encodeBlock2 = _interopRequireDefault(_encodeBlock);

var _blockEntities = __webpack_require__("./node_modules/draft-convert/lib/blockEntities.js");

var _blockEntities2 = _interopRequireDefault(_blockEntities);

var _blockInlineStyles = __webpack_require__("./node_modules/draft-convert/lib/blockInlineStyles.js");

var _blockInlineStyles2 = _interopRequireDefault(_blockInlineStyles);

var _accumulateFunction = __webpack_require__("./node_modules/draft-convert/lib/util/accumulateFunction.js");

var _accumulateFunction2 = _interopRequireDefault(_accumulateFunction);

var _blockTypeObjectFunction = __webpack_require__("./node_modules/draft-convert/lib/util/blockTypeObjectFunction.js");

var _blockTypeObjectFunction2 = _interopRequireDefault(_blockTypeObjectFunction);

var _getBlockTags = __webpack_require__("./node_modules/draft-convert/lib/util/getBlockTags.js");

var _getBlockTags2 = _interopRequireDefault(_getBlockTags);

var _getNestedBlockTags = __webpack_require__("./node_modules/draft-convert/lib/util/getNestedBlockTags.js");

var _getNestedBlockTags2 = _interopRequireDefault(_getNestedBlockTags);

var _defaultBlockHTML = __webpack_require__("./node_modules/draft-convert/lib/default/defaultBlockHTML.js");

var _defaultBlockHTML2 = _interopRequireDefault(_defaultBlockHTML);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Immutable from 'immutable'; // eslint-disable-line no-unused-vars
var NESTED_BLOCK_TYPES = ['ordered-list-item', 'unordered-list-item'];

var defaultEntityToHTML = function defaultEntityToHTML(entity, originalText) {
  return originalText;
};

var convertToHTML = function convertToHTML(_ref) {
  var _ref$styleToHTML = _ref.styleToHTML,
      styleToHTML = _ref$styleToHTML === undefined ? {} : _ref$styleToHTML,
      _ref$blockToHTML = _ref.blockToHTML,
      blockToHTML = _ref$blockToHTML === undefined ? {} : _ref$blockToHTML,
      _ref$entityToHTML = _ref.entityToHTML,
      entityToHTML = _ref$entityToHTML === undefined ? defaultEntityToHTML : _ref$entityToHTML;
  return function (contentState) {
    (0, _invariant2.default)(contentState !== null && contentState !== undefined, 'Expected contentState to be non-null');

    var getBlockHTML = void 0;
    if (blockToHTML.__isMiddleware === true) {
      getBlockHTML = blockToHTML((0, _blockTypeObjectFunction2.default)(_defaultBlockHTML2.default));
    } else {
      getBlockHTML = (0, _accumulateFunction2.default)((0, _blockTypeObjectFunction2.default)(blockToHTML), (0, _blockTypeObjectFunction2.default)(_defaultBlockHTML2.default));
    }

    var rawState = (0, _draftJs.convertToRaw)(contentState);

    var listStack = [];

    var result = rawState.blocks.map(function (block) {
      var type = block.type,
          depth = block.depth;


      var closeNestTags = '';
      var openNestTags = '';

      if (NESTED_BLOCK_TYPES.indexOf(type) === -1) {
        // this block can't be nested, so reset all nesting if necessary
        closeNestTags = listStack.reduceRight(function (string, nestedBlock) {
          return string + (0, _getNestedBlockTags2.default)(getBlockHTML(nestedBlock)).nestEnd;
        }, '');
        listStack = [];
      } else {
        while (depth + 1 !== listStack.length || type !== listStack[depth].type) {
          if (depth + 1 === listStack.length) {
            // depth is right but doesn't match type
            var blockToClose = listStack[depth];
            closeNestTags += (0, _getNestedBlockTags2.default)(getBlockHTML(blockToClose)).nestEnd;
            openNestTags += (0, _getNestedBlockTags2.default)(getBlockHTML(block)).nestStart;
            listStack[depth] = block;
          } else if (depth + 1 < listStack.length) {
            var _blockToClose = listStack[listStack.length - 1];
            closeNestTags += (0, _getNestedBlockTags2.default)(getBlockHTML(_blockToClose)).nestEnd;
            listStack = listStack.slice(0, -1);
          } else {
            openNestTags += (0, _getNestedBlockTags2.default)(getBlockHTML(block)).nestStart;
            listStack.push(block);
          }
        }
      }

      var innerHTML = (0, _blockInlineStyles2.default)((0, _blockEntities2.default)((0, _encodeBlock2.default)(block), rawState.entityMap, entityToHTML), styleToHTML);

      var blockHTML = (0, _getBlockTags2.default)(getBlockHTML(block));

      var html = void 0;

      if (typeof blockHTML === 'string') {
        html = blockHTML;
      } else {
        html = blockHTML.start + innerHTML + blockHTML.end;
      }

      if (innerHTML.length === 0 && Object.prototype.hasOwnProperty.call(blockHTML, 'empty')) {
        if (_react2.default.isValidElement(blockHTML.empty)) {
          html = _server2.default.renderToStaticMarkup(blockHTML.empty);
        } else {
          html = blockHTML.empty;
        }
      }

      return closeNestTags + openNestTags + html;
    }).join('');

    result = listStack.reduce(function (res, nestBlock) {
      return res + (0, _getNestedBlockTags2.default)(getBlockHTML(nestBlock)).nestEnd;
    }, result);

    return result;
  };
};

exports.default = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length === 1 && Object.prototype.hasOwnProperty.call(args[0], '_map') && args[0].getBlockMap != null) {
    // skip higher-order function and use defaults
    return convertToHTML({}).apply(undefined, args);
  }

  return convertToHTML.apply(undefined, args);
};

/***/ }),

/***/ "./node_modules/draft-convert/lib/default/defaultBlockHTML.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  'unstyled': _react2.default.createElement('p', null),
  'paragraph': _react2.default.createElement('p', null),
  'header-one': _react2.default.createElement('h1', null),
  'header-two': _react2.default.createElement('h2', null),
  'header-three': _react2.default.createElement('h3', null),
  'header-four': _react2.default.createElement('h4', null),
  'header-five': _react2.default.createElement('h5', null),
  'header-six': _react2.default.createElement('h6', null),
  'blockquote': _react2.default.createElement('blockquote', null),
  'unordered-list-item': {
    element: _react2.default.createElement('li', null),
    nest: _react2.default.createElement('ul', null)
  },
  'ordered-list-item': {
    element: _react2.default.createElement('li', null),
    nest: _react2.default.createElement('ol', null)
  },
  'media': _react2.default.createElement('figure', null)
};

/***/ }),

/***/ "./node_modules/draft-convert/lib/default/defaultInlineHTML.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultInlineHTML;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultInlineHTML(style) {
  switch (style) {
    case 'BOLD':
      return _react2.default.createElement('strong', null);
    case 'ITALIC':
      return _react2.default.createElement('em', null);
    case 'UNDERLINE':
      return _react2.default.createElement('u', null);
    case 'CODE':
      return _react2.default.createElement('code', null);
    default:
      return {
        start: '',
        end: ''
      };
  }
}

/***/ }),

/***/ "./node_modules/draft-convert/lib/encodeBlock.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _updateMutation = __webpack_require__("./node_modules/draft-convert/lib/util/updateMutation.js");

var _updateMutation2 = _interopRequireDefault(_updateMutation);

var _rangeSort = __webpack_require__("./node_modules/draft-convert/lib/util/rangeSort.js");

var _rangeSort2 = _interopRequireDefault(_rangeSort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTITY_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '\n': '<br/>'
};

exports.default = function (block) {
  var blockText = block.text;

  var entities = block.entityRanges.sort(_rangeSort2.default);
  var styles = block.inlineStyleRanges.sort(_rangeSort2.default);
  var resultText = '';

  var _loop = function _loop(index) {
    var char = blockText[index];

    if (ENTITY_MAP[char] !== undefined) {
      (function () {
        var encoded = ENTITY_MAP[char];
        var resultIndex = resultText.length;
        resultText += encoded;

        var updateForChar = function updateForChar(mutation) {
          return (0, _updateMutation2.default)(mutation, resultIndex, char.length, encoded.length, 0);
        };

        entities = entities.map(updateForChar);
        styles = styles.map(updateForChar);
      })();
    } else {
      resultText += char;
    }
  };

  for (var index = 0; index < blockText.length; index++) {
    _loop(index);
  }

  return Object.assign({}, block, {
    text: resultText,
    inlineStyleRanges: styles,
    entityRanges: entities
  });
};

/***/ }),

/***/ "./node_modules/draft-convert/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseHTML = exports.convertFromHTML = exports.convertToHTML = undefined;

var _convertToHTML = __webpack_require__("./node_modules/draft-convert/lib/convertToHTML.js");

var _convertToHTML2 = _interopRequireDefault(_convertToHTML);

var _convertFromHTML = __webpack_require__("./node_modules/draft-convert/lib/convertFromHTML.js");

var _convertFromHTML2 = _interopRequireDefault(_convertFromHTML);

var _parseHTML = __webpack_require__("./node_modules/draft-convert/lib/util/parseHTML.js");

var _parseHTML2 = _interopRequireDefault(_parseHTML);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.convertToHTML = _convertToHTML2.default;
exports.convertFromHTML = _convertFromHTML2.default;
exports.parseHTML = _parseHTML2.default;

/***/ }),

/***/ "./node_modules/draft-convert/lib/util/accumulateFunction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (newFn, rest) {
  return function () {
    var newResult = newFn.apply(undefined, arguments);
    if (newResult !== undefined && newResult !== null) {
      return newResult;
    }

    return rest.apply(undefined, arguments);
  };
};

/***/ }),

/***/ "./node_modules/draft-convert/lib/util/blockTypeObjectFunction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (typeObject) {
  return function (block) {
    if (typeof typeObject === 'function') {
      // handle case where typeObject is already a function
      return typeObject(block);
    }

    return typeObject[block.type];
  };
};

/***/ }),

/***/ "./node_modules/draft-convert/lib/util/getBlockTags.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBlockTags;

var _invariant = __webpack_require__("./node_modules/invariant/browser.js");

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _server = __webpack_require__("./node_modules/react-dom/server.js");

var _server2 = _interopRequireDefault(_server);

var _splitReactElement = __webpack_require__("./node_modules/draft-convert/lib/util/splitReactElement.js");

var _splitReactElement2 = _interopRequireDefault(_splitReactElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasChildren(element) {
  return _react2.default.isValidElement(element) && _react2.default.Children.count(element.props.children) > 0;
}

function getBlockTags(blockHTML) {
  (0, _invariant2.default)(blockHTML !== null && blockHTML !== undefined, 'Expected block HTML value to be non-null');

  if (_react2.default.isValidElement(blockHTML)) {
    if (hasChildren(blockHTML)) {
      return _server2.default.renderToStaticMarkup(blockHTML);
    }

    return (0, _splitReactElement2.default)(blockHTML);
  }

  if (Object.prototype.hasOwnProperty.call(blockHTML, 'element') && _react2.default.isValidElement(blockHTML.element)) {
    return Object.assign({}, blockHTML, (0, _splitReactElement2.default)(blockHTML.element));
  }

  (0, _invariant2.default)(Object.prototype.hasOwnProperty.call(blockHTML, 'start') && Object.prototype.hasOwnProperty.call(blockHTML, 'end'), 'convertToHTML: received block information without either a ReactElement or an object with start/end tags');

  return blockHTML;
}

/***/ }),

/***/ "./node_modules/draft-convert/lib/util/getElementHTML.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getElementHTML;

var _invariant = __webpack_require__("./node_modules/invariant/browser.js");

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _server = __webpack_require__("./node_modules/react-dom/server.js");

var _server2 = _interopRequireDefault(_server);

var _splitReactElement = __webpack_require__("./node_modules/draft-convert/lib/util/splitReactElement.js");

var _splitReactElement2 = _interopRequireDefault(_splitReactElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasChildren(element) {
  return _react2.default.isValidElement(element) && _react2.default.Children.count(element.props.children) > 0;
}

function getElementHTML(element) {
  var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (element === undefined || element === null) {
    return element;
  }

  if (typeof element === 'string') {
    return element;
  }

  if (_react2.default.isValidElement(element)) {
    if (hasChildren(element)) {
      return _server2.default.renderToStaticMarkup(element);
    }

    var tags = (0, _splitReactElement2.default)(element);

    if (text !== null) {
      var start = tags.start,
          end = tags.end;

      return start + text + end;
    }

    return tags;
  }

  (0, _invariant2.default)(Object.prototype.hasOwnProperty.call(element, 'start') && Object.prototype.hasOwnProperty.call(element, 'end'), 'convertToHTML: received conversion data without either an HTML string, ReactElement or an object with start/end tags');

  if (text !== null) {
    var _start = element.start,
        _end = element.end;

    return _start + text + _end;
  }

  return element;
}

/***/ }),

/***/ "./node_modules/draft-convert/lib/util/getElementPrefix.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _splitReactElement = __webpack_require__("./node_modules/draft-convert/lib/util/splitReactElement.js");

var _splitReactElement2 = _interopRequireDefault(_splitReactElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (element) {
  if (_react2.default.isValidElement(element) && _react2.default.Children.count(element.props.children) === 0) {
    return (0, _splitReactElement2.default)(element).start.length;
  }

  if ((typeof element === 'undefined' ? 'undefined' : _typeof(element)) === 'object') {
    return element.start ? element.start.length : 0;
  }

  return 0;
};

/***/ }),

/***/ "./node_modules/draft-convert/lib/util/getNestedBlockTags.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getNestedBlockTags;

var _invariant = __webpack_require__("./node_modules/invariant/browser.js");

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _splitReactElement2 = __webpack_require__("./node_modules/draft-convert/lib/util/splitReactElement.js");

var _splitReactElement3 = _interopRequireDefault(_splitReactElement2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getNestedBlockTags(blockHTML) {
  (0, _invariant2.default)(blockHTML !== null && blockHTML !== undefined, 'Expected block HTML value to be non-null');

  if (_react2.default.isValidElement(blockHTML.nest)) {
    var _splitReactElement = (0, _splitReactElement3.default)(blockHTML.nest),
        start = _splitReactElement.start,
        end = _splitReactElement.end;

    return Object.assign({}, blockHTML, {
      nestStart: start,
      nestEnd: end
    });
  }

  (0, _invariant2.default)(Object.prototype.hasOwnProperty.call(blockHTML, 'nestStart') && Object.prototype.hasOwnProperty.call(blockHTML, 'nestEnd'), 'convertToHTML: received block information without either a ReactElement or an object with start/end tags');

  return blockHTML;
}

/***/ }),

/***/ "./node_modules/draft-convert/lib/util/parseHTML.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseHTML;
var fallback = function fallback(html) {
  var doc = document.implementation.createHTMLDocument('');
  doc.documentElement.innerHTML = html;
  return doc;
};

function parseHTML(html) {
  var doc = void 0;
  if (typeof DOMParser !== 'undefined') {
    var parser = new DOMParser();
    doc = parser.parseFromString(html, 'text/html');
    if (doc === null || doc.body === null) {
      doc = fallback(html);
    }
  } else {
    doc = fallback(html);
  }
  return doc.body;
}

/***/ }),

/***/ "./node_modules/draft-convert/lib/util/rangeSort.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (r1, r2) {
  if (r1.offset === r2.offset) {
    return r2.length - r1.length;
  }
  return r1.offset - r2.offset;
};

/***/ }),

/***/ "./node_modules/draft-convert/lib/util/splitReactElement.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = splitReactElement;

var _invariant = __webpack_require__("./node_modules/invariant/browser.js");

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _server = __webpack_require__("./node_modules/react-dom/server.js");

var _server2 = _interopRequireDefault(_server);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function splitReactElement(element) {
  var tags = _server2.default.renderToStaticMarkup(_react2.default.cloneElement(element, {}, '\r')).split('\r');

  (0, _invariant2.default)(tags.length > 1, 'convertToHTML: Element of type ' + element.type + ' must render children');

  (0, _invariant2.default)(tags.length < 3, 'convertToHTML: Element of type ' + element.type + ' cannot use carriage return character');

  return {
    start: tags[0],
    end: tags[1]
  };
}

/***/ }),

/***/ "./node_modules/draft-convert/lib/util/styleObjectFunction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (object) {
  return function (style) {
    if (typeof object === 'function') {
      return object(style);
    }

    return object[style];
  };
};

/***/ }),

/***/ "./node_modules/draft-convert/lib/util/updateMutation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateMutation;
function updateMutation(mutation, originalOffset, originalLength, newLength, prefixLength) {
  // three cases we can reasonably adjust - disjoint mutations that
  // happen later on where the offset will need to be changed,
  // mutations that completely contain the new one where we can adjust
  // the length, and mutations that occur partially within the new one.
  var lengthDiff = newLength - originalLength;

  if (originalOffset + originalLength <= mutation.offset) {
    return Object.assign({}, mutation, {
      offset: mutation.offset + lengthDiff
    });
  }
  if (originalOffset >= mutation.offset && originalOffset + originalLength <= mutation.offset + mutation.length) {
    return Object.assign({}, mutation, {
      length: mutation.length + lengthDiff
    });
  }
  if (originalOffset <= mutation.offset) {
    return Object.assign({}, mutation, {
      offset: mutation.offset + prefixLength
    });
  }

  return mutation;
}

/***/ }),

/***/ "./node_modules/draft-convert/node_modules/immutable/dist/immutable.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  global.Immutable = factory();
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step > 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    findEntry: function(predicate, context) {
      var found;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findLastEntry: function(predicate, context) {
      return this.toSeq().reverse().findEntry(predicate, context);
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  // Temporary warning about using length
  (function () {
    try {
      Object.defineProperty(IterablePrototype, 'length', {
        get: function () {
          if (!Iterable.noLengthWarning) {
            var stack;
            try {
              throw new Error();
            } catch (error) {
              stack = error.stack;
            }
            if (stack.indexOf('_wrapObject') === -1) {
              console && console.warn && console.warn(
                'iterable.length has been deprecated, '+
                'use iterable.size or iterable.count(). '+
                'This warning will become a silent error in a future version. ' +
                stack
              );
              return this.size;
            }
          }
        }
      });
    } catch (e) {}
  })();



  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLastKey: function(predicate, context) {
      return this.toSeq().reverse().findKey(predicate, context);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    lastKeyOf: function(searchValue) {
      return this.findLastKey(function(value ) {return is(value, searchValue)});
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.toKeyedSeq().keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
      return key === undefined ? -1 : key;

      // var index =
      // return this.toSeq().reverse().indexOf(searchValue);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var key = this.toKeyedSeq().findLastKey(predicate, context);
      return key === undefined ? -1 : key;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : value;
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),

/***/ "./node_modules/invariant/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ "./node_modules/nunjucks-loader/runtime-shim.js":
/***/ (function(module, exports) {

module.exports = function (nunjucks, env, obj, dependencies){

    var oldRoot = obj.root;

    obj.root = function( env, context, frame, runtime, ignoreMissing, cb ) {
        var oldGetTemplate = env.getTemplate;
        env.getTemplate = function (name, ec, parentName, ignoreMissing, cb) {
            if( typeof ec === "function" ) {
                cb = ec = false;
            }
            var _require = function (name) {
                try {
                    // add a reference to the already resolved dependency here
                    return dependencies[name];
                }
                catch (e) {
                    if (frame.get("_require")) {
                        return frame.get("_require")(name);
                    }
                    else {
                        console.warn('Could not load template "%s"', name);
                    }
                }
            };

            var tmpl = _require(name);
            frame.set("_require", _require);

            if( ec ) tmpl.compile();
            cb( null, tmpl );
        };

        oldRoot(env, context, frame, runtime, ignoreMissing, function (err, res) {
            env.getTemplate = oldGetTemplate;
            cb( err, res );
        });
    };

    var src = {
        obj: obj,
        type: 'code'
    };

    return new nunjucks.Template(src, env);

};

/***/ }),

/***/ "./node_modules/nunjucks/browser/nunjucks-slim.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {/*! Browser bundle of nunjucks 3.0.1 (slim, only works with precompiled templates) */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["nunjucks"] = factory();
	else
		root["nunjucks"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var lib = __webpack_require__(1);
	var env = __webpack_require__(2);
	var Loader = __webpack_require__(15);
	var loaders = __webpack_require__(3);
	var precompile = __webpack_require__(3);

	module.exports = {};
	module.exports.Environment = env.Environment;
	module.exports.Template = env.Template;

	module.exports.Loader = Loader;
	module.exports.FileSystemLoader = loaders.FileSystemLoader;
	module.exports.PrecompiledLoader = loaders.PrecompiledLoader;
	module.exports.WebLoader = loaders.WebLoader;

	module.exports.compiler = __webpack_require__(3);
	module.exports.parser = __webpack_require__(3);
	module.exports.lexer = __webpack_require__(3);
	module.exports.runtime = __webpack_require__(8);
	module.exports.lib = lib;
	module.exports.nodes = __webpack_require__(3);

	module.exports.installJinjaCompat = __webpack_require__(16);

	// A single instance of an environment, since this is so commonly used

	var e;
	module.exports.configure = function(templatesPath, opts) {
	    opts = opts || {};
	    if(lib.isObject(templatesPath)) {
	        opts = templatesPath;
	        templatesPath = null;
	    }

	    var TemplateLoader;
	    if(loaders.FileSystemLoader) {
	        TemplateLoader = new loaders.FileSystemLoader(templatesPath, {
	            watch: opts.watch,
	            noCache: opts.noCache
	        });
	    }
	    else if(loaders.WebLoader) {
	        TemplateLoader = new loaders.WebLoader(templatesPath, {
	            useCache: opts.web && opts.web.useCache,
	            async: opts.web && opts.web.async
	        });
	    }

	    e = new env.Environment(TemplateLoader, opts);

	    if(opts && opts.express) {
	        e.express(opts.express);
	    }

	    return e;
	};

	module.exports.compile = function(src, env, path, eagerCompile) {
	    if(!e) {
	        module.exports.configure();
	    }
	    return new module.exports.Template(src, env, path, eagerCompile);
	};

	module.exports.render = function(name, ctx, cb) {
	    if(!e) {
	        module.exports.configure();
	    }

	    return e.render(name, ctx, cb);
	};

	module.exports.renderString = function(src, ctx, cb) {
	    if(!e) {
	        module.exports.configure();
	    }

	    return e.renderString(src, ctx, cb);
	};

	if(precompile) {
	    module.exports.precompile = precompile.precompile;
	    module.exports.precompileString = precompile.precompileString;
	}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';

	var ArrayProto = Array.prototype;
	var ObjProto = Object.prototype;

	var escapeMap = {
	    '&': '&amp;',
	    '"': '&quot;',
	    '\'': '&#39;',
	    '<': '&lt;',
	    '>': '&gt;'
	};

	var escapeRegex = /[&"'<>]/g;

	var lookupEscape = function(ch) {
	    return escapeMap[ch];
	};

	var exports = module.exports = {};

	exports.prettifyError = function(path, withInternals, err) {
	    // jshint -W022
	    // http://jslinterrors.com/do-not-assign-to-the-exception-parameter
	    if (!err.Update) {
	        // not one of ours, cast it
	        err = new exports.TemplateError(err);
	    }
	    err.Update(path);

	    // Unless they marked the dev flag, show them a trace from here
	    if (!withInternals) {
	        var old = err;
	        err = new Error(old.message);
	        err.name = old.name;
	    }

	    return err;
	};

	exports.TemplateError = function(message, lineno, colno) {
	    var err = this;

	    if (message instanceof Error) { // for casting regular js errors
	        err = message;
	        message = message.name + ': ' + message.message;

	        try {
	            if(err.name = '') {}
	        }
	        catch(e) {
	            // If we can't set the name of the error object in this
	            // environment, don't use it
	            err = this;
	        }
	    } else {
	        if(Error.captureStackTrace) {
	            Error.captureStackTrace(err);
	        }
	    }

	    err.name = 'Template render error';
	    err.message = message;
	    err.lineno = lineno;
	    err.colno = colno;
	    err.firstUpdate = true;

	    err.Update = function(path) {
	        var message = '(' + (path || 'unknown path') + ')';

	        // only show lineno + colno next to path of template
	        // where error occurred
	        if (this.firstUpdate) {
	            if(this.lineno && this.colno) {
	                message += ' [Line ' + this.lineno + ', Column ' + this.colno + ']';
	            }
	            else if(this.lineno) {
	                message += ' [Line ' + this.lineno + ']';
	            }
	        }

	        message += '\n ';
	        if (this.firstUpdate) {
	            message += ' ';
	        }

	        this.message = message + (this.message || '');
	        this.firstUpdate = false;
	        return this;
	    };

	    return err;
	};

	exports.TemplateError.prototype = Error.prototype;

	exports.escape = function(val) {
	  return val.replace(escapeRegex, lookupEscape);
	};

	exports.isFunction = function(obj) {
	    return ObjProto.toString.call(obj) === '[object Function]';
	};

	exports.isArray = Array.isArray || function(obj) {
	    return ObjProto.toString.call(obj) === '[object Array]';
	};

	exports.isString = function(obj) {
	    return ObjProto.toString.call(obj) === '[object String]';
	};

	exports.isObject = function(obj) {
	    return ObjProto.toString.call(obj) === '[object Object]';
	};

	exports.groupBy = function(obj, val) {
	    var result = {};
	    var iterator = exports.isFunction(val) ? val : function(obj) { return obj[val]; };
	    for(var i=0; i<obj.length; i++) {
	        var value = obj[i];
	        var key = iterator(value, i);
	        (result[key] || (result[key] = [])).push(value);
	    }
	    return result;
	};

	exports.toArray = function(obj) {
	    return Array.prototype.slice.call(obj);
	};

	exports.without = function(array) {
	    var result = [];
	    if (!array) {
	        return result;
	    }
	    var index = -1,
	    length = array.length,
	    contains = exports.toArray(arguments).slice(1);

	    while(++index < length) {
	        if(exports.indexOf(contains, array[index]) === -1) {
	            result.push(array[index]);
	        }
	    }
	    return result;
	};

	exports.extend = function(obj, obj2) {
	    for(var k in obj2) {
	        obj[k] = obj2[k];
	    }
	    return obj;
	};

	exports.repeat = function(char_, n) {
	    var str = '';
	    for(var i=0; i<n; i++) {
	        str += char_;
	    }
	    return str;
	};

	exports.each = function(obj, func, context) {
	    if(obj == null) {
	        return;
	    }

	    if(ArrayProto.each && obj.each === ArrayProto.each) {
	        obj.forEach(func, context);
	    }
	    else if(obj.length === +obj.length) {
	        for(var i=0, l=obj.length; i<l; i++) {
	            func.call(context, obj[i], i, obj);
	        }
	    }
	};

	exports.map = function(obj, func) {
	    var results = [];
	    if(obj == null) {
	        return results;
	    }

	    if(ArrayProto.map && obj.map === ArrayProto.map) {
	        return obj.map(func);
	    }

	    for(var i=0; i<obj.length; i++) {
	        results[results.length] = func(obj[i], i);
	    }

	    if(obj.length === +obj.length) {
	        results.length = obj.length;
	    }

	    return results;
	};

	exports.asyncIter = function(arr, iter, cb) {
	    var i = -1;

	    function next() {
	        i++;

	        if(i < arr.length) {
	            iter(arr[i], i, next, cb);
	        }
	        else {
	            cb();
	        }
	    }

	    next();
	};

	exports.asyncFor = function(obj, iter, cb) {
	    var keys = exports.keys(obj);
	    var len = keys.length;
	    var i = -1;

	    function next() {
	        i++;
	        var k = keys[i];

	        if(i < len) {
	            iter(k, obj[k], i, len, next);
	        }
	        else {
	            cb();
	        }
	    }

	    next();
	};

	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf#Polyfill
	exports.indexOf = Array.prototype.indexOf ?
	    function (arr, searchElement, fromIndex) {
	        return Array.prototype.indexOf.call(arr, searchElement, fromIndex);
	    } :
	    function (arr, searchElement, fromIndex) {
	        var length = this.length >>> 0; // Hack to convert object.length to a UInt32

	        fromIndex = +fromIndex || 0;

	        if(Math.abs(fromIndex) === Infinity) {
	            fromIndex = 0;
	        }

	        if(fromIndex < 0) {
	            fromIndex += length;
	            if (fromIndex < 0) {
	                fromIndex = 0;
	            }
	        }

	        for(;fromIndex < length; fromIndex++) {
	            if (arr[fromIndex] === searchElement) {
	                return fromIndex;
	            }
	        }

	        return -1;
	    };

	if(!Array.prototype.map) {
	    Array.prototype.map = function() {
	        throw new Error('map is unimplemented for this js engine');
	    };
	}

	exports.keys = function(obj) {
	    if(Object.prototype.keys) {
	        return obj.keys();
	    }
	    else {
	        var keys = [];
	        for(var k in obj) {
	            if(obj.hasOwnProperty(k)) {
	                keys.push(k);
	            }
	        }
	        return keys;
	    }
	};

	exports.inOperator = function (key, val) {
	    if (exports.isArray(val)) {
	        return exports.indexOf(val, key) !== -1;
	    } else if (exports.isObject(val)) {
	        return key in val;
	    } else if (exports.isString(val)) {
	        return val.indexOf(key) !== -1;
	    } else {
	        throw new Error('Cannot use "in" operator to search for "'
	            + key + '" in unexpected types.');
	    }
	};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var path = __webpack_require__(3);
	var asap = __webpack_require__(4);
	var lib = __webpack_require__(1);
	var Obj = __webpack_require__(6);
	var compiler = __webpack_require__(3);
	var builtin_filters = __webpack_require__(7);
	var builtin_loaders = __webpack_require__(3);
	var runtime = __webpack_require__(8);
	var globals = __webpack_require__(9);
	var waterfall = __webpack_require__(10);
	var Frame = runtime.Frame;
	var Template;

	// Unconditionally load in this loader, even if no other ones are
	// included (possible in the slim browser build)
	builtin_loaders.PrecompiledLoader = __webpack_require__(14);

	// If the user is using the async API, *always* call it
	// asynchronously even if the template was synchronous.
	function callbackAsap(cb, err, res) {
	    asap(function() { cb(err, res); });
	}

	var Environment = Obj.extend({
	    init: function(loaders, opts) {
	        // The dev flag determines the trace that'll be shown on errors.
	        // If set to true, returns the full trace from the error point,
	        // otherwise will return trace starting from Template.render
	        // (the full trace from within nunjucks may confuse developers using
	        //  the library)
	        // defaults to false
	        opts = this.opts = opts || {};
	        this.opts.dev = !!opts.dev;

	        // The autoescape flag sets global autoescaping. If true,
	        // every string variable will be escaped by default.
	        // If false, strings can be manually escaped using the `escape` filter.
	        // defaults to true
	        this.opts.autoescape = opts.autoescape != null ? opts.autoescape : true;

	        // If true, this will make the system throw errors if trying
	        // to output a null or undefined value
	        this.opts.throwOnUndefined = !!opts.throwOnUndefined;
	        this.opts.trimBlocks = !!opts.trimBlocks;
	        this.opts.lstripBlocks = !!opts.lstripBlocks;

	        this.loaders = [];

	        if(!loaders) {
	            // The filesystem loader is only available server-side
	            if(builtin_loaders.FileSystemLoader) {
	                this.loaders = [new builtin_loaders.FileSystemLoader('views')];
	            }
	            else if(builtin_loaders.WebLoader) {
	                this.loaders = [new builtin_loaders.WebLoader('/views')];
	            }
	        }
	        else {
	            this.loaders = lib.isArray(loaders) ? loaders : [loaders];
	        }

	        // It's easy to use precompiled templates: just include them
	        // before you configure nunjucks and this will automatically
	        // pick it up and use it
	        if((true) && window.nunjucksPrecompiled) {
	            this.loaders.unshift(
	                new builtin_loaders.PrecompiledLoader(window.nunjucksPrecompiled)
	            );
	        }

	        this.initCache();

	        this.globals = globals();
	        this.filters = {};
	        this.asyncFilters = [];
	        this.extensions = {};
	        this.extensionsList = [];

	        for(var name in builtin_filters) {
	            this.addFilter(name, builtin_filters[name]);
	        }
	    },

	    initCache: function() {
	        // Caching and cache busting
	        lib.each(this.loaders, function(loader) {
	            loader.cache = {};

	            if(typeof loader.on === 'function') {
	                loader.on('update', function(template) {
	                    loader.cache[template] = null;
	                });
	            }
	        });
	    },

	    addExtension: function(name, extension) {
	        extension._name = name;
	        this.extensions[name] = extension;
	        this.extensionsList.push(extension);
	        return this;
	    },

	    removeExtension: function(name) {
	        var extension = this.getExtension(name);
	        if (!extension) return;

	        this.extensionsList = lib.without(this.extensionsList, extension);
	        delete this.extensions[name];
	    },

	    getExtension: function(name) {
	        return this.extensions[name];
	    },

	    hasExtension: function(name) {
	        return !!this.extensions[name];
	    },

	    addGlobal: function(name, value) {
	        this.globals[name] = value;
	        return this;
	    },

	    getGlobal: function(name) {
	        if(typeof this.globals[name] === 'undefined') {
	            throw new Error('global not found: ' + name);
	        }
	        return this.globals[name];
	    },

	    addFilter: function(name, func, async) {
	        var wrapped = func;

	        if(async) {
	            this.asyncFilters.push(name);
	        }
	        this.filters[name] = wrapped;
	        return this;
	    },

	    getFilter: function(name) {
	        if(!this.filters[name]) {
	            throw new Error('filter not found: ' + name);
	        }
	        return this.filters[name];
	    },

	    resolveTemplate: function(loader, parentName, filename) {
	        var isRelative = (loader.isRelative && parentName)? loader.isRelative(filename) : false;
	        return (isRelative && loader.resolve)? loader.resolve(parentName, filename) : filename;
	    },

	    getTemplate: function(name, eagerCompile, parentName, ignoreMissing, cb) {
	        var that = this;
	        var tmpl = null;
	        if(name && name.raw) {
	            // this fixes autoescape for templates referenced in symbols
	            name = name.raw;
	        }

	        if(lib.isFunction(parentName)) {
	            cb = parentName;
	            parentName = null;
	            eagerCompile = eagerCompile || false;
	        }

	        if(lib.isFunction(eagerCompile)) {
	            cb = eagerCompile;
	            eagerCompile = false;
	        }

	        if (name instanceof Template) {
	             tmpl = name;
	        }
	        else if(typeof name !== 'string') {
	            throw new Error('template names must be a string: ' + name);
	        }
	        else {
	            for (var i = 0; i < this.loaders.length; i++) {
	                var _name = this.resolveTemplate(this.loaders[i], parentName, name);
	                tmpl = this.loaders[i].cache[_name];
	                if (tmpl) break;
	            }
	        }

	        if(tmpl) {
	            if(eagerCompile) {
	                tmpl.compile();
	            }

	            if(cb) {
	                cb(null, tmpl);
	            }
	            else {
	                return tmpl;
	            }
	        } else {
	            var syncResult;
	            var _this = this;

	            var createTemplate = function(err, info) {
	                if(!info && !err) {
	                    if(!ignoreMissing) {
	                        err = new Error('template not found: ' + name);
	                    }
	                }

	                if (err) {
	                    if(cb) {
	                        cb(err);
	                    }
	                    else {
	                        throw err;
	                    }
	                }
	                else {
	                    var tmpl;
	                    if(info) {
	                        tmpl = new Template(info.src, _this,
	                                            info.path, eagerCompile);

	                        if(!info.noCache) {
	                            info.loader.cache[name] = tmpl;
	                        }
	                    }
	                    else {
	                        tmpl = new Template('', _this,
	                                            '', eagerCompile);
	                    }

	                    if(cb) {
	                        cb(null, tmpl);
	                    }
	                    else {
	                        syncResult = tmpl;
	                    }
	                }
	            };

	            lib.asyncIter(this.loaders, function(loader, i, next, done) {
	                function handle(err, src) {
	                    if(err) {
	                        done(err);
	                    }
	                    else if(src) {
	                        src.loader = loader;
	                        done(null, src);
	                    }
	                    else {
	                        next();
	                    }
	                }

	                // Resolve name relative to parentName
	                name = that.resolveTemplate(loader, parentName, name);

	                if(loader.async) {
	                    loader.getSource(name, handle);
	                }
	                else {
	                    handle(null, loader.getSource(name));
	                }
	            }, createTemplate);

	            return syncResult;
	        }
	    },

	    express: function(app) {
	        var env = this;

	        function NunjucksView(name, opts) {
	            this.name          = name;
	            this.path          = name;
	            this.defaultEngine = opts.defaultEngine;
	            this.ext           = path.extname(name);
	            if (!this.ext && !this.defaultEngine) throw new Error('No default engine was specified and no extension was provided.');
	            if (!this.ext) this.name += (this.ext = ('.' !== this.defaultEngine[0] ? '.' : '') + this.defaultEngine);
	        }

	        NunjucksView.prototype.render = function(opts, cb) {
	          env.render(this.name, opts, cb);
	        };

	        app.set('view', NunjucksView);
	        app.set('nunjucksEnv', this);
	        return this;
	    },

	    render: function(name, ctx, cb) {
	        if(lib.isFunction(ctx)) {
	            cb = ctx;
	            ctx = null;
	        }

	        // We support a synchronous API to make it easier to migrate
	        // existing code to async. This works because if you don't do
	        // anything async work, the whole thing is actually run
	        // synchronously.
	        var syncResult = null;

	        this.getTemplate(name, function(err, tmpl) {
	            if(err && cb) {
	                callbackAsap(cb, err);
	            }
	            else if(err) {
	                throw err;
	            }
	            else {
	                syncResult = tmpl.render(ctx, cb);
	            }
	        });

	        return syncResult;
	    },

	    renderString: function(src, ctx, opts, cb) {
	        if(lib.isFunction(opts)) {
	            cb = opts;
	            opts = {};
	        }
	        opts = opts || {};

	        var tmpl = new Template(src, this, opts.path);
	        return tmpl.render(ctx, cb);
	    },

	    waterfall: waterfall
	});

	var Context = Obj.extend({
	    init: function(ctx, blocks, env) {
	        // Has to be tied to an environment so we can tap into its globals.
	        this.env = env || new Environment();

	        // Make a duplicate of ctx
	        this.ctx = {};
	        for(var k in ctx) {
	            if(ctx.hasOwnProperty(k)) {
	                this.ctx[k] = ctx[k];
	            }
	        }

	        this.blocks = {};
	        this.exported = [];

	        for(var name in blocks) {
	            this.addBlock(name, blocks[name]);
	        }
	    },

	    lookup: function(name) {
	        // This is one of the most called functions, so optimize for
	        // the typical case where the name isn't in the globals
	        if(name in this.env.globals && !(name in this.ctx)) {
	            return this.env.globals[name];
	        }
	        else {
	            return this.ctx[name];
	        }
	    },

	    setVariable: function(name, val) {
	        this.ctx[name] = val;
	    },

	    getVariables: function() {
	        return this.ctx;
	    },

	    addBlock: function(name, block) {
	        this.blocks[name] = this.blocks[name] || [];
	        this.blocks[name].push(block);
	        return this;
	    },

	    getBlock: function(name) {
	        if(!this.blocks[name]) {
	            throw new Error('unknown block "' + name + '"');
	        }

	        return this.blocks[name][0];
	    },

	    getSuper: function(env, name, block, frame, runtime, cb) {
	        var idx = lib.indexOf(this.blocks[name] || [], block);
	        var blk = this.blocks[name][idx + 1];
	        var context = this;

	        if(idx === -1 || !blk) {
	            throw new Error('no super block available for "' + name + '"');
	        }

	        blk(env, context, frame, runtime, cb);
	    },

	    addExport: function(name) {
	        this.exported.push(name);
	    },

	    getExported: function() {
	        var exported = {};
	        for(var i=0; i<this.exported.length; i++) {
	            var name = this.exported[i];
	            exported[name] = this.ctx[name];
	        }
	        return exported;
	    }
	});

	Template = Obj.extend({
	    init: function (src, env, path, eagerCompile) {
	        this.env = env || new Environment();

	        if(lib.isObject(src)) {
	            switch(src.type) {
	            case 'code': this.tmplProps = src.obj; break;
	            case 'string': this.tmplStr = src.obj; break;
	            }
	        }
	        else if(lib.isString(src)) {
	            this.tmplStr = src;
	        }
	        else {
	            throw new Error('src must be a string or an object describing ' +
	                            'the source');
	        }

	        this.path = path;

	        if(eagerCompile) {
	            var _this = this;
	            try {
	                _this._compile();
	            }
	            catch(err) {
	                throw lib.prettifyError(this.path, this.env.opts.dev, err);
	            }
	        }
	        else {
	            this.compiled = false;
	        }
	    },

	    render: function(ctx, parentFrame, cb) {
	        if (typeof ctx === 'function') {
	            cb = ctx;
	            ctx = {};
	        }
	        else if (typeof parentFrame === 'function') {
	            cb = parentFrame;
	            parentFrame = null;
	        }

	        var forceAsync = true;
	        if(parentFrame) {
	            // If there is a frame, we are being called from internal
	            // code of another template, and the internal system
	            // depends on the sync/async nature of the parent template
	            // to be inherited, so force an async callback
	            forceAsync = false;
	        }

	        var _this = this;
	        // Catch compile errors for async rendering
	        try {
	            _this.compile();
	        } catch (_err) {
	            var err = lib.prettifyError(this.path, this.env.opts.dev, _err);
	            if (cb) return callbackAsap(cb, err);
	            else throw err;
	        }

	        var context = new Context(ctx || {}, _this.blocks, _this.env);
	        var frame = parentFrame ? parentFrame.push(true) : new Frame();
	        frame.topLevel = true;
	        var syncResult = null;

	        _this.rootRenderFunc(
	            _this.env,
	            context,
	            frame || new Frame(),
	            runtime,
	            function(err, res) {
	                if(err) {
	                    err = lib.prettifyError(_this.path, _this.env.opts.dev, err);
	                }

	                if(cb) {
	                    if(forceAsync) {
	                        callbackAsap(cb, err, res);
	                    }
	                    else {
	                        cb(err, res);
	                    }
	                }
	                else {
	                    if(err) { throw err; }
	                    syncResult = res;
	                }
	            }
	        );

	        return syncResult;
	    },


	    getExported: function(ctx, parentFrame, cb) {
	        if (typeof ctx === 'function') {
	            cb = ctx;
	            ctx = {};
	        }

	        if (typeof parentFrame === 'function') {
	            cb = parentFrame;
	            parentFrame = null;
	        }

	        // Catch compile errors for async rendering
	        try {
	            this.compile();
	        } catch (e) {
	            if (cb) return cb(e);
	            else throw e;
	        }

	        var frame = parentFrame ? parentFrame.push() : new Frame();
	        frame.topLevel = true;

	        // Run the rootRenderFunc to populate the context with exported vars
	        var context = new Context(ctx || {}, this.blocks, this.env);
	        this.rootRenderFunc(this.env,
	                            context,
	                            frame,
	                            runtime,
	                            function(err) {
	        		        if ( err ) {
	        			    cb(err, null);
	        		        } else {
	        			    cb(null, context.getExported());
	        		        }
	                            });
	    },

	    compile: function() {
	        if(!this.compiled) {
	            this._compile();
	        }
	    },

	    _compile: function() {
	        var props;

	        if(this.tmplProps) {
	            props = this.tmplProps;
	        }
	        else {
	            var source = compiler.compile(this.tmplStr,
	                                          this.env.asyncFilters,
	                                          this.env.extensionsList,
	                                          this.path,
	                                          this.env.opts);

	            /* jslint evil: true */
	            var func = new Function(source);
	            props = func();
	        }

	        this.blocks = this._getBlocks(props);
	        this.rootRenderFunc = props.root;
	        this.compiled = true;
	    },

	    _getBlocks: function(props) {
	        var blocks = {};

	        for(var k in props) {
	            if(k.slice(0, 2) === 'b_') {
	                blocks[k.slice(2)] = props[k];
	            }
	        }

	        return blocks;
	    }
	});

	module.exports = {
	    Environment: Environment,
	    Template: Template
	};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	// rawAsap provides everything we need except exception management.
	var rawAsap = __webpack_require__(5);
	// RawTasks are recycled to reduce GC churn.
	var freeTasks = [];
	// We queue errors to ensure they are thrown in right order (FIFO).
	// Array-as-queue is good enough here, since we are just dealing with exceptions.
	var pendingErrors = [];
	var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

	function throwFirstError() {
	    if (pendingErrors.length) {
	        throw pendingErrors.shift();
	    }
	}

	/**
	 * Calls a task as soon as possible after returning, in its own event, with priority
	 * over other events like animation, reflow, and repaint. An error thrown from an
	 * event will not interrupt, nor even substantially slow down the processing of
	 * other events, but will be rather postponed to a lower priority event.
	 * @param {{call}} task A callable object, typically a function that takes no
	 * arguments.
	 */
	module.exports = asap;
	function asap(task) {
	    var rawTask;
	    if (freeTasks.length) {
	        rawTask = freeTasks.pop();
	    } else {
	        rawTask = new RawTask();
	    }
	    rawTask.task = task;
	    rawAsap(rawTask);
	}

	// We wrap tasks with recyclable task objects.  A task object implements
	// `call`, just like a function.
	function RawTask() {
	    this.task = null;
	}

	// The sole purpose of wrapping the task is to catch the exception and recycle
	// the task object after its single use.
	RawTask.prototype.call = function () {
	    try {
	        this.task.call();
	    } catch (error) {
	        if (asap.onerror) {
	            // This hook exists purely for testing purposes.
	            // Its name will be periodically randomized to break any code that
	            // depends on its existence.
	            asap.onerror(error);
	        } else {
	            // In a web browser, exceptions are not fatal. However, to avoid
	            // slowing down the queue of pending tasks, we rethrow the error in a
	            // lower priority turn.
	            pendingErrors.push(error);
	            requestErrorThrow();
	        }
	    } finally {
	        this.task = null;
	        freeTasks[freeTasks.length] = this;
	    }
	};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";

	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}

	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;

	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}

	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);

	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.

	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396

	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}

	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;

	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}

	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html

	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.

	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }

	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.

	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }

	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.

	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.

	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);

	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}

	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';

	// A simple class system, more documentation to come

	function extend(cls, name, props) {
	    // This does that same thing as Object.create, but with support for IE8
	    var F = function() {};
	    F.prototype = cls.prototype;
	    var prototype = new F();

	    // jshint undef: false
	    var fnTest = /xyz/.test(function(){ xyz; }) ? /\bparent\b/ : /.*/;
	    props = props || {};

	    for(var k in props) {
	        var src = props[k];
	        var parent = prototype[k];

	        if(typeof parent === 'function' &&
	           typeof src === 'function' &&
	           fnTest.test(src)) {
	            /*jshint -W083 */
	            prototype[k] = (function (src, parent) {
	                return function() {
	                    // Save the current parent method
	                    var tmp = this.parent;

	                    // Set parent to the previous method, call, and restore
	                    this.parent = parent;
	                    var res = src.apply(this, arguments);
	                    this.parent = tmp;

	                    return res;
	                };
	            })(src, parent);
	        }
	        else {
	            prototype[k] = src;
	        }
	    }

	    prototype.typename = name;

	    var new_cls = function() {
	        if(prototype.init) {
	            prototype.init.apply(this, arguments);
	        }
	    };

	    new_cls.prototype = prototype;
	    new_cls.prototype.constructor = new_cls;

	    new_cls.extend = function(name, props) {
	        if(typeof name === 'object') {
	            props = name;
	            name = 'anonymous';
	        }
	        return extend(new_cls, name, props);
	    };

	    return new_cls;
	}

	module.exports = extend(Object, 'Object', {});


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var lib = __webpack_require__(1);
	var r = __webpack_require__(8);

	function normalize(value, defaultValue) {
	    if(value === null || value === undefined || value === false) {
	        return defaultValue;
	    }
	    return value;
	}

	var filters = {
	    abs: Math.abs,

	    batch: function(arr, linecount, fill_with) {
	        var i;
	        var res = [];
	        var tmp = [];

	        for(i = 0; i < arr.length; i++) {
	            if(i % linecount === 0 && tmp.length) {
	                res.push(tmp);
	                tmp = [];
	            }

	            tmp.push(arr[i]);
	        }

	        if(tmp.length) {
	            if(fill_with) {
	                for(i = tmp.length; i < linecount; i++) {
	                    tmp.push(fill_with);
	                }
	            }

	            res.push(tmp);
	        }

	        return res;
	    },

	    capitalize: function(str) {
	        str = normalize(str, '');
	        var ret = str.toLowerCase();
	        return r.copySafeness(str, ret.charAt(0).toUpperCase() + ret.slice(1));
	    },

	    center: function(str, width) {
	        str = normalize(str, '');
	        width = width || 80;

	        if(str.length >= width) {
	            return str;
	        }

	        var spaces = width - str.length;
	        var pre = lib.repeat(' ', spaces/2 - spaces % 2);
	        var post = lib.repeat(' ', spaces/2);
	        return r.copySafeness(str, pre + str + post);
	    },

	    'default': function(val, def, bool) {
	        if(bool) {
	            return val ? val : def;
	        }
	        else {
	            return (val !== undefined) ? val : def;
	        }
	    },

	    dictsort: function(val, case_sensitive, by) {
	        if (!lib.isObject(val)) {
	            throw new lib.TemplateError('dictsort filter: val must be an object');
	        }

	        var array = [];
	        for (var k in val) {
	            // deliberately include properties from the object's prototype
	            array.push([k,val[k]]);
	        }

	        var si;
	        if (by === undefined || by === 'key') {
	            si = 0;
	        } else if (by === 'value') {
	            si = 1;
	        } else {
	            throw new lib.TemplateError(
	                'dictsort filter: You can only sort by either key or value');
	        }

	        array.sort(function(t1, t2) {
	            var a = t1[si];
	            var b = t2[si];

	            if (!case_sensitive) {
	                if (lib.isString(a)) {
	                    a = a.toUpperCase();
	                }
	                if (lib.isString(b)) {
	                    b = b.toUpperCase();
	                }
	            }

	            return a > b ? 1 : (a === b ? 0 : -1);
	        });

	        return array;
	    },

	    dump: function(obj, spaces) {
	        return JSON.stringify(obj, null, spaces);
	    },

	    escape: function(str) {
	        if(str instanceof r.SafeString) {
	            return str;
	        }
	        str = (str === null || str === undefined) ? '' : str;
	        return r.markSafe(lib.escape(str.toString()));
	    },

	    safe: function(str) {
	        if (str instanceof r.SafeString) {
	            return str;
	        }
	        str = (str === null || str === undefined) ? '' : str;
	        return r.markSafe(str.toString());
	    },

	    first: function(arr) {
	        return arr[0];
	    },

	    groupby: function(arr, attr) {
	        return lib.groupBy(arr, attr);
	    },

	    indent: function(str, width, indentfirst) {
	        str = normalize(str, '');

	        if (str === '') return '';

	        width = width || 4;
	        var res = '';
	        var lines = str.split('\n');
	        var sp = lib.repeat(' ', width);

	        for(var i=0; i<lines.length; i++) {
	            if(i === 0 && !indentfirst) {
	                res += lines[i] + '\n';
	            }
	            else {
	                res += sp + lines[i] + '\n';
	            }
	        }

	        return r.copySafeness(str, res);
	    },

	    join: function(arr, del, attr) {
	        del = del || '';

	        if(attr) {
	            arr = lib.map(arr, function(v) {
	                return v[attr];
	            });
	        }

	        return arr.join(del);
	    },

	    last: function(arr) {
	        return arr[arr.length-1];
	    },

	    length: function(val) {
	        var value = normalize(val, '');

	        if(value !== undefined) {
	            if(
	                (typeof Map === 'function' && value instanceof Map) ||
	                (typeof Set === 'function' && value instanceof Set)
	            ) {
	                // ECMAScript 2015 Maps and Sets
	                return value.size;
	            }
	            if(lib.isObject(value) && !(value instanceof r.SafeString)) {
	                // Objects (besides SafeStrings), non-primative Arrays
	                return Object.keys(value).length;
	            }
	            return value.length;
	        }
	        return 0;
	    },

	    list: function(val) {
	        if(lib.isString(val)) {
	            return val.split('');
	        }
	        else if(lib.isObject(val)) {
	            var keys = [];

	            if(Object.keys) {
	                keys = Object.keys(val);
	            }
	            else {
	                for(var k in val) {
	                    keys.push(k);
	                }
	            }

	            return lib.map(keys, function(k) {
	                return { key: k,
	                         value: val[k] };
	            });
	        }
	        else if(lib.isArray(val)) {
	          return val;
	        }
	        else {
	            throw new lib.TemplateError('list filter: type not iterable');
	        }
	    },

	    lower: function(str) {
	        str = normalize(str, '');
	        return str.toLowerCase();
	    },

	    nl2br: function(str) {
	        if (str === null || str === undefined) {
	            return '';
	        }
	        return r.copySafeness(str, str.replace(/\r\n|\n/g, '<br />\n'));
	    },

	    random: function(arr) {
	        return arr[Math.floor(Math.random() * arr.length)];
	    },

	    rejectattr: function(arr, attr) {
	      return arr.filter(function (item) {
	        return !item[attr];
	      });
	    },

	    selectattr: function(arr, attr) {
	      return arr.filter(function (item) {
	        return !!item[attr];
	      });
	    },

	    replace: function(str, old, new_, maxCount) {
	        var originalStr = str;

	        if (old instanceof RegExp) {
	            return str.replace(old, new_);
	        }

	        if(typeof maxCount === 'undefined'){
	            maxCount = -1;
	        }

	        var res = '';  // Output

	        // Cast Numbers in the search term to string
	        if(typeof old === 'number'){
	            old = old + '';
	        }
	        else if(typeof old !== 'string') {
	            // If it is something other than number or string,
	            // return the original string
	            return str;
	        }

	        // Cast numbers in the replacement to string
	        if(typeof str === 'number'){
	            str = str + '';
	        }

	        // If by now, we don't have a string, throw it back
	        if(typeof str !== 'string' && !(str instanceof r.SafeString)){
	            return str;
	        }

	        // ShortCircuits
	        if(old === ''){
	            // Mimic the python behaviour: empty string is replaced
	            // by replacement e.g. "abc"|replace("", ".") -> .a.b.c.
	            res = new_ + str.split('').join(new_) + new_;
	            return r.copySafeness(str, res);
	        }

	        var nextIndex = str.indexOf(old);
	        // if # of replacements to perform is 0, or the string to does
	        // not contain the old value, return the string
	        if(maxCount === 0 || nextIndex === -1){
	            return str;
	        }

	        var pos = 0;
	        var count = 0; // # of replacements made

	        while(nextIndex  > -1 && (maxCount === -1 || count < maxCount)){
	            // Grab the next chunk of src string and add it with the
	            // replacement, to the result
	            res += str.substring(pos, nextIndex) + new_;
	            // Increment our pointer in the src string
	            pos = nextIndex + old.length;
	            count++;
	            // See if there are any more replacements to be made
	            nextIndex = str.indexOf(old, pos);
	        }

	        // We've either reached the end, or done the max # of
	        // replacements, tack on any remaining string
	        if(pos < str.length) {
	            res += str.substring(pos);
	        }

	        return r.copySafeness(originalStr, res);
	    },

	    reverse: function(val) {
	        var arr;
	        if(lib.isString(val)) {
	            arr = filters.list(val);
	        }
	        else {
	            // Copy it
	            arr = lib.map(val, function(v) { return v; });
	        }

	        arr.reverse();

	        if(lib.isString(val)) {
	            return r.copySafeness(val, arr.join(''));
	        }
	        return arr;
	    },

	    round: function(val, precision, method) {
	        precision = precision || 0;
	        var factor = Math.pow(10, precision);
	        var rounder;

	        if(method === 'ceil') {
	            rounder = Math.ceil;
	        }
	        else if(method === 'floor') {
	            rounder = Math.floor;
	        }
	        else {
	            rounder = Math.round;
	        }

	        return rounder(val * factor) / factor;
	    },

	    slice: function(arr, slices, fillWith) {
	        var sliceLength = Math.floor(arr.length / slices);
	        var extra = arr.length % slices;
	        var offset = 0;
	        var res = [];

	        for(var i=0; i<slices; i++) {
	            var start = offset + i * sliceLength;
	            if(i < extra) {
	                offset++;
	            }
	            var end = offset + (i + 1) * sliceLength;

	            var slice = arr.slice(start, end);
	            if(fillWith && i >= extra) {
	                slice.push(fillWith);
	            }
	            res.push(slice);
	        }

	        return res;
	    },

	    sum: function(arr, attr, start) {
	        var sum = 0;

	        if(typeof start === 'number'){
	            sum += start;
	        }

	        if(attr) {
	            arr = lib.map(arr, function(v) {
	                return v[attr];
	            });
	        }

	        for(var i = 0; i < arr.length; i++) {
	            sum += arr[i];
	        }

	        return sum;
	    },

	    sort: r.makeMacro(['value', 'reverse', 'case_sensitive', 'attribute'], [], function(arr, reverse, caseSens, attr) {
	         // Copy it
	        arr = lib.map(arr, function(v) { return v; });

	        arr.sort(function(a, b) {
	            var x, y;

	            if(attr) {
	                x = a[attr];
	                y = b[attr];
	            }
	            else {
	                x = a;
	                y = b;
	            }

	            if(!caseSens && lib.isString(x) && lib.isString(y)) {
	                x = x.toLowerCase();
	                y = y.toLowerCase();
	            }

	            if(x < y) {
	                return reverse ? 1 : -1;
	            }
	            else if(x > y) {
	                return reverse ? -1: 1;
	            }
	            else {
	                return 0;
	            }
	        });

	        return arr;
	    }),

	    string: function(obj) {
	        return r.copySafeness(obj, obj);
	    },

	    striptags: function(input, preserve_linebreaks) {
	        input = normalize(input, '');
	        preserve_linebreaks = preserve_linebreaks || false;
	        var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>|<!--[\s\S]*?-->/gi;
	        var trimmedInput = filters.trim(input.replace(tags, ''));
	        var res = '';
	        if (preserve_linebreaks) {
	            res = trimmedInput
	                .replace(/^ +| +$/gm, '')     // remove leading and trailing spaces
	                .replace(/ +/g, ' ')          // squash adjacent spaces
	                .replace(/(\r\n)/g, '\n')     // normalize linebreaks (CRLF -> LF)
	                .replace(/\n\n\n+/g, '\n\n'); // squash abnormal adjacent linebreaks
	        } else {
	            res = trimmedInput.replace(/\s+/gi, ' ');
	        }
	        return r.copySafeness(input, res);
	    },

	    title: function(str) {
	        str = normalize(str, '');
	        var words = str.split(' ');
	        for(var i = 0; i < words.length; i++) {
	            words[i] = filters.capitalize(words[i]);
	        }
	        return r.copySafeness(str, words.join(' '));
	    },

	    trim: function(str) {
	        return r.copySafeness(str, str.replace(/^\s*|\s*$/g, ''));
	    },

	    truncate: function(input, length, killwords, end) {
	        var orig = input;
	        input = normalize(input, '');
	        length = length || 255;

	        if (input.length <= length)
	            return input;

	        if (killwords) {
	            input = input.substring(0, length);
	        } else {
	            var idx = input.lastIndexOf(' ', length);
	            if(idx === -1) {
	                idx = length;
	            }

	            input = input.substring(0, idx);
	        }

	        input += (end !== undefined && end !== null) ? end : '...';
	        return r.copySafeness(orig, input);
	    },

	    upper: function(str) {
	        str = normalize(str, '');
	        return str.toUpperCase();
	    },

	    urlencode: function(obj) {
	        var enc = encodeURIComponent;
	        if (lib.isString(obj)) {
	            return enc(obj);
	        } else {
	            var parts;
	            if (lib.isArray(obj)) {
	                parts = obj.map(function(item) {
	                    return enc(item[0]) + '=' + enc(item[1]);
	                });
	            } else {
	                parts = [];
	                for (var k in obj) {
	                    if (obj.hasOwnProperty(k)) {
	                        parts.push(enc(k) + '=' + enc(obj[k]));
	                    }
	                }
	            }
	            return parts.join('&');
	        }
	    },

	    urlize: function(str, length, nofollow) {
	        if (isNaN(length)) length = Infinity;

	        var noFollowAttr = (nofollow === true ? ' rel="nofollow"' : '');

	        // For the jinja regexp, see
	        // https://github.com/mitsuhiko/jinja2/blob/f15b814dcba6aa12bc74d1f7d0c881d55f7126be/jinja2/utils.py#L20-L23
	        var puncRE = /^(?:\(|<|&lt;)?(.*?)(?:\.|,|\)|\n|&gt;)?$/;
	        // from http://blog.gerv.net/2011/05/html5_email_address_regexp/
	        var emailRE = /^[\w.!#$%&'*+\-\/=?\^`{|}~]+@[a-z\d\-]+(\.[a-z\d\-]+)+$/i;
	        var httpHttpsRE = /^https?:\/\/.*$/;
	        var wwwRE = /^www\./;
	        var tldRE = /\.(?:org|net|com)(?:\:|\/|$)/;

	        var words = str.split(/(\s+)/).filter(function(word) {
	          // If the word has no length, bail. This can happen for str with
	          // trailing whitespace.
	          return word && word.length;
	        }).map(function(word) {
	          var matches = word.match(puncRE);
	          var possibleUrl = matches && matches[1] || word;

	          // url that starts with http or https
	          if (httpHttpsRE.test(possibleUrl))
	            return '<a href="' + possibleUrl + '"' + noFollowAttr + '>' + possibleUrl.substr(0, length) + '</a>';

	          // url that starts with www.
	          if (wwwRE.test(possibleUrl))
	            return '<a href="http://' + possibleUrl + '"' + noFollowAttr + '>' + possibleUrl.substr(0, length) + '</a>';

	          // an email address of the form username@domain.tld
	          if (emailRE.test(possibleUrl))
	            return '<a href="mailto:' + possibleUrl + '">' + possibleUrl + '</a>';

	          // url that ends in .com, .org or .net that is not an email address
	          if (tldRE.test(possibleUrl))
	            return '<a href="http://' + possibleUrl + '"' + noFollowAttr + '>' + possibleUrl.substr(0, length) + '</a>';

	          return word;

	        });

	        return words.join('');
	    },

	    wordcount: function(str) {
	        str = normalize(str, '');
	        var words = (str) ? str.match(/\w+/g) : null;
	        return (words) ? words.length : null;
	    },

	    'float': function(val, def) {
	        var res = parseFloat(val);
	        return isNaN(res) ? def : res;
	    },

	    'int': function(val, def) {
	        var res = parseInt(val, 10);
	        return isNaN(res) ? def : res;
	    }
	};

	// Aliases
	filters.d = filters['default'];
	filters.e = filters.escape;

	module.exports = filters;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var lib = __webpack_require__(1);
	var Obj = __webpack_require__(6);

	// Frames keep track of scoping both at compile-time and run-time so
	// we know how to access variables. Block tags can introduce special
	// variables, for example.
	var Frame = Obj.extend({
	    init: function(parent, isolateWrites) {
	        this.variables = {};
	        this.parent = parent;
	        this.topLevel = false;
	        // if this is true, writes (set) should never propagate upwards past
	        // this frame to its parent (though reads may).
	        this.isolateWrites = isolateWrites;
	    },

	    set: function(name, val, resolveUp) {
	        // Allow variables with dots by automatically creating the
	        // nested structure
	        var parts = name.split('.');
	        var obj = this.variables;
	        var frame = this;

	        if(resolveUp) {
	            if((frame = this.resolve(parts[0], true))) {
	                frame.set(name, val);
	                return;
	            }
	        }

	        for(var i=0; i<parts.length - 1; i++) {
	            var id = parts[i];

	            if(!obj[id]) {
	                obj[id] = {};
	            }
	            obj = obj[id];
	        }

	        obj[parts[parts.length - 1]] = val;
	    },

	    get: function(name) {
	        var val = this.variables[name];
	        if(val !== undefined) {
	            return val;
	        }
	        return null;
	    },

	    lookup: function(name) {
	        var p = this.parent;
	        var val = this.variables[name];
	        if(val !== undefined) {
	            return val;
	        }
	        return p && p.lookup(name);
	    },

	    resolve: function(name, forWrite) {
	        var p = (forWrite && this.isolateWrites) ? undefined : this.parent;
	        var val = this.variables[name];
	        if(val !== undefined) {
	            return this;
	        }
	        return p && p.resolve(name);
	    },

	    push: function(isolateWrites) {
	        return new Frame(this, isolateWrites);
	    },

	    pop: function() {
	        return this.parent;
	    }
	});

	function makeMacro(argNames, kwargNames, func) {
	    return function() {
	        var argCount = numArgs(arguments);
	        var args;
	        var kwargs = getKeywordArgs(arguments);
	        var i;

	        if(argCount > argNames.length) {
	            args = Array.prototype.slice.call(arguments, 0, argNames.length);

	            // Positional arguments that should be passed in as
	            // keyword arguments (essentially default values)
	            var vals = Array.prototype.slice.call(arguments, args.length, argCount);
	            for(i = 0; i < vals.length; i++) {
	                if(i < kwargNames.length) {
	                    kwargs[kwargNames[i]] = vals[i];
	                }
	            }

	            args.push(kwargs);
	        }
	        else if(argCount < argNames.length) {
	            args = Array.prototype.slice.call(arguments, 0, argCount);

	            for(i = argCount; i < argNames.length; i++) {
	                var arg = argNames[i];

	                // Keyword arguments that should be passed as
	                // positional arguments, i.e. the caller explicitly
	                // used the name of a positional arg
	                args.push(kwargs[arg]);
	                delete kwargs[arg];
	            }

	            args.push(kwargs);
	        }
	        else {
	            args = arguments;
	        }

	        return func.apply(this, args);
	    };
	}

	function makeKeywordArgs(obj) {
	    obj.__keywords = true;
	    return obj;
	}

	function getKeywordArgs(args) {
	    var len = args.length;
	    if(len) {
	        var lastArg = args[len - 1];
	        if(lastArg && lastArg.hasOwnProperty('__keywords')) {
	            return lastArg;
	        }
	    }
	    return {};
	}

	function numArgs(args) {
	    var len = args.length;
	    if(len === 0) {
	        return 0;
	    }

	    var lastArg = args[len - 1];
	    if(lastArg && lastArg.hasOwnProperty('__keywords')) {
	        return len - 1;
	    }
	    else {
	        return len;
	    }
	}

	// A SafeString object indicates that the string should not be
	// autoescaped. This happens magically because autoescaping only
	// occurs on primitive string objects.
	function SafeString(val) {
	    if(typeof val !== 'string') {
	        return val;
	    }

	    this.val = val;
	    this.length = val.length;
	}

	SafeString.prototype = Object.create(String.prototype, {
	    length: { writable: true, configurable: true, value: 0 }
	});
	SafeString.prototype.valueOf = function() {
	    return this.val;
	};
	SafeString.prototype.toString = function() {
	    return this.val;
	};

	function copySafeness(dest, target) {
	    if(dest instanceof SafeString) {
	        return new SafeString(target);
	    }
	    return target.toString();
	}

	function markSafe(val) {
	    var type = typeof val;

	    if(type === 'string') {
	        return new SafeString(val);
	    }
	    else if(type !== 'function') {
	        return val;
	    }
	    else {
	        return function() {
	            var ret = val.apply(this, arguments);

	            if(typeof ret === 'string') {
	                return new SafeString(ret);
	            }

	            return ret;
	        };
	    }
	}

	function suppressValue(val, autoescape) {
	    val = (val !== undefined && val !== null) ? val : '';

	    if(autoescape && !(val instanceof SafeString)) {
	        val = lib.escape(val.toString());
	    }

	    return val;
	}

	function ensureDefined(val, lineno, colno) {
	    if(val === null || val === undefined) {
	        throw new lib.TemplateError(
	            'attempted to output null or undefined value',
	            lineno + 1,
	            colno + 1
	        );
	    }
	    return val;
	}

	function memberLookup(obj, val) {
	    obj = obj || {};

	    if(typeof obj[val] === 'function') {
	        return function() {
	            return obj[val].apply(obj, arguments);
	        };
	    }

	    return obj[val];
	}

	function callWrap(obj, name, context, args) {
	    if(!obj) {
	        throw new Error('Unable to call `' + name + '`, which is undefined or falsey');
	    }
	    else if(typeof obj !== 'function') {
	        throw new Error('Unable to call `' + name + '`, which is not a function');
	    }

	    // jshint validthis: true
	    return obj.apply(context, args);
	}

	function contextOrFrameLookup(context, frame, name) {
	    var val = frame.lookup(name);
	    return (val !== undefined) ?
	        val :
	        context.lookup(name);
	}

	function handleError(error, lineno, colno) {
	    if(error.lineno) {
	        return error;
	    }
	    else {
	        return new lib.TemplateError(error, lineno, colno);
	    }
	}

	function asyncEach(arr, dimen, iter, cb) {
	    if(lib.isArray(arr)) {
	        var len = arr.length;

	        lib.asyncIter(arr, function(item, i, next) {
	            switch(dimen) {
	            case 1: iter(item, i, len, next); break;
	            case 2: iter(item[0], item[1], i, len, next); break;
	            case 3: iter(item[0], item[1], item[2], i, len, next); break;
	            default:
	                item.push(i, next);
	                iter.apply(this, item);
	            }
	        }, cb);
	    }
	    else {
	        lib.asyncFor(arr, function(key, val, i, len, next) {
	            iter(key, val, i, len, next);
	        }, cb);
	    }
	}

	function asyncAll(arr, dimen, func, cb) {
	    var finished = 0;
	    var len, i;
	    var outputArr;

	    function done(i, output) {
	        finished++;
	        outputArr[i] = output;

	        if(finished === len) {
	            cb(null, outputArr.join(''));
	        }
	    }

	    if(lib.isArray(arr)) {
	        len = arr.length;
	        outputArr = new Array(len);

	        if(len === 0) {
	            cb(null, '');
	        }
	        else {
	            for(i = 0; i < arr.length; i++) {
	                var item = arr[i];

	                switch(dimen) {
	                case 1: func(item, i, len, done); break;
	                case 2: func(item[0], item[1], i, len, done); break;
	                case 3: func(item[0], item[1], item[2], i, len, done); break;
	                default:
	                    item.push(i, done);
	                    // jshint validthis: true
	                    func.apply(this, item);
	                }
	            }
	        }
	    }
	    else {
	        var keys = lib.keys(arr);
	        len = keys.length;
	        outputArr = new Array(len);

	        if(len === 0) {
	            cb(null, '');
	        }
	        else {
	            for(i = 0; i < keys.length; i++) {
	                var k = keys[i];
	                func(k, arr[k], i, len, done);
	            }
	        }
	    }
	}

	module.exports = {
	    Frame: Frame,
	    makeMacro: makeMacro,
	    makeKeywordArgs: makeKeywordArgs,
	    numArgs: numArgs,
	    suppressValue: suppressValue,
	    ensureDefined: ensureDefined,
	    memberLookup: memberLookup,
	    contextOrFrameLookup: contextOrFrameLookup,
	    callWrap: callWrap,
	    handleError: handleError,
	    isArray: lib.isArray,
	    keys: lib.keys,
	    SafeString: SafeString,
	    copySafeness: copySafeness,
	    markSafe: markSafe,
	    asyncEach: asyncEach,
	    asyncAll: asyncAll,
	    inOperator: lib.inOperator
	};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';

	function cycler(items) {
	    var index = -1;

	    return {
	        current: null,
	        reset: function() {
	            index = -1;
	            this.current = null;
	        },

	        next: function() {
	            index++;
	            if(index >= items.length) {
	                index = 0;
	            }

	            this.current = items[index];
	            return this.current;
	        },
	    };

	}

	function joiner(sep) {
	    sep = sep || ',';
	    var first = true;

	    return function() {
	        var val = first ? '' : sep;
	        first = false;
	        return val;
	    };
	}

	// Making this a function instead so it returns a new object
	// each time it's called. That way, if something like an environment
	// uses it, they will each have their own copy.
	function globals() {
	    return {
	        range: function(start, stop, step) {
	            if(typeof stop === 'undefined') {
	                stop = start;
	                start = 0;
	                step = 1;
	            }
	            else if(!step) {
	                step = 1;
	            }

	            var arr = [];
	            var i;
	            if (step > 0) {
	                for (i=start; i<stop; i+=step) {
	                    arr.push(i);
	                }
	            } else {
	                for (i=start; i>stop; i+=step) {
	                    arr.push(i);
	                }
	            }
	            return arr;
	        },

	        // lipsum: function(n, html, min, max) {
	        // },

	        cycler: function() {
	            return cycler(Array.prototype.slice.call(arguments));
	        },

	        joiner: function(sep) {
	            return joiner(sep);
	        }
	    };
	}

	module.exports = globals;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(setImmediate, process) {// MIT license (by Elan Shanker).
	(function(globals) {
	  'use strict';

	  var executeSync = function(){
	    var args = Array.prototype.slice.call(arguments);
	    if (typeof args[0] === 'function'){
	      args[0].apply(null, args.splice(1));
	    }
	  };

	  var executeAsync = function(fn){
	    if (typeof setImmediate === 'function') {
	      setImmediate(fn);
	    } else if (typeof process !== 'undefined' && process.nextTick) {
	      process.nextTick(fn);
	    } else {
	      setTimeout(fn, 0);
	    }
	  };

	  var makeIterator = function (tasks) {
	    var makeCallback = function (index) {
	      var fn = function () {
	        if (tasks.length) {
	          tasks[index].apply(null, arguments);
	        }
	        return fn.next();
	      };
	      fn.next = function () {
	        return (index < tasks.length - 1) ? makeCallback(index + 1): null;
	      };
	      return fn;
	    };
	    return makeCallback(0);
	  };
	  
	  var _isArray = Array.isArray || function(maybeArray){
	    return Object.prototype.toString.call(maybeArray) === '[object Array]';
	  };

	  var waterfall = function (tasks, callback, forceAsync) {
	    var nextTick = forceAsync ? executeAsync : executeSync;
	    callback = callback || function () {};
	    if (!_isArray(tasks)) {
	      var err = new Error('First argument to waterfall must be an array of functions');
	      return callback(err);
	    }
	    if (!tasks.length) {
	      return callback();
	    }
	    var wrapIterator = function (iterator) {
	      return function (err) {
	        if (err) {
	          callback.apply(null, arguments);
	          callback = function () {};
	        } else {
	          var args = Array.prototype.slice.call(arguments, 1);
	          var next = iterator.next();
	          if (next) {
	            args.push(wrapIterator(next));
	          } else {
	            args.push(callback);
	          }
	          nextTick(function () {
	            iterator.apply(null, args);
	          });
	        }
	      };
	    };
	    wrapIterator(makeIterator(tasks))();
	  };

	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return waterfall;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // RequireJS
	  } else if (typeof module !== 'undefined' && module.exports) {
	    module.exports = waterfall; // CommonJS
	  } else {
	    globals.waterfall = waterfall; // <script>
	  }
	})(this);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11).setImmediate, __webpack_require__(13)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;

	// DOM APIs, for completeness

	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};

	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};

	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};

	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};

	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);

	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};

	// setimmediate attaches itself to the global object
	__webpack_require__(12);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";

	    if (global.setImmediate) {
	        return;
	    }

	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;

	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }

	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }

	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }

	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }

	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }

	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }

	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };

	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }

	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }

	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };

	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }

	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }

	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }

	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();

	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();

	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();

	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();

	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }

	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(13)))

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var Loader = __webpack_require__(15);

	var PrecompiledLoader = Loader.extend({
	    init: function(compiledTemplates) {
	        this.precompiled = compiledTemplates || {};
	    },

	    getSource: function(name) {
	        if (this.precompiled[name]) {
	            return {
	                src: { type: 'code',
	                       obj: this.precompiled[name] },
	                path: name
	            };
	        }
	        return null;
	    }
	});

	module.exports = PrecompiledLoader;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var path = __webpack_require__(3);
	var Obj = __webpack_require__(6);
	var lib = __webpack_require__(1);

	var Loader = Obj.extend({
	    on: function(name, func) {
	        this.listeners = this.listeners || {};
	        this.listeners[name] = this.listeners[name] || [];
	        this.listeners[name].push(func);
	    },

	    emit: function(name /*, arg1, arg2, ...*/) {
	        var args = Array.prototype.slice.call(arguments, 1);

	        if(this.listeners && this.listeners[name]) {
	            lib.each(this.listeners[name], function(listener) {
	                listener.apply(null, args);
	            });
	        }
	    },

	    resolve: function(from, to) {
	        return path.resolve(path.dirname(from), to);
	    },

	    isRelative: function(filename) {
	        return (filename.indexOf('./') === 0 || filename.indexOf('../') === 0);
	    }
	});

	module.exports = Loader;


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	function installCompat() {
	    'use strict';

	    // This must be called like `nunjucks.installCompat` so that `this`
	    // references the nunjucks instance
	    var runtime = this.runtime; // jshint ignore:line
	    var lib = this.lib; // jshint ignore:line
	    var Compiler = this.compiler.Compiler; // jshint ignore:line
	    var Parser = this.parser.Parser; // jshint ignore:line
	    var nodes = this.nodes; // jshint ignore:line
	    var lexer = this.lexer; // jshint ignore:line

	    var orig_contextOrFrameLookup = runtime.contextOrFrameLookup;
	    var orig_Compiler_assertType = Compiler.prototype.assertType;
	    var orig_Parser_parseAggregate = Parser.prototype.parseAggregate;
	    var orig_memberLookup = runtime.memberLookup;

	    function uninstall() {
	        runtime.contextOrFrameLookup = orig_contextOrFrameLookup;
	        Compiler.prototype.assertType = orig_Compiler_assertType;
	        Parser.prototype.parseAggregate = orig_Parser_parseAggregate;
	        runtime.memberLookup = orig_memberLookup;
	    }

	    runtime.contextOrFrameLookup = function(context, frame, key) {
	        var val = orig_contextOrFrameLookup.apply(this, arguments);
	        if (val === undefined) {
	            switch (key) {
	            case 'True':
	                return true;
	            case 'False':
	                return false;
	            case 'None':
	                return null;
	            }
	        }

	        return val;
	    };

	    var Slice = nodes.Node.extend('Slice', {
	        fields: ['start', 'stop', 'step'],
	        init: function(lineno, colno, start, stop, step) {
	            start = start || new nodes.Literal(lineno, colno, null);
	            stop = stop || new nodes.Literal(lineno, colno, null);
	            step = step || new nodes.Literal(lineno, colno, 1);
	            this.parent(lineno, colno, start, stop, step);
	        }
	    });

	    Compiler.prototype.assertType = function(node) {
	        if (node instanceof Slice) {
	            return;
	        }
	        return orig_Compiler_assertType.apply(this, arguments);
	    };
	    Compiler.prototype.compileSlice = function(node, frame) {
	        this.emit('(');
	        this._compileExpression(node.start, frame);
	        this.emit('),(');
	        this._compileExpression(node.stop, frame);
	        this.emit('),(');
	        this._compileExpression(node.step, frame);
	        this.emit(')');
	    };

	    function getTokensState(tokens) {
	        return {
	            index: tokens.index,
	            lineno: tokens.lineno,
	            colno: tokens.colno
	        };
	    }

	    Parser.prototype.parseAggregate = function() {
	        var self = this;
	        var origState = getTokensState(this.tokens);
	        // Set back one accounting for opening bracket/parens
	        origState.colno--;
	        origState.index--;
	        try {
	            return orig_Parser_parseAggregate.apply(this);
	        } catch(e) {
	            var errState = getTokensState(this.tokens);
	            var rethrow = function() {
	                lib.extend(self.tokens, errState);
	                return e;
	            };

	            // Reset to state before original parseAggregate called
	            lib.extend(this.tokens, origState);
	            this.peeked = false;

	            var tok = this.peekToken();
	            if (tok.type !== lexer.TOKEN_LEFT_BRACKET) {
	                throw rethrow();
	            } else {
	                this.nextToken();
	            }

	            var node = new Slice(tok.lineno, tok.colno);

	            // If we don't encounter a colon while parsing, this is not a slice,
	            // so re-raise the original exception.
	            var isSlice = false;

	            for (var i = 0; i <= node.fields.length; i++) {
	                if (this.skip(lexer.TOKEN_RIGHT_BRACKET)) {
	                    break;
	                }
	                if (i === node.fields.length) {
	                    if (isSlice) {
	                        this.fail('parseSlice: too many slice components', tok.lineno, tok.colno);
	                    } else {
	                        break;
	                    }
	                }
	                if (this.skip(lexer.TOKEN_COLON)) {
	                    isSlice = true;
	                } else {
	                    var field = node.fields[i];
	                    node[field] = this.parseExpression();
	                    isSlice = this.skip(lexer.TOKEN_COLON) || isSlice;
	                }
	            }
	            if (!isSlice) {
	                throw rethrow();
	            }
	            return new nodes.Array(tok.lineno, tok.colno, [node]);
	        }
	    };

	    function sliceLookup(obj, start, stop, step) {
	        obj = obj || [];
	        if (start === null) {
	            start = (step < 0) ? (obj.length - 1) : 0;
	        }
	        if (stop === null) {
	            stop = (step < 0) ? -1 : obj.length;
	        } else {
	            if (stop < 0) {
	                stop += obj.length;
	            }
	        }

	        if (start < 0) {
	            start += obj.length;
	        }

	        var results = [];

	        for (var i = start; ; i += step) {
	            if (i < 0 || i > obj.length) {
	                break;
	            }
	            if (step > 0 && i >= stop) {
	                break;
	            }
	            if (step < 0 && i <= stop) {
	                break;
	            }
	            results.push(runtime.memberLookup(obj, i));
	        }
	        return results;
	    }

	    var ARRAY_MEMBERS = {
	        pop: function(index) {
	            if (index === undefined) {
	                return this.pop();
	            }
	            if (index >= this.length || index < 0) {
	                throw new Error('KeyError');
	            }
	            return this.splice(index, 1);
	        },
	        append: function(element) {
	                return this.push(element);
	        },
	        remove: function(element) {
	            for (var i = 0; i < this.length; i++) {
	                if (this[i] === element) {
	                    return this.splice(i, 1);
	                }
	            }
	            throw new Error('ValueError');
	        },
	        count: function(element) {
	            var count = 0;
	            for (var i = 0; i < this.length; i++) {
	                if (this[i] === element) {
	                    count++;
	                }
	            }
	            return count;
	        },
	        index: function(element) {
	            var i;
	            if ((i = this.indexOf(element)) === -1) {
	                throw new Error('ValueError');
	            }
	            return i;
	        },
	        find: function(element) {
	            return this.indexOf(element);
	        },
	        insert: function(index, elem) {
	            return this.splice(index, 0, elem);
	        }
	    };
	    var OBJECT_MEMBERS = {
	        items: function() {
	            var ret = [];
	            for(var k in this) {
	                ret.push([k, this[k]]);
	            }
	            return ret;
	        },
	        values: function() {
	            var ret = [];
	            for(var k in this) {
	                ret.push(this[k]);
	            }
	            return ret;
	        },
	        keys: function() {
	            var ret = [];
	            for(var k in this) {
	                ret.push(k);
	            }
	            return ret;
	        },
	        get: function(key, def) {
	            var output = this[key];
	            if (output === undefined) {
	                output = def;
	            }
	            return output;
	        },
	        has_key: function(key) {
	            return this.hasOwnProperty(key);
	        },
	        pop: function(key, def) {
	            var output = this[key];
	            if (output === undefined && def !== undefined) {
	                output = def;
	            } else if (output === undefined) {
	                throw new Error('KeyError');
	            } else {
	                delete this[key];
	            }
	            return output;
	        },
	        popitem: function() {
	            for (var k in this) {
	                // Return the first object pair.
	                var val = this[k];
	                delete this[k];
	                return [k, val];
	            }
	            throw new Error('KeyError');
	        },
	        setdefault: function(key, def) {
	            if (key in this) {
	                return this[key];
	            }
	            if (def === undefined) {
	                def = null;
	            }
	            return this[key] = def;
	        },
	        update: function(kwargs) {
	            for (var k in kwargs) {
	                this[k] = kwargs[k];
	            }
	            return null;    // Always returns None
	        }
	    };
	    OBJECT_MEMBERS.iteritems = OBJECT_MEMBERS.items;
	    OBJECT_MEMBERS.itervalues = OBJECT_MEMBERS.values;
	    OBJECT_MEMBERS.iterkeys = OBJECT_MEMBERS.keys;
	    runtime.memberLookup = function(obj, val, autoescape) { // jshint ignore:line
	        if (arguments.length === 4) {
	            return sliceLookup.apply(this, arguments);
	        }
	        obj = obj || {};

	        // If the object is an object, return any of the methods that Python would
	        // otherwise provide.
	        if (lib.isArray(obj) && ARRAY_MEMBERS.hasOwnProperty(val)) {
	            return function() {return ARRAY_MEMBERS[val].apply(obj, arguments);};
	        }

	        if (lib.isObject(obj) && OBJECT_MEMBERS.hasOwnProperty(val)) {
	            return function() {return OBJECT_MEMBERS[val].apply(obj, arguments);};
	        }

	        return orig_memberLookup.apply(this, arguments);
	    };

	    return uninstall;
	}

	module.exports = installCompat;


/***/ })
/******/ ])
});
;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/timers-browserify/main.js").setImmediate, __webpack_require__("./node_modules/timers-browserify/main.js").clearImmediate))

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDOMServer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDefaultInjection = __webpack_require__("./node_modules/react-dom/lib/ReactDefaultInjection.js");
var ReactServerRendering = __webpack_require__("./node_modules/react-dom/lib/ReactServerRendering.js");
var ReactVersion = __webpack_require__("./node_modules/react-dom/lib/ReactVersion.js");

ReactDefaultInjection.inject();

var ReactDOMServer = {
  renderToString: ReactServerRendering.renderToString,
  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
  version: ReactVersion
};

module.exports = ReactDOMServer;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactServerBatchingStrategy.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactServerBatchingStrategy = {
  isBatchingUpdates: false,
  batchedUpdates: function (callback) {
    // Don't do anything here. During the server rendering we don't want to
    // schedule any updates. We will simply ignore them.
  }
};

module.exports = ReactServerBatchingStrategy;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactServerRendering.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var React = __webpack_require__("./node_modules/react/lib/React.js");
var ReactDOMContainerInfo = __webpack_require__("./node_modules/react-dom/lib/ReactDOMContainerInfo.js");
var ReactDefaultBatchingStrategy = __webpack_require__("./node_modules/react-dom/lib/ReactDefaultBatchingStrategy.js");
var ReactInstrumentation = __webpack_require__("./node_modules/react-dom/lib/ReactInstrumentation.js");
var ReactMarkupChecksum = __webpack_require__("./node_modules/react-dom/lib/ReactMarkupChecksum.js");
var ReactReconciler = __webpack_require__("./node_modules/react-dom/lib/ReactReconciler.js");
var ReactServerBatchingStrategy = __webpack_require__("./node_modules/react-dom/lib/ReactServerBatchingStrategy.js");
var ReactServerRenderingTransaction = __webpack_require__("./node_modules/react-dom/lib/ReactServerRenderingTransaction.js");
var ReactUpdates = __webpack_require__("./node_modules/react-dom/lib/ReactUpdates.js");

var emptyObject = __webpack_require__("./node_modules/fbjs/lib/emptyObject.js");
var instantiateReactComponent = __webpack_require__("./node_modules/react-dom/lib/instantiateReactComponent.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

var pendingTransactions = 0;

/**
 * @param {ReactElement} element
 * @return {string} the HTML markup
 */
function renderToStringImpl(element, makeStaticMarkup) {
  var transaction;
  try {
    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);

    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);

    pendingTransactions++;

    return transaction.perform(function () {
      var componentInstance = instantiateReactComponent(element, true);
      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
      );
      if (false) {
        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
      }
      if (!makeStaticMarkup) {
        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
      }
      return markup;
    }, null);
  } finally {
    pendingTransactions--;
    ReactServerRenderingTransaction.release(transaction);
    // Revert to the DOM batching strategy since these two renderers
    // currently share these stateful modules.
    if (!pendingTransactions) {
      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
    }
  }
}

/**
 * Render a ReactElement to its initial HTML. This should only be used on the
 * server.
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
 */
function renderToString(element) {
  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
  return renderToStringImpl(element, false);
}

/**
 * Similar to renderToString, except this doesn't create extra DOM attributes
 * such as data-react-id that React uses internally.
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
 */
function renderToStaticMarkup(element) {
  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
  return renderToStringImpl(element, true);
}

module.exports = {
  renderToString: renderToString,
  renderToStaticMarkup: renderToStaticMarkup
};

/***/ }),

/***/ "./node_modules/react-dom/server.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__("./node_modules/react-dom/lib/ReactDOMServer.js");


/***/ }),

/***/ "./node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/react-spin/lib/main.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _spin = __webpack_require__("./node_modules/spin.js/spin.js");

var _spin2 = _interopRequireDefault(_spin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ReactSpinner = _react2.default.createClass({
  displayName: 'ReactSpinner',

  propTypes: {
    config: _react2.default.PropTypes.object,
    stopped: _react2.default.PropTypes.bool
  },

  componentDidMount: function componentDidMount() {
    this.spinner = new _spin2.default(this.props.config);
    if (!this.props.stopped) {
      this.spinner.spin(this.refs.container);
    }
  },

  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
    if (newProps.stopped === true && !this.props.stopped) {
      this.spinner.stop();
    } else if (!newProps.stopped && this.props.stopped === true) {
      this.spinner.spin(this.refs.container);
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    this.spinner.stop();
  },

  render: function render() {
    return _react2.default.createElement('span', { ref: 'container' });
  }
});

exports.default = ReactSpinner;

/***/ }),

/***/ "./node_modules/timers-browserify/main.js":
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__("./node_modules/setimmediate/setImmediate.js");
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),

/***/ "multi ./enso_cms/static/enso-cms/js/main.js ./enso_cms/static/enso-cms/js/publish.js ./enso_cms/static/enso-cms/js/wysiwyg.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./enso_cms/static/enso-cms/js/main.js");
__webpack_require__("./enso_cms/static/enso-cms/js/publish.js");
module.exports = __webpack_require__("./enso_cms/static/enso-cms/js/wysiwyg.js");


/***/ })

},["multi ./enso_cms/static/enso-cms/js/main.js ./enso_cms/static/enso-cms/js/publish.js ./enso_cms/static/enso-cms/js/wysiwyg.js"]);


// WEBPACK FOOTER //
// main.bundle.c2f8e2d8e38cdd9ffc6e.js